<template>
 <!-- v-show="!loading" -->
    <div class="indexCon">
        <loading :show-loading="showLoading" />
        <div class="pc" :class="{'ie-pc':isIe}">
            <registerPop :registerPop="registerPop" @registerPopClose="registerPopClose" @goRegister="goRegister"></registerPop>
            <!--侧边导航-->
            <div class="nav-list">
                <div class="left-button" v-if="liveStatus=='middle'"><img src="@/assets/newImages/common/play-icon.png" alt=""><p>直播中</p></div>
                <ul class="nav-line">
                    <li class="nav-line-item" @click="goSlide('/home', '首页')">
                        <div class="nav-line-item-one" :class=" slideHash === '/home' ? 'nav-line-item-one-active' :''"><p>首页</p><div class="line"></div></div>
                    </li>
                    <li class="nav-line-item" v-if="showNavAgendaDesc" @click="goSlide('/desc', '大会介绍')">
                        <div class="nav-line-item-one" :class=" slideHash === '/desc' ? 'nav-line-item-one-active' :''"><p>大会介绍</p><div class="line"></div></div>
                    </li>
                    <li class="nav-line-item" v-if="showNavAgendaList" @click="goSlide('/agenda', '大会议程')">
                        <div class="nav-line-item-one" :class=" slideHash === '/agenda' ? 'nav-line-item-one-active' :''"><p>大会议程</p><div class="line"></div></div>
                    </li>
                    <li class="nav-line-item" v-if="showNavGuest" @click="goSlide('/guest', '重磅嘉宾')">
                        <div class="nav-line-item-one" :class=" slideHash === '/guest' ? 'nav-line-item-one-active' :''"><p>重磅嘉宾</p><div class="line"></div></div>
                    </li>
                    <li class="nav-line-item" v-if="showNavHall" @click="goSlide('/exhibition', '展厅导览')">
                        <div class="nav-line-item-one" :class=" slideHash === '/exhibition' ? 'nav-line-item-one-active' :''"><p>展厅导览</p><div class="line"></div></div>
                    </li>
                    <li class="nav-line-item" v-if="showNavNews" @click="goSlide('/news', '热门资讯')">
                        <div class="nav-line-item-one" :class=" slideHash === '/news' ? 'nav-line-item-one-active' :''"><p>热门资讯</p><div class="line"></div></div>
                    </li>
                    <li class="nav-line-item" v-if="showNavPartner" @click="goSlide('/partner', '生态伙伴')">
                        <div class="nav-line-item-one" :class=" slideHash === '/partner' ? 'nav-line-item-one-active' :''"><p>生态伙伴</p><div class="line"></div></div>
                    </li>
                    <li class="nav-line-item" v-if="showNavPic" @click="goSlide('/wonderfulPic', '精彩图集')">
                        <div class="nav-line-item-one" :class=" slideHash === '/wonderfulPic' ? 'nav-line-item-one-active' :''"><p>精彩图集</p><div class="line"></div></div>
                    </li>
                    <li class="nav-line-item" v-if="showNavWords" @click="goSlide('/wonderfulWords', '大咖观点')">
                        <div class="nav-line-item-one" :class=" slideHash === '/wonderfulWords' ? 'nav-line-item-one-active' :''"><p>大咖观点</p><div class="line"></div></div>
                    </li>
                    <li class="nav-line-item" v-if="showNavVideo" @click="goSlide('/video', '精彩视频')">
                        <div class="nav-line-item-one" :class=" slideHash === '/video' ? 'nav-line-item-one-active' :''"><p>精彩视频</p><div class="line"></div></div>
                    </li>
                    <li class="nav-line-item" v-if="showNavDownload" @click="goSlide('/files', '资料中心')">
                        <div class="nav-line-item-one" :class=" slideHash === '/files' ? 'nav-line-item-one-active' :''"><p>资料中心</p><div class="line"></div></div>
                    </li>
                    <li class="nav-line-item" @click="goSlide('/guide', '参会指南')">
                        <div class="nav-line-item-one" :class=" slideHash === '/guide' ? 'nav-line-item-one-active' :''"><p>参会指南</p><div class="line"></div></div>
                    </li>
                    
                </ul>
            </div>
            <!-- Swiper -->
            <div class="swiper-container swiper-page" >
                <div class="swiper-wrapper">
                    <div class="swiper-slide" id="/home">
                        <div class="con-page1" v-if="liveStatus=='before'">
                            <div class="con-1200 margin-l-r-auto">
                                <div class="text">{{page1Text}}　{{page1Address}}</div>
                                <!-- 都报名成功 -->
                                <div class="button button-div" v-if="orderOffline==1">
                                    <button class="button1" @click="signUp()">查看参会二维码</button>
                                </div>
                                <div class="button button-div" v-if="orderOffline!=1&&isStudent&&!orderStop">
                                    <button class="button2" v-if="orderOnline==0" @click="orderLive()">预约直播</button>
                                    <button class="button2" v-if="orderOnline==1" @click="orderLive()">已预约直播</button>
                                </div>
                                <div class="button" v-if="orderOffline!=1&&!isStudent&&!orderStop">
                                    <button class="button2" v-if="orderOnline==0" @click="orderLive()">预约直播</button>
                                    <button class="button2" v-if="orderOnline==1" @click="orderLive()">已预约直播</button>
                                    <button class="button1" v-if="orderOffline==0&&!isStudent" @click="signUp()">参会报名</button>
                                    <button class="button1" v-if="orderOffline==2" @click="signUp()">线下参会审核中</button>
                                </div>
                                <div class="button button-div" v-if="orderOffline!=1&&orderStop">
                                    <button class="button2" v-if="orderOnline==0" @click="orderLive()">预约直播</button>
                                    <button class="button2" v-if="orderOnline==1" @click="orderLive()">已预约直播</button>
                                </div>
                                <div class="page1-bottom"><img src="@/assets/newImages/common/line.gif" alt=""></div>
                            </div>
                        </div>
                        <div class="con-page1-live" v-if="liveStatus!='before'&&liveLists.length>0">
                            <div class="bg-img1"><img src="@/assets/newImages/home/live/bg-img1.png" alt=""></div>
                            <div class="bg-img2"><img src="@/assets/newImages/home/live/bg-img2.png" alt=""></div>
                            <div class="bg-img3"><img src="@/assets/newImages/home/live/bg-img3.png" alt=""></div>
                            <div class="con-1200">
                                <div class="live-left">
                                    <div class="left-title">
                                        <div class="one-left">
                                            <img src="@/assets/newImages/home/live-icon.png" alt="">
                                            <p v-if="liveStatus=='middle'">正在直播：{{mainLiveTitle}}</p>
                                            <p v-if="liveStatus=='after'">{{mainLiveTitle}}</p>
                                        </div>
                                        <div class="one-right" @click="clickMainLive()">进入直播间参与更多互动</div>
                                    </div>
                                    <!--<div class="left-video">
                                        <video :src="mainLiveUrl" controls></video>
                                    </div>-->
                                    <iframe v-if="isPc" class="left-video"
                                        allow="camera *;microphone *;"
                                        border="0"
                                        allowfullscreen="true"
                                        :src="mainLiveIframeUrl">
                                    </iframe>
                                </div>
                                <div class="live-right">
                                    <div class="live-right-top">
                                        <div class="img"><img src="@/assets/newImages/home/live-eco.png" alt=""></div>
                                        <div class="text-div">
                                            <div class="text-date" :class="{'text-active':liveIndex==index}" v-for="(item,index) in liveLists" :key="index" @click="chooseLiveDate(index)">
                                                <p>{{item.name}}</p><span class="line"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="live-right-lists">
                                        <div class="live-right-lists-one" v-for="(lists,num) in liveLists[liveIndex].content" :key="num" :class="{'live-right-lists-active':num==liveLists[liveIndex].showList}">
                                            <div class="right-title" @click="chooseLiveListIndex(num)">
                                                <div class="title-left">
                                                    <p v-if="lists.name!='Σco·Live'">{{lists.name}}</p>
                                                    <div v-if="lists.name=='Σco·Live'&&num==liveLists[liveIndex].showList" class="img"><img src="@/assets/newImages/home/live/pc-live.svg" alt=""></div>
                                                    <div v-if="lists.name=='Σco·Live'&&num!=liveLists[liveIndex].showList" class="img"><img src="@/assets/newImages/home/live/pc-live-black.svg" alt=""></div>
                                                    <div v-if="lists.name=='Σco·Live'" class="list-img" style="margin-left:5px;margin-bottom: -2px;">
                                                        <div class="img1" @click.stop="clickMainLive()" v-if="lists.vhallStatus==0"><img src="@/assets/newImages/home/live/live-img2.png" alt=""></div>
                                                        <div class="img1" @click.stop="clickMainLive()" v-if="lists.vhallStatus==1"><img src="@/assets/newImages/home/live/live-img1.png" alt=""></div>
                                                        <div class="img1" @click.stop="clickMainLive()" v-if="lists.vhallStatus==2"><img src="@/assets/newImages/home/live/live-img3.png" alt=""></div>
                                                        <div class="img1" @click.stop="clickMainLive()" v-if="lists.vhallStatus==3"><img src="@/assets/newImages/home/live/live-img4.png" alt=""></div>
                                                    </div>
                                                    <span class="left-right"></span>
                                                </div>
                                                <div class="title-img"><img src="@/assets/newImages/parnter/title-icon2.png" alt=""></div>
                                            </div>
                                            <div class="right-list">
                                                <div class="right-list-scroll" v-on:mouseenter="disableMouseWheel()" v-on:mouseleave="enableMouseWheel()">
                                                    <div class="right-list-one" v-for="(item,num2) in lists.child" :key="num2" :class="{'right-list-one-active':liveLeftIndex==item.id}" @click="clickLive(item)">
                                                        <div class="list-one-top">
                                                            <div class="time">{{item.startTime_h_m}}-{{item.endTime_h_m}}</div>
                                                            <div class="list-img">
                                                                <div class="img1" v-if="item.vhallStatus==0"><img src="@/assets/newImages/home/live/live-img2.png" alt=""></div>
                                                                <div class="img1" v-if="item.vhallStatus==1"><img src="@/assets/newImages/home/live/live-img1.png" alt=""></div>
                                                                <div class="img1" v-if="item.vhallStatus==2"><img src="@/assets/newImages/home/live/live-img3.png" alt=""></div>
                                                                <div class="img1" v-if="item.vhallStatus==3"><img src="@/assets/newImages/home/live/live-img4.png" alt=""></div>
                                                            </div>
                                                        </div>
                                                        <div class="list-one-title">{{item.name}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide" v-if="showNavAgendaDesc" id="/desc"><div class="con-page2">
                        <div class="bg-img"><img src="@/assets/newImages/home/page2-right-bg.png" alt=""></div>
                        <div class="con-1200">
                            <div class="con-title"><p>大会介绍</p></div>
                            <div class="image"><img src="../assets/newImages/home/page2-img1.jpg"></div>
                            <div class="rich-text" v-on:mouseenter="disableMouseWheel()" v-on:mouseleave="enableMouseWheel()">
                                <p>站在数字时代的新起点，我们看到，数字化转型的趋势性价值与机会空间无比广阔，正化作时代的最强光指引千行百业穿越迷雾。</p>
                                <p>迎接更深层的转型新局，我们发现，唯有能力共进、持续深耕、全面协同，才能在众多不确定性的挑战中，创造更多确定性价值！</p>
                                <p style="margin-top:1.66vh;">“因聚而生，有能有为”，华为中国生态大会2021，期待与每一位有能力、有抱负的生态伙伴一起，合力相融，能力共进，释放更大生态潜能，在时代新局下共育新机，共赢价值，共享繁荣！</p>
                                <p style="margin-top:1.66vh;">2021年5月17日-18日，我们诚邀您相聚深圳，携手共见！</p>
                            </div>
                        </div>
                    </div></div>
                    <div class="swiper-slide" v-if="showNavAgendaList" id="/agenda"><div class="con-page3">
                        <div class="bg-img"><img src="@/assets/newImages/home/page3-right-bg.png" alt=""></div>
                        <div class="con-1200">
                            <div class="con-title"><p>大会议程</p></div>
                            <div class="agenda-content">
                                <div class="agenda-year">
                                    <div class="agenda-year-list">
                                        <div class="day-text flexCenter" v-for="(item, key) in agendaYearDay" :key="key" :class="dayIndex === key ? 'day-text-active':''" @click="chooseDay(key)">
                                            <p>{{item.day}}</p><p>DAY{{key+1}}</p>
                                        </div>
                                    </div>
                                    <div class="year-text"><p>2021</p><p>YEAR</p></div>
                                </div>
                                <div class="agenda-list">
                                    <div class="agenda-nav">
                                        <div class="agenda-nav-one" v-for="(item, key) in agendaDayNav" :key="key" :class="agendaDayNavOne === key ? 'agenda-nav-one-active':''" @click="chooseDayNav(key)">{{item.title}}</div>
                                    </div>
                                    <div v-if="agendaSpeechList.length==0&&agendaDayNavOne!=2">
                                        <div class="agenda-wait">敬请期待</div>
                                    </div>
                                    <div v-if="agendaSpeechList.length==0&&agendaDayNavOne==2">
                                        <div class="agenda-wait">30+精彩演讲，敬请期待</div>
                                    </div>
                                    <div v-if="agendaSpeechList.length>0">
                                        <div class="agenda-main1" v-if="agendaDayNavOne==0">
                                            <div class="agenda-image main-one-image" v-if="agendaSpeechList.length==1" style="padding: 1.875vw 0.88542vw;box-shadow:none">
                                                <div>
                                                    <div class="text-title"><span></span>主题演讲</div>
                                                    <div class="text-am"><div class="p"><p v-for="(startWord, startWordKey) in agendaTopicBar.startTimeWordArr" :key="startWordKey">{{startWord}}</p></div><span>{{agendaTopicBar.startTime_zh}}</span></div>
                                                    <div class="text-am"><div class="p"><p v-for="(endWord, endWordKey) in agendaTopicBar.endTimeWordArr" :key="endWordKey">{{endWord}}</p></div><span>{{agendaTopicBar.endTime_zh}}</span></div>
                                                </div>
                                                <div>
                                                    <p class="text-p">{{agendaTopicBar.name}}</p>
                                                    <div class="text-address"><img v-if="agendaTopicBar.hotel!=null&&agendaTopicBar.hotel!=''" src="@/assets/newImages/home/little-address.png" alt=""><span>{{agendaTopicBar.hotel}}</span></div>
                                                    <div class="main-one-image-bottom" style="margin-top: 0.83333vw;">
                                                        <!-- bottom-icon-active 收藏后的图标 -->
                                                        <div v-if="showIconCollect" @click="clickAgendaCollect()" class="bottom-icon flexCenter" :class="{'bottom-icon-active':agendaTopicBar.isOrder}">
                                                            <img src="@/assets/newImages/agenda/icon4.png" alt="">
                                                            <img src="@/assets/newImages/agenda/icon423.png" alt="">
                                                        </div>
                                                        <div v-if="showIconLive&&agendaTopicBar.m_vhallLiveId" @click="clickAgendaLive()" class="bottom-icon flexCenter">
                                                            <img src="@/assets/newImages/agenda/icon3.png" alt="">
                                                            <img src="@/assets/newImages/agenda/icon32.png" alt="">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- 跟议程二级页一致 -->
                                            <!-- <div class="main-one-image" v-if="agendaSpeechList.length==1">
                                                <div class="main-one-image-top">
                                                    <div class="title">{{agendaTopicBar.name}}</div>
                                                    <div class="time">{{agendaTopicBar.startTime}}-{{agendaTopicBar.endTime}}</div>
                                                    <div class="address"><img v-if="agendaTopicBar.hotel!=null&&agendaTopicBar.hotel!=''" src="@/assets/newImages/home/little-address.png" alt=""><span>{{agendaTopicBar.hotel}}</span></div>
                                                </div>
                                                <div class="main-one-image-bottom">
                                                    <!-- bottom-icon-active 收藏后的图标 
                                                    <div v-if="showIconCollect" @click="clickAgendaCollect()" class="bottom-icon flexCenter" :class="{'bottom-icon-active':agendaTopicBar.isOrder}">
                                                        <img src="@/assets/newImages/agenda/icon4.png" alt="">
                                                        <img src="@/assets/newImages/agenda/icon423.png" alt="">
                                                    </div>
                                                    <div v-if="showIconLive&&agendaTopicBar.i_liveurl" @click="clickAgendaLive()" class="bottom-icon flexCenter">
                                                        <img src="@/assets/newImages/agenda/icon3.png" alt="">
                                                        <img src="@/assets/newImages/agenda/icon32.png" alt="">
                                                    </div>
                                                </div>
                                            </div> -->
                                            <!-- 两个主题， main-one-image-active控制显示-->
                                            <div class="main-one-image2" v-if="agendaSpeechList.length==2">
                                                <div class="main-one-image-one " v-for="(leftItem, leftKey) in agendaSpeechList" :key="leftKey" 
                                                    :class="{'main-one-image-active':agendaThemeActive==leftKey}" @click="clickTopicAgendaLeft(leftKey)" >
                                                    <div class="image-bg1" v-if="leftKey==0"><img src="@/assets/newImages/agenda/agenda-img11.png" alt=""></div>
                                                    <div class="image-bg1" v-if="leftKey==0"><img src="@/assets/newImages/agenda/agenda-img21.png" alt=""></div>
                                                    <div class="image-bg1" v-if="leftKey==1"><img src="@/assets/newImages/agenda/agenda-img12.png" alt=""></div>
                                                    <div class="image-bg1" v-if="leftKey==1"><img src="@/assets/newImages/agenda/agenda-img22.png" alt=""></div>
                                                    <div class="main-one-image-top">
                                                        <div class="title">{{leftItem.name}}</div>
                                                        <div class="time">{{leftItem.startTime_h_m}}-{{leftItem.endTime_h_m}}</div>
                                                        <div class="address"><img v-if="leftItem.hotel!=null&&leftItem.hotel!=''" src="@/assets/newImages/home/little-address.png" alt=""><span>{{leftItem.hotel}}</span></div>
                                                    </div>
                                                    <div class="main-one-image-bottom">
                                                    <!-- bottom-icon-active 收藏后的图标 -->
                                                        <div v-if="showIconCollect" @click="clickAgendaCollect()" class="bottom-icon flexCenter" :class="{'bottom-icon-active':leftItem.isOrder}">
                                                            <img src="@/assets/newImages/agenda/icon4.png" alt="">
                                                            <img src="@/assets/newImages/agenda/icon423.png" alt="">
                                                        </div>
                                                        <div v-if="showIconLive&&leftItem.m_vhallLiveId" @click="clickAgendaLive()" class="bottom-icon flexCenter">
                                                            <img src="@/assets/newImages/agenda/icon3.png" alt="">
                                                            <img src="@/assets/newImages/agenda/icon32.png" alt="">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- -跟议程二级页一致 -->
                                            <div v-if="topicAgendaChild.length==0">
                                                <div class="agenda-child-wait flexCenter">敬请期待</div>
                                            </div>
                                            <div class="agenda-lists-main" v-if="topicAgendaChild.length>0" v-on:mouseenter="disableMouseWheel()" v-on:mouseleave="enableMouseWheel()">
                                                <div class="agendaList-one" v-for="(item, key) in topicAgendaChild" :key="key" v-on:mouseenter="setAgendaBar(item)" @click="clickAgenda(item, key)">
                                                    <p class="time">{{item.startTime_h_m}}-{{item.endTime_h_m}}</p>
                                                    <img class="line" src="@/assets/newImages/common/line.png" alt="">
                                                    <div class="title">{{item.name}}</div>
                                                    <div class="guest-div" v-if="item.guestList">
                                                        <div class="guest" v-for="(guestOne, key) in item.guestList" :key="key">
                                                            <p>{{guestOne.name}}</p>
                                                            <p v-if="guestOne.enterprise||guestOne.duty">|</p>
                                                            <p v-if="guestOne.enterprise||guestOne.duty" v-html="guestOne.fullDuty"></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="agenda-main1 agenda-main2" v-if="agendaDayNavOne==1">
                                            <div class="agenda-image">
                                                <div>
                                                    <div class="text-title"><span></span>专题演讲</div>
                                                    <div class="text-am"><div class="p"><p v-for="(startWord, startWordKey) in agendaSpecialBar.startTimeWordArr" :key="startWordKey">{{startWord}}</p></div><span>{{agendaSpecialBar.startTime_zh}}</span></div>
                                                    <div class="text-am"><div class="p"><p v-for="(endWord, endWordKey) in agendaSpecialBar.endTimeWordArr" :key="endWordKey">{{endWord}}</p></div><span>{{agendaSpecialBar.endTime_zh}}</span></div>
                                                </div>
                                                <div>
                                                    <p class="text-p">{{agendaSpecialBar.name}}</p>
                                                    <div class="text-address"><img v-if="agendaSpecialBar.hotel!=null&&agendaSpecialBar.hotel!=''" src="@/assets/newImages/home/little-address.png" alt=""><span>{{agendaSpecialBar.hotel}}</span></div>
                                                </div>
                                            </div>
                                            <div class="agenda-lists-main" v-on:mouseenter="disableMouseWheel()" v-on:mouseleave="enableMouseWheel()">
                                                <div class="agendaList-one" v-for="(item, key) in agendaSpeechList" :key="key" v-on:mouseenter="setAgendaBar(item)" @click="clickAgenda(item, key)">
                                                    <img class="line" src="@/assets/newImages/common/line.png" alt="">
                                                    <div class="title">{{item.name}}</div>
                                                    <div class="time-div"><img src="@/assets/newImages/home/icon-time.png" alt="">{{item.startTime_h_m}}-{{item.endTime_h_m}}</div>
                                                    <div class="time-div address-div"><img v-if="item.hotel!=''&&item.hotel!=null" src="@/assets/newImages/home/icon-address.png" alt=""><p>{{item.hotel}}</p></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="agenda-main1 agenda-main2 agenda-main3" v-if="agendaDayNavOne==2">
                                            <div class="agenda-image">
                                                <div>
                                                    <div class="text-title"><span></span>开放演讲</div>
                                                    <div class="text-am"><div class="p"><p v-for="(startWord, startWordKey) in agendaOpenBar.startTimeWordArr" :key="startWordKey">{{startWord}}</p></div><span>{{agendaOpenBar.startTime_zh}}</span></div>
                                                    <div class="text-am"><div class="p"><p v-for="(endWord, endWordKey) in agendaOpenBar.endTimeWordArr" :key="endWordKey">{{endWord}}</p></div><span>{{agendaOpenBar.endTime_zh}}</span></div>
                                                </div>
                                                <div>
                                                    <p class="text-p">{{agendaOpenBar.name}}</p>
                                                    <div class="text-address"><img v-if="agendaOpenBar.hotel!=null&&agendaOpenBar.hotel!=''" src="@/assets/newImages/home/little-address.png" alt=""><span>{{agendaOpenBar.hotel}}</span></div>
                                                </div>
                                            </div>
                                            <div class="agenda-lists-main" v-on:mouseenter="disableMouseWheel()" v-on:mouseleave="enableMouseWheel()">
                                                <div class="agendaList-one" v-for="(item, key) in agendaSpeechList" :key="key" v-on:mouseenter="setAgendaBar(item)" @click="clickAgenda(item, key)">
                                                    <div class="num"><img :src="item.index_zh_img" alt=""></div>
                                                    <!-- <div class="num"><p>{{item.index_zh}}</p></div> -->
                                                    <div class="title">{{item.name}}</div>
                                                    <div class="time-div"><img src="@/assets/newImages/home/icon-time.png" alt="">{{item.startTime_h_m}}-{{item.endTime_h_m}}</div>
                                                    <div class="time-div address-div"><img v-if="item.hotel!=null&&item.hotel!=''" src="@/assets/newImages/home/icon-address.png" alt=""><p>{{item.hotel}}</p></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tishi">*以现场执行为准</div>
                            </div>
                        </div>
                        <div class="more"><p @click="goPath('/agenda', '大会议程')">查看更多</p><div class="img"><img src="@/assets/newImages/home/icon-more1.png" alt="more"></div></div>
                    </div></div> 
                    <div class="swiper-slide" v-if="showNavGuest" id="/guest"><div class="con-page9">
                        <div class="bg-img"><img src="@/assets/newImages/home/page3-right-bg.png" alt=""></div>
                        <div class="bg-img2"><img src="@/assets/newImages/home/page4-left-bg.png" alt=""></div>
                        <div class="con-1200">
                            <div class="con-title"><p>重磅嘉宾</p></div>
                            <div class="guest-content">
                                <div class="hot-top-button">
                                    <div class="hot-left" :class="guestListTab<=0?'':'hot-left-active'" @click="reduceGuest()"><img src="@/assets/newImages/home/icon-left.png" alt=""></div>
                                    <div class="hot-right" :class="guestListTab>=guestList.length-1?'':'hot-right-active'" @click="addGuest()"><img src="@/assets/newImages/home/icon-right.png" alt=""></div>
                                </div>
                                <div class="guest-list">
                                    <div class="guest-one" v-for="(guestOne, key) in guestList" :key="key" :class="{'guest-one-active':guestListTab == key , 'guest-one-oldActive':guestListTab-1 == key}">
                                        <div class="guest1" v-for="(item, key) in guestOne" :key="key" :class="{'guest1-active':guestOneActive==key}"  v-on:mouseenter="guestOneMouse(key)" v-on:mouseleave="enableGuestOneMouseMouse()" @click="goPath('/guest', '重磅嘉宾')">
                                            <div class="guest1-one">
                                                <div class="bg-img"><img src="@/assets/newImages/home/guest/guest-bg.png" alt=""></div>
                                                <div class="name">{{item.name}}</div>
                                                <div class="text">{{item.duty}}</div>
                                                <div class="people-img"><img :src="item.realPath" alt=""></div>
                                            </div>
                                            <div class="guest1-two">
                                                <div class="bg-img"><img src="@/assets/newImages/home/guest/guest-bg2.png" alt=""></div>
                                                <div class="name">{{item.name}}</div>
                                                <div class="text">{{item.duty}}</div>
                                                <div class="people-img"><img :src="item.realPath" alt=""></div>
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                        </div>
                        <div class="more"><p @click="goPath('/guest', '重磅嘉宾')">查看更多</p><div class="img"><img src="@/assets/newImages/home/icon-more1.png" alt="more"></div></div>
                    </div></div> 
                    <div class="swiper-slide" v-if="showNavHall" id="/exhibition"><div class="con-page10">
                        <div class="bg-img"><img src="@/assets/newImages/home/page4-left-bg.png" alt=""></div>
                        <div class="bg-img2"><img src="@/assets/newImages/home/page5-right-bg.png" alt=""></div>
                        <div class="con-1200">
                            <div class="con-title"><p>展厅导览</p></div>
                            <div class="exhibition-content">
                                <div class="exhibition-top">
                                    <div class="bg-img">
                                        <img src="@/assets/newImages/home/guest/exhibition-img1.png" alt="">
                                        <img src="@/assets/newImages/home/guest/exhibition-img2.png" alt="">
                                        <img src="@/assets/newImages/home/guest/exhibition-img3.png" alt="">
                                    </div>
                                    <div class="top-middle"><p>生态馆</p><p>产业馆</p><p>行业馆</p></div>
                                    <div class="top-left">大会展览展示总面积超过 25000 平米，围绕“三元协同，共创数字化转型价值”的设计理念，专设生态馆、产业馆和行业馆三大展馆。 <br>生态馆集中呈现了100+生态伙伴和80+平台支撑能力，诠释了华为如何与伙伴携手共生共进；<br> 产业馆则带来了覆盖超过20+子产品线的250+个展点，以互动体验的形式全面展现科技创新的驱动力，夯实了价值创造基石； <br>行业馆以覆盖超过40+子行业，携手200+伙伴联合打造的270+个展点和渐进式体验点，诠释了如何以场景深耕探索，发现更大、更高行业新价值。</div>
                                </div>
                                <div class="exhibition-three">
                                    <div class="exhibition-one" v-for="(item,index) in exhibitionList " :key="index" @click="goExhibition(item.title)">
                                        <div class="bg-img"><img :src="item.bgImg" alt=""></div>
                                        <div class="img"><img :src="item.img" alt=""></div>
                                        <div class="text-right">
                                            <div class="title"><span>{{item.title}}</span><img src="@/assets/newImages/home/icon-right9.png" alt=""></div>
                                            <p>{{item.text}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="more"><p @click="goPath('/exhibition', '展厅导览')">查看更多</p><div class="img"><img src="@/assets/newImages/home/icon-more1.png" alt="more"></div></div>
                    </div></div> 
                    <div class="swiper-slide" v-if="showNavNews" id="/news"><div class="con-page5">
                        <div class="bg-img3"><img src="@/assets/newImages/home/page5-right-bg.png" alt=""></div>
                        <!-- <div class="bg-img"><img src="@/assets/newImages/home/page4-left-bg.png" alt=""></div> -->
                        <!-- <div class="bg-img2"><img src="@/assets/newImages/home/page5-right-bg.png" alt=""></div> -->
                        <div class="con-1200">
                            <div class="con-title"><p>热门资讯</p></div>
                            <!--<div class="hot-main">
                                <div class="hot-top-button">
                                    <div class="hot-left" :class="hotNewsTab<=0?'':'hot-left-active'" @click="reduceNum()"><img src="@/assets/newImages/home/icon-left.png" alt=""></div>
                                    <div class="hot-right" :class="hotNewsTab>=hotNewsList.length-1?'':'hot-right-active'" @click="addNum()"><img src="@/assets/newImages/home/icon-right.png" alt=""></div>
                                </div>
                                <div class="hot-news-list">
                                    <div class="hot-news" v-for="(hotNewsNow, key) in hotNewsList" :key="key" :class="{'hot-news-active':hotNewsTab == key , 'hot-news-oldActive':hotNewsTab-1 == key}" >
                                        <div class="hot-left" @click="clickNews(hotNewsNow.hotOne.url, hotNewsNow.hotOne.title, hotNewsNow.hotOne.product_tag, hotNewsNow.hotOne.industry_tag, 99)">
                                            <div class="hot-image"><img :src="hotNewsNow.hotOne.coverImageRealPath" alt=""></div>
                                            <div class="hot-text"><p>{{hotNewsNow.hotOne.title}}</p><div class="img"><img src="@/assets/newImages/home/icon-right.png" alt=""></div></div>
                                        </div>
                                        <div class="hot-right">
                                            <div class="hot-right-one" v-for="(item, key) in hotNewsNow.hotList" :key="key"  @click="clickNews(item.url, item.title, item.product_tag, item.industry_tag, key)">
                                                <div class="days"><p>{{item.pushTimeYear}}</p><span>{{item.pushTimeDay}}</span></div>
                                                <div class="hot-main-title">
                                                    <p class="title">{{item.title}}</p>
                                                    <p class="text">{{item.summary2}}</p>
                                                    <div class="img"><img src="@/assets/newImages/home/icon-right9.png" alt=""></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                            </div>-->
                            <div class="hot-main">
                                <div class="hot-top-button">
                                    <div class="hot-left" :class="hotNewsTab<=0?'':'hot-left-active'" @click="reduceNum()"><img src="@/assets/newImages/home/icon-left.png" alt=""></div>
                                    <div class="hot-right" :class="hotNewsTab>=hotNewsList.length-1?'':'hot-right-active'" @click="addNum()"><img src="@/assets/newImages/home/icon-right.png" alt=""></div>
                                </div>
                                <div class="hot-news-list">
                                    <div class="hot-news" v-for="(hotNewsNow, key) in hotNewsList" :key="key" :class="{'hot-news-active':hotNewsTab == key , 'hot-news-oldActive':hotNewsTab-1 == key}" >
                                        <div class="hot-left" @click="clickNews(hotNewsBar.url, hotNewsBar.title, hotNewsBar.product_tag, hotNewsBar.industry_tag, 99)">
                                            <div class="hot-image"><img :src="hotNewsBar.coverImageRealPath" alt=""></div>
                                            <div class="hot-text"><p>{{hotNewsBar.title}}</p><div class="img"><img src="@/assets/newImages/home/icon-right.png" alt=""></div></div>
                                        </div>
                                        <div class="hot-right">
                                            <div class="hot-right-one" v-for="(item, key) in hotNewsNow" :key="key"  @click="clickNews(item.url, item.title, item.product_tag, item.industry_tag, key)" v-on:mouseenter="setNewsBar(item)">
                                                <div class="days"><p>{{item.pushTimeYear}}</p><span>{{item.pushTimeDay}}</span></div>
                                                <div class="hot-main-title">
                                                    <p class="title">{{item.title}}</p>
                                                    <p class="text">{{item.summary2}}</p>
                                                    <div class="img"><img src="@/assets/newImages/home/icon-right9.png" alt=""></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                        </div>
                        <div class="more"><p @click="goPath('/news', '热门资讯')">查看更多</p><div class="img"><img src="@/assets/newImages/home/icon-more1.png" alt="more"></div></div>
                    </div></div> 
                    <div class="swiper-slide" v-if="showNavPartner" id="/partner"><div class="con-page6">
                        <!-- <div class="bg-img"><img src="@/assets/newImages/home/page5-right-bg.png" alt=""></div> -->
                        <div class="bg-img3"><img src="@/assets/newImages/home/page6-right-bg.png" alt=""></div>
                        <div class="con-1200">
                            <div class="con-title"><p>生态伙伴</p></div>
                            <div class="com-main">
                                <div class="com-main-top" @click="clickSponsorSpecial(sponsorSpecial.url, sponsorSpecial.name)">
                                    <p>{{sponsorSpecial.title1}}{{sponsorSpecial.title2}}</p>
                                    <img :src="sponsorSpecial.image" alt="">
                                </div>
                                <div class="com-main-bottom">
                                    <div class="sponsor-main">
                                        <div class="sponsor-one" v-for="(sponsor, key) in sponsorList" :key="key" :class="{'sponsor-active':sponsorShow == key}">
                                            <div class="sponsor-one-img" @click="chooseSponsorTab(key, sponsor.title)">
                                                <img :src="sponsor.bgImg" alt=""><p>{{sponsor.title}}</p><div class="sponsor-one-img-bg"></div>
                                            </div>
                                            <div class="sponsor-logo-list">
                                                <div class="hot-top-button">
                                                    <div class="hot-left" :class="sponsor.sponsorOneShow<=0?'':'hot-left-active'" @click="reduceSponsorNum(key)"><img src="@/assets/newImages/home/icon-left.png" alt=""></div>
                                                    <div class="hot-right" :class="sponsor.sponsorOneShow>=sponsor.sponsorOne.length-1?'':'hot-right-active'" @click="addSponsorNum(key)"><img src="@/assets/newImages/home/icon-right.png" alt=""></div>
                                                </div>
                                                <div class="sponsor-logo-main">
                                                    <div class="sponsor-logoOne" v-for="(sponsorLogoList, key) in sponsor.sponsorOne" :key="key" :class="{'sponsor-logoOne-active':sponsor.sponsorOneShow == key , 'sponsor-logoOne-oldActive':sponsor.sponsorOneShow-1 == key}" >
                                                        <div class="sponsorLogo" v-for="(logo, key) in sponsorLogoList" :key="key" @click="clickPartner(logo.url, logo.title)">
                                                            <img :src="logo.coverImageRealPath"/>
                                                        </div>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tishi">*以上排名不分先后</div>
                        </div>
                        <div class="more"><p @click="goPath('/partner', '生态伙伴')">查看更多</p><div class="img"><img src="@/assets/newImages/home/icon-more1.png" alt="more"></div></div>
                    </div></div> 
                    <!-- 精彩图集 -->
                    <div class="swiper-slide" v-if="showNavPic" id="/wonderfulPic"><div class="con-page11">
                        <div class="bg-img"><img src="@/assets/newImages/home/page6-right-bg.png" alt=""></div>
                        <div class="con-1200">
                            <div class="con-title"><p>精彩图集</p></div>
                            <div class="com-main">
                                <div class="hot-top-button">
                                    <div class="hot-left" :class="{'hot-left-active':isLeftScrollPc==true}" @click="reduceAtlas()"><img src="@/assets/newImages/home/icon-left.png" alt=""></div>
                                    <div class="hot-right" :class="{'hot-right-active':isRightScrollPc==true}" @click="addAtlas()"><img src="@/assets/newImages/home/icon-right.png" alt=""></div>
                                </div>
                                <div class="atlas-list" id="pagePcContent5">
                                    <div class="page11-content">
                                        <div class="left" id="pagePcContent1"><img :src="wonderfulPic.firstImg" alt=""></div>
                                        <div class="right" id="pagePcContent2">
                                            <div class="right-top">
                                                <img  v-for="(item,index) in wonderfulPic.list" :key="index" :src="item" alt="">
                                            </div>
                                            <div class="right-top">
                                                <img  v-for="(item,index) in wonderfulPic.list2" :key="index" :src="item" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div></div> 
                    <!-- 大咖观点 -->
                    <div class="swiper-slide" v-if="showNavWords" id="/wonderfulWords"><div class="con-page12">
                        <div class="bg-img"><img src="@/assets/newImages/home/twins-left-bg.png" alt=""></div>
                        <div class="bg-img2"><img src="@/assets/newImages/home/twins-right-bg.png" alt=""></div>
                        <div class="con-1200">
                            <div class="con-title"><p>大咖观点</p></div>
                            <div class="swiper-container twins-content" >
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide" v-for="(item,key) in twinsList" :key="key">
                                        <div class="bg-img"><img src="@/assets/newImages/home/guest/twins-img.png" alt=""></div>
                                        <div class="people-img"><img :src="item.coverImageRealPath" alt=""></div>
                                        <div class="text"><p class="name">{{item.guestName}}</p>
                                            <div class="post">{{item.guestDuty}}</div>
                                            <div class="detail-div">
                                                <div class="text-show">
                                                    <div class="show-img"><img src="@/assets/newImages/home/guest/twins-icon.png" alt=""></div>
                                                    <p class="detail">{{item.summary}}</p>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-button-next twins-next"><img src="@/assets/newImages/home/icon-right.png" alt=""></div>
                                <div class="swiper-button-prev twins-prev"><img src="@/assets/newImages/home/icon-left.png" alt=""></div>
                                <div class="twins-bg"></div>
                            </div>
                        </div>
                    </div></div>
                    <div class="swiper-slide" v-if="showNavVideo" id="/video"><div class="con-page7">
                        <div class="bg-img"><img src="@/assets/newImages/home/twins-left-bg.png" alt=""></div>
                        <div class="bg-img2"><img src="@/assets/newImages/home/page7-right-bg.png" alt=""></div>
                        <div class="con-1200">
                            <div class="con-title"><p>精彩视频</p></div>
                            <div class="con-main">
                                <!-- 导航按钮 -->
                                <div class="hot-top-button">
                                    <div class="hot-left" :class="VideoTab<=0?'':'hot-left-active'" @click="prevNum()"><img src="@/assets/newImages/home/icon-left.png" alt=""></div>
                                    <div class="hot-right" :class="VideoTab>=videoList.length-1?'':'hot-right-active'" @click="nextNum()"><img src="@/assets/newImages/home/icon-right.png" alt=""></div>
                                </div>
                                <div class="video-main">
                                    <div class="video-one" v-for="(videoOne, key) in videoList" :key="key" :class="{'video-one-active':VideoTab == key , 'video-one-oldActive':VideoTab-1 == key}" >
                                        <div class="video-one-three" v-for="(video, key) in videoOne" :key="key" @click="showVideoToast(video, video.title)">
                                            <div class="video-show-one">
                                                <div class="img-bg"></div>
                                                    <img :src="video.coverImageRealPath" alt="">
                                                <p class="p">{{video.title}}</p>
                                                <div class="button"><p>播放</p>
                                                    <img src="@/assets/newImages/home/page7-icon3.png" alt="">
                                                </div>
                                            </div>
                                            <div class="video-show-two">
                                                <img :src="video.coverImageRealPath" alt="">
                                                <div class="bg"><p>{{video.title}}</p>
                                                    <div class="video-start">
                                                        <img src="@/assets/newImages/home/video.png" alt="">
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="more"><p @click="goPath('/video', '精彩视频')">查看更多</p><div class="img"><img src="@/assets/newImages/home/icon-more1.png" alt="more"></div></div>
                    </div></div> 
                    <!-- 资料下载 -->
                    <div class="swiper-slide" v-if="showNavDownload" id="/files"><div class="con-page13">
                        <div class="bg-img"><img src="@/assets/newImages/home/page3-right-bg.png" alt=""></div>
                        <div class="bg-img2"><img src="@/assets/newImages/home/page7-right-bg.png" alt=""></div>
                        <div class="con-1200">
                            <div class="con-title"><p>资料中心</p></div>
                            <div class="files-content">
                                <div class="files-three">
                                    <div class="files-three-one flexCenter" v-for="(filesOne,key) in filesTabNav" :key="key" :class="{'files-one-active':key==fileOneTab}" @click="filesTabNavThree(key)">
                                        <p>{{filesOne.title}}</p><span class="right-line"></span><span class="line"></span>
                                    </div>
                                </div>
                                <div class="files-list" >
                                    <div class="files-nav" v-if="fileOneTab==2">
                                        <div class="files-nav-one" v-for="(twoTab, key) in hallList" :key="key" :class="filesTabTwoNav === key ? 'files-nav-one-active':''" @click="filesTabTwoChoose(key)">{{twoTab.cateName}}</div>
                                    </div>
                                    <div class="files-main1" v-if="fileOneTab==2">
                                        <div class="files-main1-content" v-on:mouseenter="disableMouseWheel()" v-on:mouseleave="enableMouseWheel()" >
                                            <div class="filesTwo-one" v-for="(item, key) in filesListTwo" :key="key">
                                                <div class="title" :class="{'title-active':item.isShow==true}" @click="filesListTwoShow(key)">
                                                    <div class="title-left"><span class="line"></span><p>{{item.title}}</p></div>
                                                    <div class="right-icon" :class="{'right-icon-bottom':item.isShow==true}"><img src="@/assets/newImages/parnter/title-icon2.png" alt=""></div>
                                                </div>
                                                <div class="filesTwo-one-main" :class="{'filesTwo-one-main-active':item.isShow==true}">
                                                    <div class="filesTwo-oneItem" v-for="(list, index) in item.fileList" :key="index" >
                                                        <div class="left-one">
                                                            <div class="left-img"><img src="@/assets/newImages/personal/collection-img.png" alt=""></div>
                                                            <p>{{list.name}}</p>
                                                        </div>
                                                        <div class="right-one">
                                                            <!-- loading-div-active按钮变灰 -->
                                                            <div class="loading-div" @click.stop="preview(list)">
                                                                <div class="img"><img src="@/assets/newImages/exhibitionGuide/main-one-img3.png" alt=""></div>
                                                                <div class="img"><img src="@/assets/newImages/agenda/icon1.png" alt=""></div>
                                                                <p>在线预览</p>
                                                            </div>
                                                            <div class="loading-div loading-div2" @click.stop="download(list)">
                                                                <div class="img"><img src="@/assets/newImages/exhibitionGuide/main-one-img2.png" alt=""></div>
                                                                <div class="img"><img src="@/assets/newImages/agenda/icon2.png" alt=""></div>
                                                                <p>资料下载 </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="files-main1 files-main2" v-if="fileOneTab==0">
                                        <div class="files-main1-content" v-on:mouseenter="disableMouseWheel()" v-on:mouseleave="enableMouseWheel()" >
                                            <div class="filesTwo-one" v-for="(item, key) in zipTopicFileList" :key="key">
                                                <div class="title title-active">
                                                    <div class="title-left"><span class="line"></span><p>{{item.title}}</p></div>
                                                </div>
                                                <div class="filesTwo-one-main filesTwo-one-main-active">
                                                    <div class="filesTwo-oneItem" v-for="(list, index) in item.fileMain" :key="index" >
                                                        <div class="left-one">
                                                            <div class="left-img"><img src="@/assets/newImages/common/like-img3-icon.png" alt=""></div>
                                                            <p>{{list.name}}</p>
                                                        </div>
                                                        <div class="right-one">
                                                            <div class="loading-div" @click.stop="preview(list)">
                                                                <div class="img"><img src="@/assets/newImages/exhibitionGuide/main-one-img3.png" alt=""></div>
                                                                <div class="img"><img src="@/assets/newImages/agenda/icon1.png" alt=""></div>
                                                                <p>在线预览</p>
                                                            </div>
                                                            <div class="loading-div loading-div2" @click.stop="download(list)">
                                                                <div class="img"><img src="@/assets/newImages/exhibitionGuide/main-one-img2.png" alt=""></div>
                                                                <div class="img"><img src="@/assets/newImages/agenda/icon2.png" alt=""></div>
                                                                <p>资料下载 </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="files-main1 files-main3" v-if="fileOneTab==1">
                                        <div class="files-main1-content" v-on:mouseenter="disableMouseWheel()" v-on:mouseleave="enableMouseWheel()" >
                                            <div class="filesTwo-one" v-for="(item, key) in zipSpecialList" :key="key">
                                                <div class="title" :class="{'title-active':item.isShow==true}" @click="filesListOneShow(key)">
                                                    <div class="title-left"><span class="line"></span><p>{{item.title}}</p></div>
                                                    <div class="right-icon" :class="{'right-icon-bottom':item.isShow==true}"><img src="@/assets/newImages/parnter/title-icon2.png" alt=""></div>
                                                </div>
                                                <div class="filesTwo-one-main" :class="{'filesTwo-one-main-active':item.isShow==true}">
                                                    <div class="filesTwo-oneItem" v-for="(list, index) in item.specialMain" :key="index" >
                                                        <div class="left-one">
                                                            <div class="left-img"><img src="@/assets/newImages/common/like-img3-icon.png" alt=""></div>
                                                            <p>{{list.name}}</p>
                                                        </div>
                                                        <div class="right-one">
                                                            <div class="loading-div" @click.stop="specialPreview(list)">
                                                                <div class="img"><img src="@/assets/newImages/exhibitionGuide/main-one-img3.png" alt=""></div>
                                                                <div class="img"><img src="@/assets/newImages/agenda/icon1.png" alt=""></div>
                                                                <p>在线预览</p>
                                                            </div>
                                                            <div class="loading-div loading-div2" @click.stop="specialDownload(list)">
                                                                <div class="img"><img src="@/assets/newImages/exhibitionGuide/main-one-img2.png" alt=""></div>
                                                                <div class="img"><img src="@/assets/newImages/agenda/icon2.png" alt=""></div>
                                                                <p>资料下载 </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="more" @click="goPath('/files', '精彩视频')"><p>查看更多</p><div class="img"><img src="@/assets/newImages/home/icon-more1.png" alt="more"></div></div>
                    </div></div> 
                    <div class="swiper-slide" id="/guide"><div class="con-page8">
                        <div class="bg-img"><img src="@/assets/newImages/home/page8-right-bg.png" alt=""></div>
                        <div class="bg-img2"><img src="@/assets/newImages/home/page8-left-bg.png" alt=""></div>
                        <div class="con-1200">
                            <div class="con-title"><p>参会指南</p></div>
                            <div class="con-main">
                                <div class="image"  @click="clickMap()">
                                    <!-- <div class="image2">
                                        <img src="../assets/newImages/home/page8-address.png">
                                        <p class="center">深圳会展中心</p>
                                        <p class="address">广东省深圳市福田区福华三路与金田路交叉口</p>
                                    </div> -->
                                </div>
                                <div class="more"><p @click="goPath('/guide', '参会指南')">查看更多</p><div class="img"><img src="@/assets/newImages/home/icon-more1.png" alt="more"></div></div>
                                <div class="applet"><img src="@/assets/newImages/home/applet2.png"></div>
                            </div>
                        </div>
                        <div class="footer">
                            <div class="left">
                                <p>票务问题</p>
                                <p>门票、酒店、机票、IT系统咨询</p>
                                <p>+86 0755-28565555</p>
                            </div>
                            <div class="right">
                                <div class="title-img">
                                    <p>关注我们</p>
                                    <div class="logos">
                                        <div class="img" v-on:mouseenter="showWxQr()" v-on:mouseleave="hideWxQr()">
                                            <img src="@/assets/newImages/home/icon-weixin.png" alt="">
                                            <div v-if="showWxQrcode" class="icon-weixin">
                                                <img src="@/assets/newImages/common/wxqrcode.jpg">
                                                <div class="sanjiao"></div>
                                            </div>
                                        </div>
                                        <div class="img" v-on:mouseenter="showAppQr()" v-on:mouseleave="hideAppQr()">
                                            <img src="@/assets/newImages/home/icon-app.png" alt="">
                                            <div v-if="showAppQrcode" class="icon-weixin">
                                                <img src="@/assets/newImages/common/appqrcode.png">
                                                <div class="sanjiao"></div>
                                            </div>
                                        </div>
                                        <div class="img" @click="clickWeibo"><img src="@/assets/newImages/home/icon-weibo.png" alt=""></div>
                                    </div>
                                </div>
                                <p><a @click="clickContactus">联系我们</a>  |  <a @click="clickLegal">法律声明</a>  |  <a @click="clickPrivacy">隐私保护</a></p>
                                <p>版权所有 © 华为技术有限公司 1998-2021</p>
                            </div>
                        </div>
                    </div></div>
                </div>
            </div>
            <videoModel v-if="isPc" :show="pageCoverVideo" :videoInfo="videoToastUrl" @closeModal="closeVideoToast"></videoModel>
        </div>
        <div class="mobile">
            <!-- 视频弹窗 -->
            <videoModel v-if="!isPc" :show="pageCoverVideo" :videoInfo="videoToastUrl" @closeModal="closeVideoToast"></videoModel>
            <div class="page1" v-if="liveStatus=='before'">
                <div class="page-img1"><img src="@/assets/newImages/wap/home/page1/page1-bg.jpg" alt=""></div>
                <div class="page-img2"><img src="@/assets/newImages/wap/home/page1/page-left.png" alt=""></div>
                <div class="page-img3"><img src="@/assets/newImages/wap/home/page1/page-right.png" alt=""></div>
                <div class="page-img4"><img src="@/assets/newImages/wap/home/page1/page-right2.png" alt=""></div>
                <!-- <div class="page-img5"><img src="@/assets/newImages/wap/home/page1/page-text-top.png" alt=""></div> -->
                <div class="page-img6"><img src="@/assets/newImages/wap/home/page1/page-num.png" alt=""></div>
                <div class="page-img7"><img src="@/assets/newImages/wap/home/page1/page-text.png" alt=""></div>
                <p>{{page1Text}}　{{page1Address}}</p>
                <div class="home-buttons home-buttons2" v-if="orderOffline==1">
                    <button class="button2 flexCenter" @click="signUp()">查看参会二维码</button>
                </div>
                <div class="home-buttons" v-else>
                    <button class="button1 flexCenter" v-if="orderOnline==0" @click="orderLive()">预约直播</button>
                    <button class="button1 flexCenter" v-if="orderOnline==1" @click="orderLive()">已预约直播</button>
                    <button class="button2 flexCenter" v-if="!orderStop&&orderOffline==0&&!isStudent" @click="signUp()">参会报名</button>
                    <button class="button2 flexCenter" v-if="!orderStop&&orderOffline==2" @click="signUp()">线下参会审核中</button>
                </div>
            </div>
            <div class="page1-live" v-if="liveStatus!='before'">
                <div class="page-img1"><img src="@/assets/newImages/wap/home/page-live-icon.png" alt=""></div>
                <div class="page-img2"><img src="@/assets/newImages/wap/home/page-live-icon2.png" alt=""></div>
                <div class="live-left">
                    <div class="left-title">
                        <div class="one-left" v-if="liveStatus=='middle'">
                            <p><img src="@/assets/newImages/home/live-icon.png" alt=""><span>正在直播：</span></p>
                            <p>{{mainLiveTitle}}</p>
                        </div>
                        <div class="one-left one-left2" v-if="liveStatus=='after'">
                            <p><img src="@/assets/newImages/home/live-icon.png" alt=""><span>{{mainLiveTitle}}</span></p>
                        </div>
                        <div class="one-right" @click="clickMainLive()">进入直播间<br>参与更多互动</div>
                    </div>
                    <!--<div class="left-video">
                        <video src="" controls></video> 
                    </div>-->
                    <iframe v-if="!isPc" class="left-video"
                        allow="camera *;microphone *;" 
                        border="0"
                        allowfullscreen="true"
                        :src="mainLiveIframeUrl">
                    </iframe>
                </div>
                <div class="live-right">
                    <div class="live-right-top">
                        <div class="img"><img src="@/assets/newImages/home/live-eco.png" alt=""></div>
                        <div class="text-div">
                            <div class="text-date" :class="{'text-active':liveIndex==index}" v-for="(item,index) in liveLists" :key="index" @click="chooseLiveDate(index)">
                                <p>{{item.name}}</p><span class="line"></span><div class="right-line"></div>
                            </div>
                        </div>
                    </div>
                    <div class="live-right-lists">
                        <div class="live-right-lists-one" v-for="(lists,num) in liveLists[liveIndex].content" :key="num" :class="{'live-right-lists-active':num==liveLists[liveIndex].showList}">
                            <div class="right-title" @click="chooseLiveListIndex(num)">
                                <div class="title-left"><p v-if="lists.name!='Σco·Live'">{{lists.name}}</p>
                                    <div v-if="lists.name=='Σco·Live'&&num==liveLists[liveIndex].showList" class="img"><img src="@/assets/newImages/home/live/wap-live.svg" alt=""></div>
                                    <div v-if="lists.name=='Σco·Live'&&num!=liveLists[liveIndex].showList" class="img"><img src="@/assets/newImages/home/live/wap-live-black.svg" alt=""></div>
                                    <div v-if="lists.name=='Σco·Live'" class="list-img" style="margin-left:5px;">
                                        <div class="img1" @click.stop="clickMainLive()" v-if="lists.vhallStatus==0"><img src="@/assets/newImages/home/live/live-wap-img2.png" alt=""></div>
                                        <div class="img1" @click.stop="clickMainLive()" v-if="lists.vhallStatus==1"><img src="@/assets/newImages/home/live/live-wap-img1.png" alt=""></div>
                                        <div class="img1" @click.stop="clickMainLive()" v-if="lists.vhallStatus==2"><img src="@/assets/newImages/home/live/live-wap-img3.png" alt=""></div>
                                        <div class="img1" @click.stop="clickMainLive()" v-if="lists.vhallStatus==3"><img src="@/assets/newImages/home/live/live-wap-img4.png" alt=""></div>
                                    </div>
                                    <span class="left-right"></span></div>
                                <div class="title-img"><img src="@/assets/newImages/parnter/title-icon2.png" alt=""></div>
                            </div>
                            <div class="right-list">
                                <div class="right-list-one" v-for="(item,num2) in lists.child" :key="num2" :class="{'right-list-one-active':liveLeftIndex==item.id}" @click="clickLive(item)">
                                    <div class="list-one-top">
                                        <div class="time">{{item.startTime_h_m}}-{{item.endTime_h_m}}</div>
                                        <div class="list-img">
                                            <div class="img1" v-if="item.vhallStatus==0"><img src="@/assets/newImages/home/live/live-wap-img2.png" alt=""></div>
                                            <div class="img1" v-if="item.vhallStatus==1"><img src="@/assets/newImages/home/live/live-wap-img1.png" alt=""></div>
                                            <div class="img1" v-if="item.vhallStatus==2"><img src="@/assets/newImages/home/live/live-wap-img3.png" alt=""></div>
                                            <div class="img1" v-if="item.vhallStatus==3"><img src="@/assets/newImages/home/live/live-wap-img4.png" alt=""></div>
                                            <!-- <div class="img1 img3" v-if="item.vhallStatus==0"><img src="@/assets/newImages/home/live/icon3.png" alt=""><p>敬请期待</p></div>
                                            <div class="img1" v-if="item.vhallStatus==1"><img src="@/assets/newImages/home/live/icon1.png" alt=""><p>直播中</p></div>
                                            <div class="img1 img4" v-if="item.vhallStatus==2"><img src="@/assets/newImages/home/live/icon4.png" alt=""><p>已结束</p></div>
                                            <div class="img1 img2" v-if="item.vhallStatus==3"><img src="@/assets/newImages/home/live/icon2.png" alt=""><p>观看回放</p></div> -->
                                        </div>
                                    </div>
                                    <div class="list-one-title">{{item.name}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-bg">
                <div v-if="showNavAgendaDesc" class="page2" id="desc">
                <div v-if="showNavAgendaDesc" class="page-title"><p>大会介绍</p></div>
                <div v-if="showNavAgendaDesc" class="page2-content">
                    <div class="con-img"><img src="@/assets/newImages/home/page2-img1.jpg" alt=""></div>
                    <div class="rich-text">
                        <p>站在数字时代的新起点，我们看到，数字化转型的趋势性价值与机会空间无比广阔，正化作时代的最强光指引千行百业穿越迷雾。</p>
                        <p>迎接更深层的转型新局，我们发现，唯有能力共进、持续深耕、全面协同，才能在众多不确定性的挑战中，创造更多确定性价值！</p>
                        <p style="margin-top:1.66vh;">“因聚而生，有能有为”，华为中国生态大会2021，期待与每一位有能力、有抱负的生态伙伴一起，合力相融，能力共进，释放更大生态潜能，在时代新局下共育新机，共赢价值，共享繁荣！</p>
                        <p style="margin-top:1.66vh;">2021年5月17日-18日，我们诚邀您相聚深圳，携手共见！</p>
                    </div>
                </div>
                </div>
                <div class="page3" v-if="showNavAgendaList" id="agenda">
                    <div class="page-title"><p>大会议程</p></div>
                    <div class="page3-content">
                        <div class="icon"><img src="@/assets/newImages/wap/home/page4-bg.png" alt=""></div>
                        <div class="con-title">
                            <div class="day-text" v-for="(item, key) in agendaYearDay" :key="key" :class="dayIndex === key ? 'day-text-active':''" @click="chooseDay(key)">
                                <p>{{item.day}}</p><p>DAY{{key+1}}</p>
                            </div>
                        </div>
                        <div class="con-list">
                            <div class="list-nav">
                                <div class="list-nav-one" v-for="(item, key) in agendaDayNav" :key="key" :class="agendaDayNavOne === key ? 'list-nav-one-active':''" @click="chooseDayNav(key)">{{item.title}}</div>
                            </div>
                            <div v-if="agendaSpeechList.length==0&&agendaDayNavOne!=2">
                                <div class="agenda-wait">敬请期待</div>
                            </div>
                            <div v-if="agendaSpeechList.length==0&&agendaDayNavOne==2">
                                <div class="agenda-wait">30+精彩演讲，敬请期待</div>
                            </div>
                            <div v-if="agendaSpeechList.length>0">
                                <div class="agenda-main1" v-if="agendaDayNavOne==0">
                                    <div class="agenda-image" v-if="agendaSpeechList.length==1">
                                        <div class="one-bg" ><img src="@/assets/newImages/agenda/wap/agenda-img-one.png" alt=""></div>
                                        <p>{{agendaTopicBar.name}}</p>
                                    </div>
                                    <div class="agenda-image2" v-if="agendaSpeechList.length>=2">
                                        <div class="agenda-image2-one" v-for="(leftItem, leftKey) in agendaSpeechList" :key="leftKey" 
                                                    :class="{'agenda-image2-active':agendaThemeActive==leftKey}"
                                                    @click="clickTopicAgendaLeft(leftKey)"    >
                                            <div class="one-bg" v-if="leftKey==0"><img src="@/assets/newImages/agenda/wap/agenda-img11.png" alt=""></div>
                                            <div class="one-bg" v-if="leftKey==0"><img src="@/assets/newImages/agenda/wap/agenda-img21.png" alt=""></div>
                                            <div class="one-bg" v-if="leftKey==1"><img src="@/assets/newImages/agenda/wap/agenda-img12.png" alt=""></div>
                                            <div class="one-bg" v-if="leftKey==1"><img src="@/assets/newImages/agenda/wap/agenda-img22.png" alt=""></div>
                                            <p>{{leftItem.name}}</p>
                                        </div>
                                    </div>
                                    <div class="agenda-image2-icons" >
                                        <div class="icon-div" v-if="showIconCollect" @click="clickAgendaCollect()" :class="{'icon-div-active':wapTopicOrder}">
                                            <img src="@/assets/newImages/agenda/icon4.png" alt="">
                                            <img src="@/assets/newImages/agenda/icon42.png" alt="">
                                            <p>收藏</p>
                                        </div>
                                        <div class="icon-div icon-div-active" v-if="showIconLive&&wapTopicLiveStatus" @click="clickAgendaLive()"><img src="@/assets/newImages/agenda/icon3.png" alt=""><img src="@/assets/newImages/agenda/icon32.png" alt=""><p>观看直播</p></div>
                                    </div>
                                    <div v-if="topicAgendaChild.length==0">
                                        <div class="agenda-child-wait flexCenter">敬请期待</div>
                                    </div>
                                    <div class="agenda-lists-main" v-if="topicAgendaChild.length>0" v-on:mouseenter="disableMouseWheel()" v-on:mouseleave="enableMouseWheel()">
                                        <div class="agendaList-one" v-for="(item, key) in topicAgendaChild" :key="key" v-on:mouseenter="setAgendaBar(item)"  @click="clickAgenda(item, key)">
                                            <div class="line-time">
                                                <img class="line" src="@/assets/newImages/common/line.png" alt="">
                                                <p class="time">{{item.startTime_h_m}}-{{item.endTime_h_m}}</p>
                                            </div>
                                            <div class="title">{{item.name}}</div>
                                            <div class="guest-div" v-if="item.guestList">
                                                <div class="guest" v-for="(guestOne, key) in item.guestList" :key="key">
                                                    <p>{{guestOne.name}}</p>
                                                    <p v-if="guestOne.enterprise||guestOne.duty">|</p>
                                                    <p v-if="guestOne.enterprise||guestOne.duty" v-html="guestOne.fullDuty"></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="agenda-main2" v-if="agendaDayNavOne==1">
                                    <div class="agenda-lists-main" v-on:mouseenter="disableMouseWheel()" v-on:mouseleave="enableMouseWheel()">
                                        <div class="agendaList-one" v-for="(item, key) in agendaSpeechList" :key="key" v-on:mouseenter="setAgendaBar(item)"  @click="clickAgenda(item, key)">
                                            <div class="line-title">
                                                <img class="line" src="@/assets/newImages/common/line.png" alt="">
                                                <div class="title">{{item.name}}</div>
                                            </div>
                                            <div class="time-address">
                                                <div class="time-div"><img src="@/assets/newImages/home/icon-time.png" alt="">{{item.startTime_h_m}}-{{item.endTime_h_m}}</div>
                                                <div class="time-div address-div"><img v-if="item.hotel!=null&&item.hotel!=''" src="@/assets/newImages/home/icon-address.png" alt=""><p>{{item.hotel}}</p></div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="agenda-main3" v-if="agendaDayNavOne==2">
                                    <div class="agenda-lists-main" v-on:mouseenter="disableMouseWheel()" v-on:mouseleave="enableMouseWheel()">
                                        <div class="agendaList-one" v-for="(item, key) in agendaSpeechList" :key="key" v-on:mouseenter="setAgendaBar(item)"  @click="clickAgenda(item, key)">
                                            <div class="num-title">
                                                <div class="num"><img :src="item.index_zh_img" alt=""></div>
                                                <!-- <div class="num"><p>{{item.index_zh}}</p></div> -->
                                                <div class="title">{{item.name}}</div>
                                            </div>
                                            <div class="time-address">
                                                <div class="time-div"><img src="@/assets/newImages/home/icon-time.png" alt="">{{item.startTime_h_m}}-{{item.endTime_h_m}}</div>
                                                <div class="time-div address-div"><img v-if="item.hotel!=null&&item.hotel!=''" src="@/assets/newImages/home/icon-address.png" alt=""><p>{{item.hotel}}</p></div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tishi">*以现场执行为准</div>
                    </div>
                    <div class="more" @click="goPath('/agenda', '大会议程')"><p>查看更多</p>
                    <div class="img"><img src="@/assets/newImages/home/icon-more1.png" alt=""></div></div>
                </div>
                <div class="page9" v-if="showNavGuest" id="guest">
                    <div class="page-title"><p>重磅嘉宾</p></div>
                    <div class="swiper-container swiper-page9" >
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="(item,key) in guestWapList" :key="key">
                                <div class="guest1-one">
                                    <div class="bg-img"><img src="@/assets/newImages/home/guest/guest-bg.png" alt=""></div>
                                    <div class="name">{{item.name}}</div>
                                    <div class="text">{{item.duty}}</div>
                                    <div class="people-img"><img :src="item.realPath" alt=""></div>
                                </div>
                                <div class="guest1-two">
                                    <div class="bg-img"><img src="@/assets/newImages/home/guest/guest-bg2.png" alt=""></div>
                                    <div class="name">{{item.name}}</div>
                                    <div class="text">{{item.duty}}</div>
                                    <div class="people-img"><img :src="item.realPath" alt=""></div>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-button-next"><img src="@/assets/newImages/home/icon-right.png" alt=""></div>
                        <div class="swiper-button-prev"><img src="@/assets/newImages/home/icon-left.png" alt=""></div>
                    </div>
                    <div class="more" @click="goPath('/guest', '重磅嘉宾')"><p>查看更多</p><div class="img"><img src="@/assets/newImages/home/icon-more1.png" alt=""></div></div>
                </div>
                <div class="page4" v-if="showNavHall" id="exhibition">
                    <div class="page-title"><p>展厅导览</p></div>
                    <div class="page4-content">
                        <div class="data-content">
                            <div class="breviery-out">
                                <div class="breviery">
                                    <!-- <img src="@/assets/newImages/wap/home/page4/exhibition2.png" alt=""> -->
                                    <div class="swiper-container swiper-breviery" >
                                        <div class="swiper-wrapper">
                                            <div class="swiper-slide" v-for="(item,index) in slideBrevieryList" :key="index"><img :src=item.imgBig alt=""></div>
                                        </div>
                                    </div>
                                    <div class="swiper-bottom">
                                        <div class="swiper-one" v-for="(item,index) in slideBrevieryList" :key="index" @click="chooseBrevieryIndex(index)" :class="{'swiper-one-active':slideBrevieryIndex==index}"><img :src=item.img alt=""><p>{{item.title}}</p></div>
                                        <!-- <div class="swiper-one"><img src="@/assets/newImages/wap/home/page4/exhibition-img2.png" alt=""><p>产业馆</p></div>
                                        <div class="swiper-one"><img src="@/assets/newImages/wap/home/page4/exhibition-img3.png" alt=""><p>行业馆</p></div> -->
                                    </div>
                                </div>
                                <div class="p"><p>大会展览展示总面积超过 25000 平米，围绕“三元协同，共创数字化转型价值”的设计理念，专设生态馆、产业馆和行业馆三大展馆。</p><p> 生态馆集中呈现了100+生态伙伴和80+平台支撑能力，诠释了华为如何与伙伴携手共生共进；</p><p> 产业馆则带来了覆盖超过20+子产品线的250+个展点，以互动体验的形式全面展现科技创新的驱动力，夯实了价值创造基石；</p><p> 行业馆以覆盖超过40+子行业，携手200+伙伴联合打造的270+个展点和渐进式体验点，诠释了如何以场景深耕探索，发现更大、更高行业新价值。</p></div>
                            </div>
                        </div>
                        <div class="exhibition-three">
                            <div class="exhibition-one" v-for="(item,index) in exhibitionList " :key="index" @click="goExhibition(item.title)">
                                <div class="bg-img"><img :src="item.bgImgWap" alt=""></div>
                                <div class="img"><img :src="item.img" alt=""></div>
                                <div class="text-right">
                                    <span>{{item.title}}</span><p>{{item.text}}</p>
                                    <div class="title"><img src="@/assets/newImages/home/icon-right9.png" alt=""></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="more" @click="goPath('/exhibition', '展厅导览')"><p>查看更多</p>
                    <div class="img"><img src="@/assets/newImages/home/icon-more1.png" alt=""></div></div>
                </div>
                <div class="page5" v-if="showNavNews" id="news">
                    <div class="page-title"><p>热门资讯</p></div>
                    <div class="page5-content">
                        <div class="hot-news">
                            <div class="hot-left" @click="clickNews(hotNewsBar.url, hotNewsBar.title, hotNewsBar.product_tag, hotNewsBar.industry_tag, 99)">
                                <div class="hot-image"><img :src="hotNewsBar.coverImageRealPath" alt=""></div>
                                <div class="hot-text"><p>{{hotNewsBar.title}}</p><div class="img"><img src="@/assets/newImages/home/icon-right.png" alt=""></div></div>
                            </div>
                            <div class="hot-right">
                                <div class="hot-right-one" v-for="(item, key) in hotNewsList[0]" :key="key"  @click="clickNews(item.url, item.title, item.product_tag, item.industry_tag, key)">
                                    <div class="days"><p>{{item.pushTimeYear}}</p><span>{{item.pushTimeDay}}</span></div>
                                    <div class="hot-main">
                                        <p class="title">{{item.title}}</p>
                                        <div class="img"><img src="@/assets/newImages/home/icon-right9.png" alt=""></div>
                                    </div>
                                </div>
                            </div>
                        </div> 
                    </div>
                    <div class="page5-icon"><img src="@/assets/newImages/wap/home/page5-icon.png" alt=""></div>
                    <div class="more" @click="goPath('/news', '热门资讯')"><p>查看更多</p>
                    <div class="img"><img src="@/assets/newImages/home/icon-more1.png" alt=""></div></div>
                </div>
                <div class="page6" v-if="showNavPartner" id="partner">
                    <div class="page-title"><p>生态伙伴</p></div>
                    <div class="page6-icon"><img src="@/assets/newImages/wap/home/page7-icon.png" alt=""></div>
                    <div class="page6-content">
                        <div class="com-main-top"  @click="clickSponsorSpecial(sponsorSpecial.url, sponsorSpecial.name)">
                            <p>{{sponsorSpecial.title1}}<br>{{sponsorSpecial.title2}}</p>
                            <img :src="sponsorSpecial.image" alt="">
                        </div>
                        <div class="com-main-bottom">
                            <div class="sponsor-main">
                                <div class="sponsor-one" v-for="(sponsor, key) in sponsorList" :key="key" :class="{'sponsor-active':sponsorShow == key}">
                                    <div class="sponsor-one-img" @click="chooseSponsorTab(key, sponsor.title)">
                                        <img class="bg-img" :src="sponsor.bgImg" alt="">
                                        <p>{{sponsor.title}}</p><img class="right-icon" src="@/assets/newImages/common/navWap/title-icon.png" alt="">
                                        <div class="sponsor-one-img-bg"></div>
                                    </div>
                                    <div class="sponsor-logo-list">
                                        <div class="sponsor-logo-main">
                                            <div class="sponsor-logoOne" v-for="(sponsorLogoList, key) in sponsor.sponsorOne" :key="key" >
                                                <div class="sponsorLogo" v-for="(logo, key) in sponsorLogoList" :key="key" @click="clickPartner(logo.url, logo.title)">
                                                    <img :src="logo.coverImageRealPath"/>
                                                </div>
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tishi">*以上排名不分先后</div>
                    </div>
                    <div class="more" @click="goPath('/partner', '生态伙伴')"><p>查看更多</p>
                    <div class="img"><img src="@/assets/newImages/home/icon-more1.png" alt=""></div></div>
                </div>
                <div class="page11" v-if="showNavPic" id="wonderfulPic">
                    <div class="page-title"><p>精彩图集</p></div>
                    <div class="hot-top-button">
                        <div class="hot-left" :class="{'hot-left-active':isLeftScroll==true}" @click="scrollLeft()"><img src="@/assets/newImages/home/icon-left.png" alt=""></div>
                        <div class="hot-right" :class="{'hot-right-active':isRightScroll==true}" @click="scrollRight()"><img src="@/assets/newImages/home/icon-right.png" alt=""></div>
                    </div>
                    <div class="page11-main" id="page11Content5" @touchmove="getPage11Content()">
                        <div class="page11-content">
                            <div class="left" id="page11Content1"><img :src="wonderfulPic.firstImg" alt=""></div>
                            <div class="right" id="page11Content2">
                                <div class="right-top">
                                    <img  v-for="(item,index) in wonderfulPic.list" :key="index" :src="item" alt="">
                                </div>
                                <div class="right-top">
                                    <img  v-for="(item,index) in wonderfulPic.list2" :key="index" :src="item" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page12" v-if="showNavWords" id="wonderfulWords">
                    <div class="page-title"><p>大咖观点</p></div>
                    <div class="page12-icon" style="display:none"><img src="@/assets/newImages/wap/home/page8-icon.png" alt=""></div>
                    <div class="swiper-container swiper-page12" >
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="(item,key) in twinsList" :key="key">
                                <div class="people-div">
                                    <div class="img"><img src="@/assets/newImages/home/guest/twins-wap-img.png" alt=""></div>
                                    <div class="people-img"><img :src="item.coverImageRealPath" alt=""></div>
                                </div>
                                <div class="name-div">
                                    <p class="name">{{item.guestName}}</p><p class="post">{{item.guestDuty}}</p>
                                    <div class="show">
                                        <div class="show-img"><img src="@/assets/newImages/home/guest/twins-icon.png" alt=""></div>
                                        <p class="detail">{{item.summary}}</p> 
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-button-next"><img src="@/assets/newImages/home/icon-right.png" alt=""></div>
                        <div class="swiper-button-prev"><img src="@/assets/newImages/home/icon-left.png" alt=""></div>
                    </div>
                </div>
                <div class="page7" v-if="showNavVideo" id="video" @click="hideAllQr">
                    <div class="page7-icon"><img src="@/assets/newImages/wap/home/page7-icon2.png" alt=""></div>
                    <div class="page-title"><p>精彩视频</p></div>
                    <div class="page7-content">
                        <div class="slider-right"></div>
                        <div class="slider-page">
                            <div class="swiper-slide" v-for="(video, key) in videoListWap" :key="key">
                                <div class="slide-img" @click.stop="showVideoToast(video, video.title)">
                                    <img :src="video.coverImageRealPath" alt="">
                                    <div class="bg">
                                        <img src="@/assets/newImages/home/video.png" alt="">
                                    </div>
                                    <p>{{video.title}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="more"  @click.stop="goPath('/video', '精彩视频')"><p>查看更多</p>
                    <div class="img"><img src="@/assets/newImages/home/icon-more1.png" alt=""></div></div>
                </div>
                <div class="page13" v-if="showNavDownload" id="files">
                    <div class="page13-icon"><img src="@/assets/newImages/wap/home/page8-icon2.png" alt=""></div>
                    <div class="page-title"><p>资料中心</p></div>
                    <div class="files-content">
                        <div class="files-three">
                            <div class="files-three-one flexCenter" v-for="(filesOne,key) in filesTabNav" :key="key" :class="{'files-one-active':key==fileOneTab}" @click="filesTabNavThree(key)">
                                <p>{{filesOne.title}}</p><span class="right-line"></span><span class="line"></span>
                            </div>
                        </div>
                        <div class="files-list" >
                            <div class="files-nav" v-if="fileOneTab==2">
                                <div class="files-nav-one" v-for="(twoTab, key) in hallList" :key="key" :class="filesTabTwoNav === key ? 'files-nav-one-active':''" @click="filesTabTwoChoose(key)">{{twoTab.cateName}}</div>
                            </div>
                            <div class="files-main1" v-if="fileOneTab==2">
                                <div class="files-main1-content" v-on:mouseenter="disableMouseWheel()" v-on:mouseleave="enableMouseWheel()" >
                                    <div class="filesTwo-one" v-for="(item, key) in filesListTwo" :key="key">
                                        <div class="title" :class="{'title-active':item.isShow==true}" @click="filesListTwoShow(key)">
                                            <div class="title-left"><span class="line"></span><p>{{item.title}}</p></div>
                                            <div class="right-icon" :class="{'right-icon-bottom':item.isShow==true}"><img src="@/assets/newImages/parnter/title-icon2.png" alt=""></div>
                                        </div>
                                        <div class="filesTwo-one-main" :class="{'filesTwo-one-main-active':item.isShow==true}">
                                            <div class="filesTwo-oneItem" v-for="(list, index) in item.fileList" :key="index" >
                                                <div class="left-one">
                                                    <div class="left-img"><img src="@/assets/newImages/personal/collection-img.png" alt=""></div>
                                                    <p>{{list.name}}</p>
                                                </div>
                                                <div class="right-one">
                                                    <!-- loading-div-active按钮变灰 -->
                                                    <div class="loading-div" @click.stop="preview(list)">
                                                        <div class="img"><img src="@/assets/newImages/exhibitionGuide/main-one-img3.png" alt=""></div>
                                                        <div class="img"><img src="@/assets/newImages/agenda/icon1.png" alt=""></div>
                                                        <p>在线预览</p>
                                                    </div>
                                                    <div class="loading-div loading-div2" @click.stop="download(list)">
                                                        <div class="img"><img src="@/assets/newImages/exhibitionGuide/main-one-img2.png" alt=""></div>
                                                        <div class="img"><img src="@/assets/newImages/agenda/icon2.png" alt=""></div>
                                                        <p>资料下载 </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="files-main1 files-main2" v-if="fileOneTab==0">
                                <div class="files-main1-content" v-on:mouseenter="disableMouseWheel()" v-on:mouseleave="enableMouseWheel()" >
                                    <div class="filesTwo-one" v-for="(item, key) in zipTopicFileList" :key="key">
                                        <div class="title title-active">
                                            <div class="title-left"><span class="line"></span><p>{{item.title}}</p></div>
                                        </div>
                                        <div class="filesTwo-one-main filesTwo-one-main-active">
                                            <div class="filesTwo-oneItem" v-for="(list, index) in item.fileMain" :key="index" >
                                                <div class="left-one">
                                                    <div class="left-img"><img src="@/assets/newImages/common/like-img3-icon.png" alt=""></div>
                                                    <p>{{list.name}}</p>
                                                </div>
                                                <div class="right-one">
                                                    <div class="loading-div" @click.stop="preview(list)">
                                                        <div class="img"><img src="@/assets/newImages/exhibitionGuide/main-one-img3.png" alt=""></div>
                                                        <div class="img"><img src="@/assets/newImages/agenda/icon1.png" alt=""></div>
                                                        <p>在线预览</p>
                                                    </div>
                                                    <div class="loading-div loading-div2" @click.stop="download(list)">
                                                        <div class="img"><img src="@/assets/newImages/exhibitionGuide/main-one-img2.png" alt=""></div>
                                                        <div class="img"><img src="@/assets/newImages/agenda/icon2.png" alt=""></div>
                                                        <p>资料下载 </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="files-main1 files-main3" v-if="fileOneTab==1">
                                <div class="files-main1-content" v-on:mouseenter="disableMouseWheel()" v-on:mouseleave="enableMouseWheel()" >
                                    <div class="filesTwo-one" v-for="(item, key) in zipSpecialList" :key="key">
                                        <div class="title" :class="{'title-active':item.isShow==true}" @click="filesListOneShow(key)">
                                            <div class="title-left"><span class="line"></span><p>{{item.title}}</p></div>
                                            <div class="right-icon" :class="{'right-icon-bottom':item.isShow==true}"><img src="@/assets/newImages/parnter/title-icon2.png" alt=""></div>
                                        </div>
                                        <div class="filesTwo-one-main" :class="{'filesTwo-one-main-active':item.isShow==true}">
                                            <div class="filesTwo-oneItem" v-for="(list, index) in item.specialMain" :key="index" >
                                                <div class="left-one">
                                                    <div class="left-img"><img src="@/assets/newImages/common/like-img3-icon.png" alt=""></div>
                                                    <p>{{list.name}}</p>
                                                </div>
                                                <div class="right-one">
                                                    <div class="loading-div" @click.stop="specialPreview(list)">
                                                        <div class="img"><img src="@/assets/newImages/exhibitionGuide/main-one-img3.png" alt=""></div>
                                                        <div class="img"><img src="@/assets/newImages/agenda/icon1.png" alt=""></div>
                                                        <p>在线预览</p>
                                                    </div>
                                                    <div class="loading-div loading-div2" @click.stop="specialDownload(list)">
                                                        <div class="img"><img src="@/assets/newImages/exhibitionGuide/main-one-img2.png" alt=""></div>
                                                        <div class="img"><img src="@/assets/newImages/agenda/icon2.png" alt=""></div>
                                                        <p>资料下载 </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="more"  @click.stop="goPath('/files', '资料下载')"><p>查看更多</p>
                    <div class="img"><img src="@/assets/newImages/home/icon-more1.png" alt=""></div></div>
                </div>
                <div class="page8" id="guide" @click="hideAllQr">
                    <div class="page-title"><p>参会指南</p></div>
                    <!-- <div class="page8-icon"><img src="@/assets/newImages/wap/home/page8-icon2.png" alt=""></div> -->
                    <div class="page8-content">
                        <div class="con-map" @click="clickMap()"><img src="@/assets/newImages/wap/home/page8-bg11.jpg" alt=""></div>
                        <!-- <div class="con-msg" @click="clickMap()">
                            <div class="msg-img"><img src="@/assets/newImages/wap/home/page8-bg2.png" alt=""></div>
                            <p class="title">深圳会展中心</p>
                            <p class="address">广东省深圳市福田区福华三路与金田路交叉口</p>
                        </div>-->
                    </div>
                    <div class="more" @click="goPath('/guide', '参会指南')"><p>查看更多</p>
                    <div class="img"><img src="@/assets/newImages/home/icon-more1.png" alt=""></div></div>
                    <div class="applet"><img src="@/assets/newImages/wap/home/page8/applet.png"></div>

                </div>
            </div>
            <!-- 底部 -->
            <div class="footer" @click="hideAllQr">
                <div class="ticket">
                    <p>票务问题</p>
                    <p>门票、酒店、机票、IT系统咨询</p>
                    <p>+86 0755-28565555</p>
                </div>
                <div class="keep">
                    <p>关注我们</p>
                    <div class="logos">
                        <div class="img" @click.stop="showWxQr">
                            <img src="@/assets/newImages/home/icon-weixin.png" alt="">
                            <div v-if="showWxQrcode" class="icon-weixin">
                                <img src="@/assets/newImages/common/wxqrcode.jpg">
                                <div class="sanjiao"></div>
                            </div>
                        </div>
                        <div class="img" @click.stop="showAppQr">
                            <img src="@/assets/newImages/home/icon-app.png" alt="">
                            <div v-if="showAppQrcode" class="icon-weixin">
                                <img src="@/assets/newImages/common/appqrcode.png">
                                <div class="sanjiao"></div>
                            </div>
                        </div>
                        <div class="img" @click="clickWeibo"><img src="@/assets/newImages/home/icon-weibo.png" alt=""></div>
                    </div>
                    <p><a @click="clickContactus">联系我们</a> | <a @click="clickLegal">法律声明</a> | <a @click="clickPrivacy">隐私保护</a></p>
                    <p>版权所有 © 华为技术有限公司 1998-2021</p>
                </div>
            </div>
            <registerPop :registerPop="registerPop" @registerPopClose="registerPopClose" @goRegister="goRegister"></registerPop>
        </div>
        <downloadFilePop :downloadFilePop="downloadFilePop" :downloadFilePopMsg="downloadFilePopMsg" @closeDownLoadPop="closeDownLoadPop" @sendEmail="sendEmail"></downloadFilePop>
        <downloadFileSuccessPop :downloadFileSuccessPop="downloadFileSuccessPop" @downloadFilePopClose="downloadFilePopClose"></downloadFileSuccessPop>
    </div>
</template>
<script>
    import wx from 'weixin-js-sdk';
    import config from '../config'
    import api from '../api'
    import mixin from 'utils/mixin'
    import {formatDateTime} from 'utils/index'
    import common from '../utils/common'
    import so from '../utils/so_event'
    import Swiper from 'swiper'
    // import GuestModalNew from 'components/guest-modal-new';
    import BackToTop from 'components/BackToTop'
    import Scroll from 'components/scroll'
    import {getFileList, downloadWithEmail} from "../api/file";
    import TimeAddress from 'components/TimeAddress'
    import vns from 'components/Vns.js'
    import toClue from 'components/toClue'
    import {CountUp} from 'utils/countUp'
    import Carousel from 'vue-owl-carousel'
    import { constructData, timestampToYear, timestampToMonth, timestampToDay, timestampToHours, delUrlParams, goSignup, sortKey, previewFile, getTime, goVhall, cnWordSort } from '@/utils/tool'
    import videoModel from 'components/video-modal'
	// import registerPop from "components/registerPop"
	import loading from 'components/loading';
    import registerPop from 'components/registerPop';
    import downloadFilePop from 'components/downloadFilePop';
    import downloadFileSuccessPop from 'components/downloadFileSuccessPop';
    import guessLike from 'components/guessLike';

    var TempPartnerArticleCategoryList = [];//生态伙伴临时变量

    export default {
        metaInfo: {
            title: config.pageTitle, // set a title
            meta: [{             // set meta
                    name: 'keyWords',
                    content: config.pageKeywords
                },
                {
                    name: 'description',
                    content: config.pageDescription
                }],
        },
        components: {
            // GuestModalNew,
            Scroll,
            BackToTop,
            TimeAddress,
            vns,
            toClue,
            Carousel,
            videoModel,loading,registerPop,
            downloadFilePop, downloadFileSuccessPop,
            guessLike
        },
        mixins: [mixin],
        name: "index",
        computed:{
            showNavAgendaDesc(){
                return this.$store.state.showControl.showNavAgendaDesc;
            },
            showNavAgendaList(){
                return this.$store.state.showControl.showNavAgendaList;
            },
            showNavHall(){
                return this.$store.state.showControl.showNavHall;
            },
            showNavNews(){
                return this.$store.state.showControl.showNavNews;
            },
            // showNavTwins(){
            //     return this.$store.state.showNavTwins;
            // },
            showNavPartner(){
                return this.$store.state.showControl.showNavPartner;
            },
            showNavVideo(){
                return this.$store.state.showControl.showNavVideo;
            },
            orderOnline(){
                return this.$store.state.orderOnline;
            },
            orderOffline(){
                return this.$store.state.orderOffline;
            },
            isStudent(){
                return this.$store.state.isStudent;
            },
            showNavGuest(){
                return this.$store.state.showControl.showNavGuest;
            },
            showNavPic(){
                return this.$store.state.showControl.showNavPic;
            },
            showNavWords(){
                return this.$store.state.showControl.showNavWords;
            },
            showNavDownload(){
                return this.$store.state.showControl.showNavDownload;
            },
            showIconCollect(){
                return this.$store.state.showControl.showIconCollect;
            },
            showIconLive(){
                return this.$store.state.showControl.showIconLive;
            },
            userLogin(){
                return this.$store.state.userLogin;
            },
            liveStatus(){
                return this.$store.state.liveStatus;
            },
            orderStop(){
                return this.$store.state.orderStop;
            },
        },
        watch:{
        },
        data(){
            return {
                width:document.documentElement.clientWidth,
                isPc: document.documentElement.clientWidth > 750 ? true : false,
                isIe: !!window.ActiveXObject || "ActiveXObject" in window?true:false,
                page1Text:"",
                page1Address:"",
                agendaName: "",
                richText:"",
                agendaThemeActive:0,
                agendaThemeActiveLeft:0,
                agendaThemeActiveRight:0,
                likeLists:[],
                // 导航栏
                navList: [
                    { content: "首页", type: 1, path:"/"},
                    { content: "大会介绍", type: 1, path:"/desc"},
                    { content: "大会议程", type: 1, path:"/agenda" },
                    { content: "展厅导览", type: 1, path:"/guide" },
                    { content: "热门资讯", type: 1, path:"/news" },
                    { content: "生态伙伴", type: 1, path:"/partner"},
                    // { content: "大咖观点", type: 1, path:"/twins"},
                    { content: "精彩视频", type: 1, path:"/video"},
                    { content: "参会指南", type: 1, path:"/exhibition"},
                ],
                requestFinishNum: 0,
                slideHash: '/home',
                slideIndex:0,
                agendaYearDay:[{day:"05.17"},{day:"05.18"}],
                dayIndex:0,
                agendaDayNav:[{title:"主题演讲"},{title:"专题演讲"},{title:"开放演讲"}],
                agendaDayNavOne:0,
                // 日程数据
                agenda: [],
                agendaSpeechList:[],
                topicAgendaChild: [],
                // 展览数据
                dataReviewList:[
                    {num:3,numText:"大",title:'展馆',info:"以三元协同，共创数字化转型价值为设计理念，大会专设生态馆、产业馆、行业馆三大展馆。"},
                    {num:25000,numText:"㎡",title:'展区',info:"展示总面积超过25000㎡，其中专设10000㎡生态馆，精彩呈现多型伙伴能力。"},
                    {num:300,numText:"+",title:'伙伴',info:"300+生态伙伴聚合，其中100+伙伴赞助展示，200+伙伴联合展示。"},
                    {num:700,numText:"+",title:'体验点',info:"展示内容覆盖40+子行业及20+子产品，共700+互动体验点。"}
                ],
                // 资讯数据
                hotNewsList:[],
                hotNewsBar: [],
                hotNewsListWap: false,
                hotNewsTab:0,
                // 伙伴数据
                sponsorSpecial: {title1: '',title2: '', name: '', image: '', url: ''},
                sponsorList:[],
                sponsorShow:0,
                // 视频数据
                videoList:[],
                videoListWap:[],
                VideoTab:0,
                videoToastUrl: '',
                pageCover:false,
                pageCoverVideo:false,
                disableMousewheelControl: false,
                agendaTopicBar: {},
                agendaSpecialBar: {},
                agendaOpenBar: {},
                swiperPage: false,
                showWxQrcode: false,
                showAppQrcode: false,
                showLoading:true,//加载弹窗
                guestList:[],
                guestListTab:0,
                guestOneActive:-1,
                guestWapList:[],
                exhibitionList:[
                    {
                        bgImg:require('@/assets/newImages/home/guest/exhibition-bg3.png'),
                        bgImgWap:require('@/assets/newImages/home/guest/exhibition-wap-bg3.png'),
                        img:require('@/assets/newImages/home/guest/exhibition-icon3.png'),
                        title:"生态馆",text:"1展厅"
                    },
                    {
                        bgImg:require('@/assets/newImages/home/guest/exhibition-bg1.png'),
                        bgImgWap:require('@/assets/newImages/home/guest/exhibition-wap-bg1.png'),
                        img:require('@/assets/newImages/home/guest/exhibition-icon1.png'),
                        title:"产业馆",text:"3展厅"
                    },
                    {
                        bgImg:require('@/assets/newImages/home/guest/exhibition-bg2.png'),
                        bgImgWap:require('@/assets/newImages/home/guest/exhibition-wap-bg2.png'),
                        img:require('@/assets/newImages/home/guest/exhibition-icon2.png'),
                        title:"行业馆",text:"4展厅"
                    },
                ],
                twinsList:[],
                atlasListTab:0,
                requestOrderAgenda: false,
                requestCancelAgenda: false,
                isLeftScroll:false,//精彩图集左滑
                isRightScroll:true,//精彩图集右滑
                isLeftScrollPc:false,
                isRightScrollPc:true,
                wonderfulPic:{
                    firstImg: '',
                    list: [],
                    list2: [],
                },
                registerPop: false,
                wapTopicOrder: false,
                wapTopicLiveStatus: false,
                filesTabNav:[{title:'主题演讲'},{title:'专题演讲'},{title:'展区'}],
                fileOneTab:0,
                filesTabTwo:[{title:'生态馆'},{title:'产业馆'},{title:'行业馆'},],
                filesTabTwoNav:0,
                filesListTwo:[],
                hallList: [],
                isRecommend: false,
                zipSpecialList: [],
                zipSpecialListOri: {},
                specialFilesRequest: false,
                hallListRequest: false,
                topicFilesRequest: false,
                zipTopicFileList: [],
                downloadFilePop: false,
                downloadFilePopMsg: '',
                downloadFileSuccessPop: false,
                downloadFileId: [],
                emailRequest: false,
                getAgendaRequest: false,
                slideBrevieryIndex:0,
                liveLists:[
                    {
                        name: '',
                        content: []
                    },
                    {
                        name: '',
                        content: []
                    },
                ],
                vhallStatus: [],
                vhallStatusTimeGuardId: 0,
                mainLiveUrl: '',
                mainLiveIframeUrl: '',
                mainLiveTitle: '',
                mainLiveStatus: 0,
                mainLiveList:[],
                vhallIds: [],
                liveIndex:0,
                liveLeftIndex:22,
                liveLeftIndexItem:'',
                slideBrevieryList:[{imgBig:require('@/assets/newImages/wap/home/page4/exhibition-big1.png'),img:require('@/assets/newImages/wap/home/page4/exhibition-img1.png'),title:'生态馆'},{imgBig:require('@/assets/newImages/wap/home/page4/exhibition-big2.png'),img:require('@/assets/newImages/wap/home/page4/exhibition-img2.png'),title:'产业馆'},{imgBig:require('@/assets/newImages/wap/home/page4/exhibition-big3.png'),img:require('@/assets/newImages/wap/home/page4/exhibition-img3.png'),title:'行业馆'}]
            }
        },
        created(){
            if(this.userLogin){
                this.getMyOrderAgendaList();
            }else{
                this.getAgendaList();
            }
            this.getSeminarInfo();
            this.getNewsList();
            this.getPartnerList();
            this.getVideoList();
            this.getWonderfulWords();
            this.getWonderfulPic();
            this.getGuestList();
            this.getExtHall();
            this.liveLists.forEach(listOne=>{
                listOne.content.forEach(item=>{
                    item.lists.forEach(one=>{
                        if(one.id==this.liveLeftIndex){
                            this.liveLeftIndexItem=one
                        }
                    })
                })
            })
        },
        mounted(){
            let self = this;
            this.$nextTick(() => {
                if(this.isPc){
                    this.initSwiper();
                }else{
                    // setTimeout(function(){
                    //     self.checkHash();
                    // }, 200);
                }
                self.showLoading = false;
                // self.initSwiper9();
                self.initSwiperBreviery()
            })
        },
        beforeDestroy(){
            if(this.vhallStatusTimeGuardId){
                window.clearTimeout(this.vhallStatusTimeGuardId);
            }
        },
        methods:{
            getSeminarInfo(){
                let that = this;
                api.getNewSubSeminarInfo()
                .then(res=>{
                    let info = this.$store.state.cache.seminarInfo;
                    that.page1Address = info.address.substr(3, info.address.length - 2);
                    that.richText = info.desc;
                    let timeStr = timestampToYear(info.startTime) + '年';
                    timeStr +=  '' + timestampToMonth(info.startTime) + '月';
                    timeStr +=  '' + timestampToDay(info.startTime) + '日';
                    timeStr +=  '-' + timestampToDay(info.endTime) + '日';
                    that.page1Text = timeStr;
                    that.agendaName = info.title;
                    that.reqeustBack();
                })
                .catch(err=>{
                    that.reqeustBack();
                    that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                });
            },
            initSwiper(){
                let self = this;
                this.swiperPage = new Swiper(".swiper-page", {
                    direction: "vertical",
                    speed: 880,
                    initialSlide: 0,
                    mousewheel: true,
                    mousewheelControl: true,
                    touchMoveStopPropagation: false,
                    noSwiping : true,
                    noSwipingClass : 'no-scroll',
                    simulateTouch: false, //禁止鼠标模拟
                    // onSlideChangeStart: function(swiper) {
                    //     self.slideIndex = swiper.activeIndex;
                    //     self.slideHash = swiper.slides[swiper.activeIndex].id;
                    // },
                    on: {
                        slideChangeTransitionStart: function(){
                            self.slideIndex = self.swiperPage.activeIndex;
                            self.slideHash = self.swiperPage.slides[self.swiperPage.activeIndex].id;
                            self.disableMouseWheel();
                        },
                        slideChangeTransitionEnd: function(){
                            setTimeout(function(){
                                self.enableMouseWheel();
                            }, 300)
                        }
                    }
                });
                // this.disableMouseWheel();
                this.checkHash();
            },
            initSwiper9(){
                let self = this;
                var width1=self.width*0.074;
                var width2=self.width*0.045;
                this.swiperPage9 = new Swiper(".swiper-page9", {
                    speed: 880,
                    initialSlide: 0,
                    // slidesOffsetBefore :width1,
                    spaceBetween :width2,
                    centeredSlides :false,
                    slidesPerView:'auto',
                    // slidesPerView:2,
                    loop:true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    on:{
                        init:function(swiper){
                            // this.setTranslate(0)
                        },
                        transitionStart(){
                            // if(this.activeIndex==1){this.setTranslate(0)}
                            // if(this.activeIndex==0){this.setTranslate(0)}
                        },
                    }
                })
            },
            initSwiperBreviery(){
                let self = this;
                this.swiperBreviery = new Swiper(".swiper-breviery", {
                    speed: 880,
                    mousewheel: true,
                    mousewheelControl: true,
                    on:{
                        slideChangeTransitionEnd:function() {
                            self.slideBrevieryIndex = this.activeIndex;
                        }
                    }
                })
            },
            chooseBrevieryIndex(index){
                this.swiperBreviery.slideTo(index, 900, true);
            },
            initSwiperTwins(){
                let self = this;
                this.swiperPageTwins = new Swiper(".twins-content", {
                    speed: 880,
                    slidesPerView :"auto",
                    navigation: {
                        nextEl: '.twins-next',
                        prevEl: '.twins-prev',
                    },
                })
            },
            initSwiper12(){
                let self = this;
                var width2=self.width*0.045;
                this.swiperPage12 = new Swiper(".swiper-page12", {
                    speed: 880,
                    spaceBetween :width2,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                })
            },
            reInitSwiper(){
                if(this.swiperPage){
                    this.swiperPage.init();
                }
            },
            reqeustBack(){
                if(this.isPc){
                    return;
                }

                this.requestFinishNum = this.requestFinishNum + 1;
                let that = this;
                if(this.requestFinishNum == 8){
                    this.$nextTick(() => {
                            // this.reInitSwiper();
                            // this.enableMouseWheel();
                            // this.requestFinishNum = 0;
                            this.checkHash();
                    })
                }
            },
            checkHash(){
                let that = this;
                let hash = localStorage.getItem('eco_2021_index_hash');
                if(hash && hash != 'false'){
                    if(this.isPc){
                        let toIndex = 0, data=this.swiperPage.slides;
                        for(let key in data){
                            if(data[key].id == hash){
                                toIndex = key;
                            }
                        }
                        setTimeout(function(){
                            that.swiperPage.slideTo(toIndex, 900, true);
                        }, 200);
                    }else{
                        let id = hash.replace('/', '#');
                        that.$nextTick(()=>{
                            document.querySelector(id).scrollIntoView({
                                    behavior: "smooth", // 平滑过渡
                                    block: "center" // 上边框与视窗顶部平齐
                                });
                            // setTimeout(function(){
                                
                            // }, 300)
                        })
                    }
                    localStorage.setItem("eco_2021_index_hash", false);
                }
            },
            // 左侧跳转
            goSlide(path, name=''){
                if(this.isPc){
                    let toIndex = 0, data=this.swiperPage.slides;
                    for(let key in data){
                        if(data[key].id == path){
                            toIndex = key;
                        }
                    }
                    this.swiperPage.slideTo(toIndex, 900, true);
                }
                
                return;
            },
            // 路由跳转
            goPath(path, name=''){
                if(path == '/' || path == '/desc' || path == '/wonderfulPic' || path == '/wonderfulWords'){
                    return;
                }else{
                    // 埋码
                    this.$maima.index_check_more_all_click(name);

                    this.$router.push({
                        path: path
                    });
                }
                return;
            },
            clickRightCantactUs(){
                this.pageCover = true;

                // 埋码
                this.$maima.index_contact_us_click();
            },
            clickOnlineHall(){
                // 埋码
                this.$maima.exhibition_tab_click();

                window.location.href = window.$config.url.onlineHall;

            },
            clickFeedback(){
                window.open(config.url.feedback);

                // 埋码
                this.$maima.index_feedback_btn_click();
                return;
            },
            clickConsult(){
                window.open(config.url.consult);

                // 埋码
                this.$maima.index_consultation_btn_click();
                return;
            },
            closePageCover(){
                this.pageCover = false;
            },
            clickMap(){
                window.open(config.url.baiduMap);
                return;
            },
            clickWeibo(){
                window.open(config.url.weibo);
                return;
            },
            clickContactus(){
                window.open(config.url.contactus);
                return;
            },
            clickLegal(){
                window.open(config.url.legal);
                return;
            },
            clickPrivacy(){
                // window.open(config.url.privacy);
                window.open(config.url.self + '/privacy');
                return;
            },
            disableMouseWheel(){
                if(!this.swiperPage){
                    return;
                }
                if(this.disableMousewheelControl){
                    return;
                }else{
                    this.disableMousewheelControl = true;
                    // this.swiperPage.disableMousewheelControl();
                    this.swiperPage.mousewheel.disable();
                }
            },
            enableMouseWheel(){
                if(!this.swiperPage){
                    return;
                }
                if(! this.disableMousewheelControl){
                    return;
                }else{
                    this.disableMousewheelControl = false;
                    // this.swiperPage.enableMousewheelControl();
                    this.swiperPage.mousewheel.enable();
                }
            },
            // 议程
            getAgendaList(){
                let that = this;
                api.getNewSubSeminarList()
                .then(res=>{
                    if(res){
                        // try{
                            
                        // }catch(e){
                        //     console.log('getAgendaList catch', e);
                        // }

                        that.agenda = res;
                        that.agendaSpeechList = res.first.topic;
                        that.getAgendaRequest = true;
                        that.initAgendaBarData(true);
                        that.initTopicAgendaRightData();
                        that.getTopicFiles(res);
                        that.getSpecialFiles(res);
                        that.initRecommend();
                        that.initLiveData();
                        

                        that.$nextTick(()=>{
                            let currentTime = getTime();
                            if(currentTime > 1621224000 && currentTime < 1621267200){
                                that.chooseDayNav(1);
                            }else if(currentTime > 1621267200 && currentTime < 1621310400){
                                that.chooseDay(1);
                            }else if(currentTime > 1621310400 && currentTime < 1621353600){
                                that.chooseDay(1);
                                that.chooseDayNav(1);
                            }
                        })
                    }
                    that.reqeustBack();
                })
                .catch(err=>{
                    that.reqeustBack();
                    that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                });
            },
            /// 获取主题演讲议程文件
            getTopicFiles(res){
                if(!this.showNavDownload){
                    return;
                }

                let that = this;

                let data = [];
                if(res.first.topic.length>0){
                    data.push({
                        title: res.first.topic[0].name,
                        fileShow: false,
                        fileMain: [],
                    });
                }
                if(res.second.topic.length>0){
                    res.second.topic.map(item=>{
                        data.push({
                            title: item.name,
                            fileShow: false,
                            fileMain: [],
                        });
                    });
                }
                that.zipTopicFileList = data;

                // 17日
                api.getFileFolder(window.$config.files.topic17FolderId)
                .then(res=>{
                    that.zipTopicFileList[0].fileMain = sortKey(res, 'order');
                })
                .catch(err=>{
                    that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                });

                // 18日-1
                api.getFileFolder(window.$config.files.topic181FolderId)
                .then(res=>{
                    that.zipTopicFileList[1].fileMain = sortKey(res, 'order');
                })
                .catch(err=>{
                    that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                });

                // 18日-2
                api.getFileFolder(window.$config.files.topic182FolderId)
                .then(res=>{
                    that.zipTopicFileList[2].fileMain = sortKey(res, 'order');
                    that.topicFilesRequest = true;
                    that.initRecommend();
                })
                .catch(err=>{
                    that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                });
            },
            // 获取专题演讲议程文件
            getSpecialFiles(res){
                if(!this.showNavDownload){
                    return;
                }

                if(this.specialFilesRequest){
                    return;
                }

                this.specialFilesRequest = true;
                let subSeminarIds = [];
                let special = {};
                res.first.special.map(item=>{
                    subSeminarIds.push(item.subSeminarId);
                    special[item.subSeminarId] = item;
                    // item.agendaListData.map(childItem=>{
                    //     subSeminarIds.push(childItem.agendaId);
                    // });
                });
                res.second.special.map(item=>{
                    subSeminarIds.push(item.subSeminarId);
                    special[item.subSeminarId] = item;
                    // item.agendaListData.map(childItem=>{
                    //     subSeminarIds.push(childItem.agendaId);
                    // });
                });
                let that = this;
                api.querySpecialTopicFiles(subSeminarIds)
                .then(res=>{
                    if(res.result == 0){
                        let data = res.content.content;
                        let specialList = [];
                        for(let key in data){
                            specialList.push({
                                title: special[key].name,
                                order: special[key].i_subSeminarOrder,
                                isShow: false,
                                specialMain: data[key],
                            });
                        }
                        specialList = sortKey(specialList, 'order');
                        specialList[0].isShow = true;
                        that.zipSpecialList = specialList;
                        that.zipSpecialListOri = data;
                    }
                    that.initRecommend();
                })
                .catch(err=>{
                });
            },
            clickTopicAgendaLeft(key){
                this.agendaThemeActive = key;
                if(this.dayIndex == 0){
                    this.agendaThemeActiveLeft = key;
                }else if(this.dayIndex == 1){
                    this.agendaThemeActiveRight = key;
                }

                if(!this.isPc){
                    let agenda = this.getClickTopicItem();
                    if(agenda.m_vhallLiveId){
                        this.wapTopicLiveStatus = true;
                    }else{
                        this.wapTopicLiveStatus = false;
                    }
                    if(this.userLogin){
                        if(this.$store.state.myData.myOrderAgendaList.indexOf(agenda.subSeminarId) != -1){
                            this.wapTopicOrder = true;
                        }else{
                            this.wapTopicOrder = false;
                        }
                    }
                }

                this.setTopicAgendaRight(this.agendaSpeechList[key]);
            },
            setAgendaBar(item, init=false){
                if(!this.isPc){
                    let agenda = this.getClickTopicItem();
                    if(agenda.m_vhallLiveId){
                        this.wapTopicLiveStatus = true;
                    }else{
                        this.wapTopicLiveStatus = false;
                    }
                    if(this.userLogin){
                        if(this.$store.state.myData.myOrderAgendaList.indexOf(agenda.subSeminarId) != -1){
                            this.wapTopicOrder = true;
                        }else{
                            this.wapTopicOrder = false;
                        }
                    }
                }
                if((this.dayIndex == 0 || this.dayIndex == 1) && this.agendaDayNavOne == 0 && !init){
                    return;
                }else if(item.categoryArr.indexOf('主题演讲') != -1){
                    this.agendaTopicBar = this.agendaTopicBarDataFormat(item);
                }else if(item.categoryArr.indexOf('专题演讲') != -1){
                    this.agendaSpecialBar = this.agendaBarDataFormat(item);
                }else if(item.categoryArr.indexOf('开放演讲') != -1){
                    this.agendaOpenBar = this.agendaBarDataFormat(item);
                }else{
                    return;
                }
            },
            agendaTopicBarDataFormat(item){
                let data;
                if(this.dayIndex == 0){
                    data = this.agenda.first.topic;
                }else{
                    data = this.agenda.second.topic;
                }
                let temp = {
                    startTime: '',
                    startTime_zh: '',
                    endTime: '',
                    endTime_zh: '',
                    name: '',
                    hotel: '',
                };
                if(item){
                    let firstData = data.slice(0, 1)[0];
                    let endData = data.slice(-1)[0];
                    temp.startTime = firstData.startTime_h_m;
                    temp.startTimeWordArr = firstData.startTime_h_m.split('');
                    temp.startTime_zh = firstData.startTimeStr.substring(11, 13) > 12 ? "下午" : "上午";
                    temp.endTime = endData.endTime_h_m;
                    temp.endTimeWordArr = endData.endTime_h_m.split('');
                    temp.endTime_zh = endData.endTimeStr.substring(11, 13) > 12 ? "下午" : "上午";
                    temp.name = item.name;
                    temp.hotel = item.hotel;
                    temp.seminarId = item.seminarId;
                    temp.isOrder = item.isOrder;
                    temp.i_liveurl = item.i_liveurl;
                    temp.m_vhallLiveId = item.m_vhallLiveId;
                }

                return temp;
            },
            agendaBarDataFormat(item){
                let temp = {
                    startTime: '',
                    startTime_zh: '',
                    endTime: '',
                    endTime_zh: '',
                    name: '',
                    hotel: '',
                };
                temp.startTime = item.startTime_h_m;
                temp.startTimeWordArr = item.startTime_h_m.split('');
                temp.startTime_zh = item.startTimeStr.substring(11, 13) > 12 ? "下午" : "上午";
                temp.endTime = item.endTime_h_m;
                temp.endTimeWordArr = item.endTime_h_m.split('');
                temp.endTime_zh = item.endTimeStr.substring(11, 13) > 12 ? "下午" : "上午";
                temp.name = item.name;
                temp.hotel = item.hotel;
                return temp;
            },
            setTopicAgendaRight(item){
                this.topicAgendaChild = item.agendaListData;
            },
            initTopicAgendaRightData(){
                if(this.dayIndex == 0 && this.agendaDayNavOne == 0){
                    if(this.agenda.first.topic.length > 0){
                        this.agendaThemeActive = this.agendaThemeActiveLeft;
                        this.agendaSpeechList = this.agenda.first.topic;
                        this.setTopicAgendaRight(this.agenda.first.topic[this.agendaThemeActive]);
                    }else{
                        this.agendaSpeechList = [];
                    }
                }else if(this.dayIndex == 1 && this.agendaDayNavOne == 0){
                    if(this.agenda.second.topic.length > 0){
                        this.agendaThemeActive = this.agendaThemeActiveRight;
                        this.agendaSpeechList = this.agenda.second.topic;
                        this.setTopicAgendaRight(this.agenda.second.topic[this.agendaThemeActive]);
                    }else{
                        this.agendaSpeechList = [];
                    }
                }else{
                    return;
                }
            },
            initAgendaBarData(init=false){
                if(this.dayIndex == 0){
                    if(this.agenda.first.topic.length > 0){
                        this.setAgendaBar(this.agenda.first.topic[0], init);
                    }
                    if(this.agenda.first.special.length > 0){
                        this.setAgendaBar(this.agenda.first.special[0]);
                    }
                    if(this.agenda.first.open.length > 0){
                        this.setAgendaBar(this.agenda.first.open[0]);
                    }
                }else if(this.dayIndex == 1){
                    if(this.agenda.second.topic.length > 0){
                        this.setAgendaBar(this.agenda.second.topic[0]);
                    }
                    if(this.agenda.second.special.length > 0){
                        this.setAgendaBar(this.agenda.second.special[0]);
                    }
                    if(this.agenda.second.open.length > 0){
                        this.setAgendaBar(this.agenda.second.open[0]);
                    }
                }else{
                    return;
                }
            },
            // 热门资讯
            getNewsList(){
                let that = this;
                api.getNewsList()
                .then(res=>{
                    // let dest = [];
                    // let temp = {
                    //     hotOne: {},
                    //     hotList: []
                    // };
                    // let p = 0;
                    for(let i=0; i<res.length; i++){
                        res[i].pushTimeYear = timestampToYear(res[i].pushTime);
                        res[i].pushTimeDay = timestampToMonth(res[i].pushTime) + '.' + timestampToDay(res[i].pushTime);
                        res[i].summary2 = res[i].summary.length > 64 ? res[i].summary.substr(0, 63) + '...' : res[i].summary;
                        // if(p == 0){
                        //     temp.hotOne = res[i];
                        // }else{
                        //     temp.hotList.push(res[i]);
                        // }
                        // p++;
                        // if(p==4 || i == (res.length - 1)){
                        //     p = 0;
                        //     dest.push(temp);
                        //     temp = {
                        //         hotOne: {},
                        //         hotList: []
                        //     };
                        // }
                    }
                    that.hotNewsList = constructData(res);
                    that.setNewsBar();
                    // that.hotNewsListWap = dest[0]
                    that.reqeustBack();
                })
                .catch(err=>{
                    that.reqeustBack();
                    that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                });
            },
            setNewsBar(item=false){
                if(item){
                    this.hotNewsBar = item;
                }else{
                    this.hotNewsBar = this.hotNewsList[0][0];
                }
            },
            clickNews(url, name, product_tag, industry_tag, index){
                if(url){
                    window.open(url);
                }

                // 埋码
                let newIndex = index == 99 ? 1 : index + 2;
                this.$maima.index_news_btn_click(newIndex, name, product_tag, industry_tag);

                return;
            },
            // 生态伙伴
            getPartnerList(){
                let that = this;
                api.getPartnerList()
                .then(res=>{
                    if(res){
                        let temp = [];
                        let data = res.slice(1, res.length);
                        let firstData = res.slice(0, 1)[0];
                        data.map((item, index)=>{
                            temp.push({
                                bgImg: that.isPc ? require('@/assets/newImages/home/page6-sponsor' + (index + 1) + '.png') : require('@/assets/newImages/wap/home/page6-con-bg' + (index + 1) + '.png'),
                                title: item.name,
                                sponsorOneShow: 0,
                                sponsorOne: that.isPc ? constructData(item.list, 15) : constructData(item.list, 1)
                            });
                        });
                        that.sponsorList = temp;
                        if(!that.isPc){
                            that.sponsorShow = -1;
                        }
                        that.sponsorSpecial = {
                            title1: firstData.name.substr(0,4),
                            title2: firstData.name.substr(4),
                            name: firstData.list[0].title,
                            image: firstData.list[0].coverImageRealPath,
                            url: firstData.list[0].url,
                        };
                    }
                    that.reqeustBack();
                })
                .catch(err=>{
                    that.reqeustBack();
                    that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                });
            },
            clickPartner(url, name=''){

                // 埋码
                this.$maima.index_crowdfunding_partner_sponsor_logo_click(name);
                return;

                if(url){
                    window.open(url);
                }

                return;
            },
            clickSponsorSpecial(url, name=''){
                // 埋码
                this.$maima.index_crowdfunding_partner_sponsor_logo_click(name);
                return;

                window.open(url);
            },
            // 精彩视频
            getVideoList(){
                let that = this;
                api.getWonderfulVideoList()
                .then(res=>{
                    if(res){
                        that.videoList = constructData(res);
                        that.videoListWap = res;
                    }
                    that.reqeustBack();
                })
                .catch(err=>{
                    that.reqeustBack();
                    that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                });
            },
            showVideoToast(url, name){
                this.pageCoverVideo = true;
                this.videoToastUrl = url;

                // if(this.isIe){
                //     this.$nextTick(() => {
                //         document.getElementById('videoPlayerBox').innerHTML = "<embed controls preload='none' class='videoInfo-video' ref='videoref' id='videoPlayer_" + url.id + "' poster='" + url.coverImageRealPath + "' src='" + url.url + "' width='896' height='510' autoplay></embed>";
                //     })
                // }
                
                // 埋码
                this.$maima.index_video_review_click(name);
                return;
            },
            closeVideoToast(){
                this.pageCoverVideo = false;
                this.videoToastUrl = '';
                // if(this.ieIe){
                //     document.getElementById('videoPlayerBox').remove();
                // }
            },
            // 选择日期
            chooseDay(index){
                if(this.dayIndex != index){
                    this.dayIndex = index;
                    if(index == 0){
                        if(this.agendaDayNavOne == 0){
                            // this.agendaSpeechList = this.agenda.first.topic;
                            this.initTopicAgendaRightData();
                        }else if(this.agendaDayNavOne == 1){
                            this.agendaSpeechList = this.agenda.first.special;
                        }if(this.agendaDayNavOne == 2){
                            this.agendaSpeechList = this.agenda.first.open;
                        }
                    }else if(index == 1){
                        if(this.agendaDayNavOne == 0){
                            // this.agendaSpeechList = this.agenda.second.topic;
                            this.initTopicAgendaRightData();
                        }else if(this.agendaDayNavOne == 1){
                            this.agendaSpeechList = this.agenda.second.special;
                        }if(this.agendaDayNavOne == 2){
                            this.agendaSpeechList = this.agenda.second.open;
                        }
                    }
                    this.initAgendaBarData();
                }
                
                // 埋码
                if(this.isPc){
                    this.$maima.index_agenda_tab_click(this.agendaDayNav[this.agendaDayNavOne].title, this.agendaYearDay[index].day);
                }else{
                    this.$maima.index_meeting_agenda_meeting_form_select_click(this.agendaYearDay[index].day);
                }
            },
            // 选择专题
            chooseDayNav(index){
                if(this.agendaDayNavOne != index){
                    this.agendaDayNavOne = index;
                    if(this.dayIndex == 0){
                        if(index == 0){
                            // this.agendaSpeechList = this.agenda.first.topic;
                            this.initTopicAgendaRightData();
                        }else if(index == 1){
                            this.agendaSpeechList = this.agenda.first.special;
                        }if(index == 2){
                            this.agendaSpeechList = this.agenda.first.open;
                        }
                    }else if(this.dayIndex == 1){
                        if(index == 0){
                            // this.agendaSpeechList = this.agenda.second.topic;
                            this.initTopicAgendaRightData();
                        }else if(index == 1){
                            this.agendaSpeechList = this.agenda.second.special;
                        }if(index == 2){
                            this.agendaSpeechList = this.agenda.second.open;
                        }
                    }
                    this.initAgendaBarData();
                }

                // 埋码
                this.$maima.index_agenda_tab_click(this.agendaDayNav[index].title, this.agendaYearDay[this.dayIndex].day);
            },
            // 热门资讯+-
            reduceNum(){
                let self = this;
                if(self.hotNewsTab>0){
                    self.hotNewsTab =self.hotNewsTab-1
                }else{
                    self.hotNewsTab=0
                }
                self.setNewsBar(self.hotNewsList[self.hotNewsTab][0]);
            },
            addNum(){
                let self = this;
                if(self.hotNewsTab<self.hotNewsList.length-1){
                    self.hotNewsTab =self.hotNewsTab+1
                }else{
                    self.hotNewsTab=self.hotNewsList.length-1
                }
                self.setNewsBar(self.hotNewsList[self.hotNewsTab][0]);
            },
            // 精彩视频+-
            prevNum(){
                let self = this;
                if(self.VideoTab>0){
                    self.VideoTab =self.VideoTab-1
                }else{
                    self.VideoTab=0
                }
            },
            nextNum(){
                let self = this;
                if(self.VideoTab<self.videoList.length-1){
                    self.VideoTab =self.VideoTab+1
                }else{
                    self.VideoTab=self.videoList.length-1
                }
            },
            // 切换合作伙伴
            chooseSponsorTab(index, type){
                let self = this;
                if(!self.isPc && index==self.sponsorShow){
                    self.sponsorShow = -1;
                }else{
                    self.sponsorShow = index
                }
                self.sponsorList.forEach((list,index)=>{
                    list.sponsorOneShow =0
                })

                // 埋码
                this.$maima.index_crowdfunding_partner_sponsor_type_click(type);
            },
            // 切换合作伙伴模块，下一页
            reduceSponsorNum(index){
                let self = this;
                var list = self.sponsorList[index]
                if(list.sponsorOneShow>0){
                    self.sponsorList[index].sponsorOneShow =self.sponsorList[index].sponsorOneShow-1
                }else{
                    self.sponsorList[index].sponsorOneShow=0
                }
            },
            addSponsorNum(index){
                let self = this;
                var list = self.sponsorList[index]
                 if(list.sponsorOneShow<list.sponsorOne.length-1){
                    self.sponsorList[index].sponsorOneShow =self.sponsorList[index].sponsorOneShow+1
                }else{
                    self.sponsorList[index].sponsorOneShow =self.sponsorList[index].sponsorOne.length-1
                }
            },
            showWxQr(){
                if(!this.showWxQrcode){
                    this.showWxQrcode = true;
                    this.showAppQrcode = false;
                }
            },
            hideWxQr(){
                if(this.showWxQrcode){
                    this.showWxQrcode = false;
                }
            },
            showAppQr(){
                if(!this.showAppQrcode){
                    this.showAppQrcode = true;
                    this.showWxQrcode = false;
                }
            },
            hideAppQr(){
                if(this.showAppQrcode){
                    this.showAppQrcode = false;
                }
            },
            hideAllQr(){
                this.showWxQrcode = false;
                this.showAppQrcode = false;
            },
            signUp(){

                // 埋码
                this.$maima.index_meetingregister_btn_click(this.agendaName, this.page1Address, this.page1Text);

                // window.open(config.url.signup);
                goSignup('offline', this.$route.query.shareKey);
            },
            orderLive(){

                // 埋码
                this.$maima.index_bookinglive_btn_click(this.agendaName, this.page1Address, this.page1Text);

                if((this.orderOffline == 3 || this.orderOffline == 2 || this.orderOffline == 1) && this.orderOnline == 0){
                    this.$store.commit('setOrderOnline', 1);
                    let that = this;
                    api.silentOrderOnline()
                    .then(res=>{
                        if(res.result != 0){
                            that.$store.commit('setSilentFail', true);
                        }
                    })
                    .catch(err=>{
                        that.$store.commit('setSilentFail', true);
                    });
                    return;
                }

                // window.open(config.url.orderLive);
                goSignup('online', this.$route.query.shareKey);
            },
            clickAgenda(item, key){
                localStorage.setItem("eco_2021_agenda_hash", JSON.stringify({
                    dayIndex: item.dayIndex,
                    typeIndex: item.typeIndex,
                    indexKey: key,
                    agendaThemeActive: this.agendaThemeActive

                }));
                this.$router.push({
                    path: '/agenda'
                });
            },
            reduceGuest(){
                let self = this;
                if(self.guestListTab>0){
                    self.guestListTab =self.guestListTab-1
                }else{
                    self.guestListTab=0
                }
            },
            addGuest(){
                let self = this;
                if(self.guestListTab<self.guestList.length-1){
                    self.guestListTab =self.guestListTab+1
                }else{
                    self.guestListTab=self.guestList.length-1
                }
            },
            getAtlasContent(index){
                var self=this
                var width1=$('#pagePcContent5').outerWidth(true)
                var width2=$('#pagePcContent1').outerWidth(true)
                var width3=$('#pagePcContent2').outerWidth(true)
                if(index){
                    var width6=index
                }else{
                    var width6=$('#pagePcContent5').scrollLeft()
                }
                var width8=width3+width2-width1-5
                if(width6<=0){self.isLeftScrollPc=false
                }else{self.isLeftScrollPc=true}
                if(width6<=width8){self.isRightScrollPc=true
                }else{self.isRightScrollPc=false}
            },
            reduceAtlas(){
                var self=this
                var width6=$('#pagePcContent5').scrollLeft()
                var left2=width6-0.4*self.width
                $('#pagePcContent5').animate({'scrollLeft':left2},500)
                self.getAtlasContent(left2)
            },
            addAtlas(){
                var self=this
                var width6=$('#pagePcContent5').scrollLeft()
                var left2=width6+0.4*self.width
                $('#pagePcContent5').animate({'scrollLeft':left2},500)
                self.getAtlasContent(left2)
            },
            getPage11Content(index){
                var self=this
                var width1=$('#page11Content5').outerWidth(true)
                var width2=$('#page11Content1').outerWidth(true)
                var width3=$('#page11Content2').outerWidth(true)
                if(index){
                    var width6=index
                }else{
                    var width6=$('#page11Content1').offset().left
                }
                var width8=width3+width2-width1+width6
                if(width6>=0.045*self.width){self.isLeftScroll=false
                }else{self.isLeftScroll=true}
                if(width8>=0.05*self.width){self.isRightScroll=true
                }else{self.isRightScroll=false}
            },
            scrollLeft(){
                var self=this
                var width6=$('#page11Content1').offset().left
                var left2=width6+0.5*self.width
                $('#page11Content5').animate({'scrollLeft':-left2},500)
                self.getPage11Content(left2)
            },
            scrollRight(){
                var self=this
                var width6=$('#page11Content1').offset().left
                var left2=width6-0.5*self.width
                // $('#page11Content5').scrollLeft(-left2)
                $('#page11Content5').animate({'scrollLeft':-left2},500)
                self.getPage11Content(left2)
            },
            guestOneMouse(index){
                this.guestOneActive = index
            },
            enableGuestOneMouseMouse(){
                this.guestOneActive = -1
            },
            // 预定议程
            clickAgendaCollect(){
                if(!this.userLogin){
                    this.showRegister();
                    return;
                }

                if(this.requestOrderAgenda){
                    return;
                }

                let agenda = this.getClickTopicItem();
                let that = this;

                if(that.$store.state.myData.myOrderAgendaList.indexOf(agenda.subSeminarId) != -1){
                    that.cancelAgendaOrder();
                    return;
                }

                // 埋码
                this.$maima.agenda_keynote_collect_click(agenda.name, agenda.m_product_tag, agenda.m_industry_tag, agenda.zipNames);

                that.requestOrderAgenda = true;
                api.orderAgenda(agenda.subSeminarId)
                .then(res=>{
                    that.requestOrderAgenda = false;
                    if(res.result == 0){
                        let temp = that.$store.state.myData.myOrderAgendaList;
                        temp.push(agenda.subSeminarId);
                        that.$store.commit('setMyOrderAgendaList', temp);
                        that.getAgendaList();
                        that.$store.commit('showCollectionSuccessToast', true);
                    }
                })
                .catch(err=>{
                    that.requestOrderAgenda = false;
                });
            },
            // 观看直播
            clickAgendaLive(){
                let agenda = this.getClickTopicItem();
                // if(!this.userLogin){
                //     this.showRegister();
                //     return;
                // }else 
                if(agenda.m_vhallLiveId){
                    goVhall(agenda.m_vhallLiveId);
                    // window.location.href = agenda.m_vhallLiveId;
                }else{
                    return;
                }

            },
            getClickTopicItem(){
                let item;
                if(this.dayIndex == 0){
                    item = this.agenda.first.topic[this.agendaThemeActive];
                }else{
                    item = this.agenda.second.topic[this.agendaThemeActive];
                }
                return item;
            },
            // 取消预定议程
            cancelAgendaOrder(){
                if(this.requestCancelAgenda){
                    return;
                }

                let agenda = this.getClickTopicItem();
                let that = this;

                if(that.$store.state.myData.myOrderAgendaList.indexOf(agenda.subSeminarId) == -1){
                    return;
                }

                that.requestCancelAgenda = true;
                api.cancelAgenda(agenda.subSeminarId)
                .then(res=>{
                    that.requestCancelAgenda = false;
                    if(res.result == 0){
                        let temp = [];
                        that.$store.state.myData.myOrderAgendaList.map(item=>{
                            if(item != agenda.subSeminarId){
                                temp.push(item);
                            }
                        });
                        that.$store.commit('setMyOrderAgendaList', temp);
                        that.getAgendaList();
                        that.$store.commit('showCollectionCancelToast', true);
                    }
                })
                .catch(err=>{
                    that.requestCancelAgenda = false;
                });
            },
            // 我的预约议程
            getMyOrderAgendaList(){
                let that = this;
                api.myOrderAgenda()
                .then(res=>{
                    if(res.result == 0){
                        let temp = [];
                        res.content.items.map(item=>{
                            temp.push(item.subSeminarId);
                        });
                        that.$store.commit('setMyOrderAgendaList', temp);
                    }
                    that.getAgendaList();
                })
                .catch(err=>{
                    that.getAgendaList();
                });
            },
            // 大咖观点
            getWonderfulWords(){
                if(!this.$store.state.showControl.showNavWords){
                    return;
                }

                let that = this;
                api.getWonderfulWords()
                .then(res=>{
                    if(res){
                        that.twinsList = res;
                        if(!that.$store.state.isPc){
                            that.$nextTick(()=>{
                                that.initSwiper12();
                            })
                        }else{
                            that.$nextTick(()=>{
                                that.initSwiperTwins();
                            })
                        }
                    }
                    that.reqeustBack();
                })
                .catch(err=>{
                    that.reqeustBack();
                    that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                });
            },
            // 精彩图集
            getWonderfulPic(){
                if(!this.$store.state.showControl.showNavPic){
                    return;
                }

                let that = this;
                api.getWonderfulPic()
                .then(res=>{
                    if(res){
                        that.wonderfulPic = res;
                    }
                    that.reqeustBack();
                })
                .catch(err=>{
                    that.reqeustBack();
                    that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                });
            },
            // 嘉宾列表
            getGuestList(){
                if(!this.$store.state.showControl.showNavGuest){
                    return;
                }

                let that = this;
                api.getGuestList()
                .then(res=>{
                    if(res){
                        that.guestList = constructData(res, 5);
                        that.guestWapList = res;
                        if(!that.$store.state.isPc){
                            that.$nextTick(()=>{
                                that.initSwiper9();
                            });
                        }
                    }
                    that.reqeustBack();
                })
                .catch(err=>{
                    that.reqeustBack();
                    that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                });
            },
            // 跳转展厅导览
            goExhibition(name){
                localStorage.setItem('eco_2021_exhibition_hash', name);
                this.$router.push({
                    path: '/exhibition'
                });
            },
            showRegister(){
                this.registerPop = true;
            },
            registerPopClose(){
                this.registerPop = false;
            },
            goRegister(){
                goSignup('online', this.$route.query.shareKey, true);
            },
            // 文件下载
            filesTabNavThree(index){
                this.fileOneTab=index
            },
            async filesTabTwoChoose(index){
                this.filesTabTwoNav=index;
                let data = this.hallList[index].child;
                let temp = [];
                data.map((item, index)=>{
                    temp.push({
                        // fileList: index == data.length-1 ? await api.getFileFolder(item.folderId) : [],
                        fileList: [],
                        title: item.title,
                        folderId: item.folderId,
                        // isShow: index == data.length-1 ? true : false,
                        isShow: false,
                    });
                });
                temp[0].isShow = true;
                temp[0].fileList = await api.getFileFolder(temp[0].folderId);
                this.filesListTwo = temp;
            },
            filesListTwoShow(index){
                this.filesListTwo.forEach(async (item,num)=>{
                    if(index==num){
                        this.filesListTwo[num].isShow=!this.filesListTwo[num].isShow
                        this.filesListTwo[num].fileList=await api.getFileFolder(this.filesListTwo[num].folderId);
                    }
                })
            },
            filesListOneShow(index){
                this.zipSpecialList.forEach((item,num)=>{
                    if(index==num){
                        this.zipSpecialList[num].isShow=!this.zipSpecialList[num].isShow
                    }
                })
            },
            // 展厅数据
            getExtHall(){
                let that = this;
                api.getExthallList()
                .then(res=>{
                    // res.map(item=>{
                    //     item.child.map(async (childItem, childIndex)=>{
                    //         if(childIndex == 0){
                    //             childItem.isShow = true;
                    //             childItem.fileList = await api.getFileFolder(childItem.folderId);
                    //         }else{
                    //             childItem.isShow = false;
                    //             childItem.fileList = [];
                    //         }
                    //     });
                    // });
                    that.hallList = res;
                    if(this.showNavDownload){
                        that.filesTabTwoChoose(0);
                    }
                    that.hallListRequest = true;
                    that.initRecommend();
                    // let nameArr = [];
                    // let hallArr = [];
                    // res.map(item=>{
                    //     item.tagName = item.cateName;
                    //     nameArr.push(item.tagName);
                    //     item.child.map(childItem=>{
                    //         hallArr.push({
                    //             title: childItem.title,
                    //             folderId: childItem.folderId,
                    //             isShow: false,
                    //             hallMain: []
                    //         });
                    //     });
                    // });
                    // that.hallFilter = nameArr;
                    // that.hallList = sortKey(hallArr, 'orderNumber');
                    // that.hallListOri = sortKey(hallArr, 'orderNumber');
                })
                .catch(err=>{
                });
            },
            initRecommend(){
                return;
                let that = this;
                if(this.isRecommend){
                    return;
                }
                if(this.showNavDownload){
                    if(this.specialFilesRequest && this.hallListRequest && this.topicFilesRequest){
                        that.isRecommend = true;
                        try{
                            _hpm("getTags", {
                                callback: res => {
                                    that.recommend(res);
                                },
                            });
                        }catch(e){
                            that.recommend({industry: null, productAndSolution: null});
                        }
                    }
                }else{
                    if(this.getAgendaRequest && this.hallListRequest){
                        that.isRecommend = true;
                        try{
                            _hpm("getTags", {
                                callback: res => {
                                    that.recommend(res);
                                },
                            });
                        }catch(e){
                            that.recommend({industry: null, productAndSolution: null});
                        }
                    }
                }

            },
            recommend(tags){
                return;
                let industryTag = '行业$默认标签',
                    productTag = '产品$默认标签';
                if(tags.industry && tags.industry.tagName){
                    industryTag = '行业$' + tags.industry.tagName.replace('-', '^');
                }
                if(tags.productAndSolution && tags.productAndSolution.tagName){
                    productTag = '产品$' + tags.industry.tagName.replace('-', '^');
                }
                let agendaRes = this.recommendAgenda(industryTag, productTag);

                let hallRes = this.recommendHall(industryTag, productTag);
                let likeLists = [
                    {
                        likeOneTitle:"议程",
			            likeContent: agendaRes.agenda
                    },
                    {
                        likeOneTitle:"展厅",
			            likeContent: hallRes
                    },
                ];
                if(agendaRes.file){
                    likeLists[2] = {
                        likeOneTitle:"资料",
			            likeContent: [agendaRes.file]
                    };
                }
                this.likeLists = likeLists;
            },
            recommendHall(industryTag, productTag){
                let data = [];
                data = data.concat(this.hallList[0].child);
                data = data.concat(this.hallList[1].child);
                data = data.concat(this.hallList[2].child);

                data.map(item=>{
                    item.m_tag_score = 0;
                    if(item.m_tag && item.m_tag.indexOf(industryTag) != -1){
                        item.m_tag_score = item.m_tag_score + 500;
                    }
                    if(item.m_tag && item.m_tag.indexOf(productTag) != -1){
                        item.m_tag_score = item.m_tag_score + 500;
                    }

                    if(item.m_tag_score > 0){
                        item.m_tag_score = item.m_tag_score - item.tags.length;
                    }
                });

                data = sortKey(data, 'm_tag_score');

                return data.slice(0, 2);
            },
            recommendAgenda(industryTag, productTag){
                // let agenda = this.$store.state.cache.allAgenda;
                let agenda = [];
                agenda = agenda.concat(this.agenda.first.topic);
                agenda = agenda.concat(this.agenda.first.special);
                agenda = agenda.concat(this.agenda.first.open);
                agenda = agenda.concat(this.agenda.second.topic);
                agenda = agenda.concat(this.agenda.second.special);
                agenda = agenda.concat(this.agenda.second.open);
                
                agenda.map(item=>{
                    if(item.m_tag.indexOf(industryTag) != -1){
                        item.m_tag_score = item.m_tag_score + 500;
                    }
                    if(item.m_tag.indexOf(productTag) != -1){
                        item.m_tag_score = item.m_tag_score + 500;
                    }

                    if(item.m_tag_score > 0){
                        item.m_tag_score = item.m_tag_score - item.m_tag.length;
                    }
                });

                let yihou = [], guoqu = [];
                agenda.map(item=>{
                    if(item.timeIndex > 0){
                        yihou.push(item);
                    }else{
                        guoqu.push(item);
                    }
                });

                yihou = sortKey(yihou, 'timeIndex').reverse();
                guoqu = sortKey(guoqu, 'timeIndex');

                let res = yihou.concat(guoqu);
                res = sortKey(res, 'm_tag_score');


                let fileInfo = false;
                if(this.$store.state.agendaStatus == 'after'){
                    let fileIdArr = [];
                    res.map(item=>{
                        if(item.categoryArr[0] == '主题演讲'){
                            if(item.filesIdArr.length > 0){
                                fileIdArr = fileIdArr.concat(item.filesIdArr);
                            }
                        }else if(item.categoryArr[0] == '专题演讲'){
                            if(this.zipSpecialListOri.hasOwnProperty(item.subSeminarId * 1)){
                                this.zipSpecialListOri[item.subSeminarId * 1].map(specItem=>{
                                    fileIdArr.push(specItem.fileId);
                                });
                            }
                        }
                    });

                    let fileId = fileIdArr[0];
                    let fileCache = this.$store.state.cache.fileList;
                    fileCache.map(cacheItem=>{
                        if(cacheItem.fileId == fileId){
                            fileInfo = cacheItem;
                        }
                    })
                }

                return {
                    agenda: this.$store.state.agendaStatus == 'after' ? res.slice(0, 2) : res.slice(0, 3),
                    file: fileInfo
                };
            },
            preview(file){
                // if(!this.$store.state.userLogin){
                //     this.showRegister();
                //     return;
                // }

                if(!file){
                    return;
                }
                
                if(file.ext == 'temp'){
                    return;
                }else{
                    previewFile(file.fileUrl);
                    return;
                }
            },
            download(file){
                if(!this.$store.state.userLogin){
                    this.showRegister();
                    return;
                }

                if(!file){
                    return;
                }

                if(file.ext == 'temp'){
                    return;
                }else{
                    this.downloadFileId = [file.fileId];
                    this.showDownloadPop();
                    return;
                }
            },
            showDownloadPop(){
                this.downloadFilePop = true;
                this.email = this.$store.state.myData.email;
            },
            sendEmail(email){
                if(this.emailRequest){
                    return;
                }
                this.emailRequest = true;
                let that = this;
                api.downloadWithEmail({
                    fileList: that.downloadFileId,
                    email: email
                }).then(res=>{
                    if(res.result == 0){
                        that.downloadFilePop = false;
                        that.showDownloadFileSuccess();
                        that.downloadFileId = [];
                    }else{
                        that.downloadFilePopMsg = res.desc;
                    }
                    that.emailRequest = false;
                })
                .catch(err=>{
                    that.emailRequest = false;
                    that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                });
            },
            showDownloadFileSuccess(){
                this.downloadFileSuccessPop = true;
            },
            downloadFilePopClose(){
                this.downloadFileSuccessPop = false;
            },
            closeDownLoadPop(){
                this.downloadFilePop=false
            },
            specialPreview(item){
                // if(!this.$store.state.userLogin){
                //     this.showRegister();
                //     return;
                // }

                if(!item){
                    return;
                }
                
                previewFile(item.url.replace('http://', 'https://') + '&type=download&isPreview=1');
                return;
            },
            specialDownload(item){
                if(!this.$store.state.userLogin){
                    this.showRegister();
                    return;
                }

                if(!item){
                    return;
                }

                this.downloadFileId = [item.fileId];
                this.showDownloadPop();
                return;
            },
            clickLike(item, key){
                if(key == 0){

                    // 埋码
                    this.$maima.index_recommendation_agenda_btn_click(item.name, item.m_product_tag, item.industry_tag);

                    localStorage.setItem("eco_2021_agenda_hash", JSON.stringify({
                        dayIndex: item.dayIndex,
                        typeIndex: item.typeIndex,
                        indexKey: item.indexKey,
                        agendaThemeActive: item.indexKey

                    }));
                    this.$router.push({
                        path: '/agenda'
                    });
                }else if(key == 1){

                    // 埋码
                    this.$maima.index_recommendation_exhibition_btn_click(item.title, item.m_product_tag, item.industry_tag);

                    this.$router.push({
                        path: '/exhibitionDetail',
                        query: {
                            id: item.articleCategoryId
                        }
                    });

                }else{

                    // 埋码
                    this.$maima.index_recommendation_material_btn_click(item.name);

                    this.$router.push({
                        path: '/files'
                    })
                }
                return;
            },
            clickLikeOne(){
                // 埋码
                this.$maima.recommendation_tab_click();
            },
            chooseLiveDate(index){
                this.liveIndex=index

                // 埋码
                this.$maima.live_page_schedule_date_click();
            },
            chooseLiveListIndex(index){
                if(index == this.liveLists[this.liveIndex].showList){
                    this.liveLists[this.liveIndex].showList = -1;
                }else{
                    this.liveLists[this.liveIndex].showList=index;
                }

                // 埋码
                this.$maima.live_page_agenda_type_click(this.liveLists[this.liveIndex].content[index].name);
            },
            initLiveData(){
                if(this.$store.state.liveStatus == 'before'){
                    return;
                }

                this.getMainLiveData();

                let that = this;
                api.getLiveCate()
                .then(async resOri=>{
                    let agenda = [];
                    let currentTime = getTime();

                    console.log('getLiveCate', resOri);

                    agenda = agenda.concat(this.agenda.first.topic);
                    agenda = agenda.concat(this.agenda.first.special);
                    agenda = agenda.concat(this.agenda.first.open);
                    agenda = agenda.concat(this.agenda.second.topic);
                    agenda = agenda.concat(this.agenda.second.special);
                    agenda = agenda.concat(this.agenda.second.open);

                    let res = JSON.stringify(resOri);
                    res = JSON.parse(res);
                    // let agendaIds = [];
                    res.map(item=>{
                        console.log('mark 0', item);
                        item.content.map((childItem, childIndex)=>{
                            // if(childIndex>0){
                            console.log('mark 1', childItem)
                            if(childItem.name != 'Σco·Live'){
                                agenda.map(agendaItem=>{
                                    if(agendaItem.i_meetingLiveType && agendaItem.i_meetingLiveType.length == 2){
                                        if(agendaItem.i_meetingLiveType[0] == item.name && agendaItem.i_meetingLiveType[1] == childItem.name){
                                            if(agendaItem.m_vhallLiveId){

                                                // 去重 原方法
                                                // let isMatch = false;
                                                // childItem.child.map(grandItem=>{
                                                //     if(grandItem.subSeminarId == agendaItem.subSeminarId){
                                                //         isMatch = true;
                                                //     }
                                                // });
                                                // if(!isMatch){
                                                //     childItem.child.push(agendaItem);
                                                // }

                                                // 不去重 无污染
                                                childItem.child.push(agendaItem);

                                                if(that.vhallIds.indexOf(agendaItem.m_vhallLiveId) == -1){
                                                    that.vhallIds.push(agendaItem.m_vhallLiveId);
                                                }
                                            }
                                        }
                                    }
                                });
                            }else{
                                // item.m_vhallLiveId = 0;
                                let vhallId = 0;
                                if(item.name == '05.17' && that.$store.state.cache.firstMainLiveAgenda){
                                    childItem.child = that.$store.state.cache.firstMainLiveAgenda.agendaListData;
                                    
                                    if(currentTime > 1621353600 || currentTime < 1621267200){
                                        // childItem.m_vhallLiveId = that.$store.state.cache.firstMainLiveAgenda.m_vhallLiveId;
                                        childItem.startTime = that.$store.state.cache.firstMainLiveAgenda.startTime;
                                    }
                                    vhallId = that.$store.state.cache.firstMainLiveAgenda.m_vhallLiveId;
                                }else if(item.name == '05.18' && that.$store.state.cache.secondMainLiveAgenda){
                                    childItem.child = that.$store.state.cache.secondMainLiveAgenda.agendaListData;

                                    if(currentTime > 1621267200){
                                        // childItem.m_vhallLiveId = that.$store.state.cache.secondMainLiveAgenda.m_vhallLiveId;
                                        // childItem.startTime = that.$store.state.cache.secondMainLiveAgenda.startTime;
                                    }

                                    vhallId = that.$store.state.cache.secondMainLiveAgenda.m_vhallLiveId;
                                }
                                childItem.child.map(richeng=>{
                                    richeng.m_vhallLiveId = vhallId;
                                    richeng.isMain = true;
                                });
                            }

                            childItem.child = sortKey(childItem.child, 'startTime').reverse();
                        });
                    });

                    if(that.$store.state.cache.firstMainLiveAgenda && that.$store.state.cache.firstMainLiveAgenda.m_vhallLiveId){
                        if(that.vhallIds.indexOf(that.$store.state.cache.firstMainLiveAgenda.m_vhallLiveId) == -1){
                            that.vhallIds.push(that.$store.state.cache.firstMainLiveAgenda.m_vhallLiveId);
                        }
                    }
                    if(that.$store.state.cache.secondMainLiveAgenda && that.$store.state.cache.secondMainLiveAgenda.m_vhallLiveId){
                        if(that.vhallIds.indexOf(that.$store.state.cache.secondMainLiveAgenda.m_vhallLiveId) == -1){
                            that.vhallIds.push(that.$store.state.cache.secondMainLiveAgenda.m_vhallLiveId);
                        }
                    }

                    let vhallStatus = await api.liveHallStatus(that.vhallIds);
                    if(vhallStatus.result == 0){
                        that.vhallStatus = vhallStatus.content;
                    }


                    that.liveLists = res;

                    that.vhallStatusTimeGuard();

                    that.$nextTick(()=>{
                        if(currentTime > 1621267200 && currentTime < 1621353600){
                            that.liveIndex = 1;
                        }
                    });
                })
                .catch(err=>{
                });
            },
            vhallStatusTimeGuard(){
                let that = this;
                let res = that.liveLists;
                let currentTime = getTime();

                // if(!that.vhallStatus.content){
                //     return;
                // }
                res.map(item=>{
                    item.content.map((contentItem, contentIndex)=>{
                        contentItem.child.map(agendaItem=>{
                            let isMatch = false;
                            that.vhallStatus.map(vhallItem=>{
                                if(vhallItem.liveId == agendaItem.m_vhallLiveId){
                                    agendaItem.vhallStatus = vhallItem.status;
                                    // if(vhallItem.status != 0){
                                    //     agendaItem.vhallStatus = vhallItem.status;
                                    // }else{
                                    //     if(currentTime > agendaItem.startTime * 1){
                                    //         agendaItem.vhallStatus = 1;
                                    //     }else{
                                    //         agendaItem.vhallStatus = 0;
                                    //     }
                                    // }
                                    isMatch = true;
                                }
                            });

                            // 未匹配到接口返回状态 是否刷新
                            // if(!isMatch && contentIndex > 0){
                            //     if(currentTime > agendaItem.startTime * 1){
                            //         agendaItem.vhallStatus = 1;
                            //     }else{
                            //         agendaItem.vhallStatus = 0;
                            //     }
                            // }

                            agendaItem.liveOrder = 0;
                            if(agendaItem.vhallStatus == 1){
                                agendaItem.liveOrder = 5;
                            }else if(agendaItem.vhallStatus == 0){
                                agendaItem.liveOrder = 4;
                            }else if(agendaItem.vhallStatus == 3){
                                agendaItem.liveOrder = 3;
                            }else if(agendaItem.vhallStatus == 2){
                                agendaItem.liveOrder = 2;
                            }else{
                                agendaItem.liveOrder = 1;
                            }
                        });

                        // 排序
                        contentItem.child = cnWordSort(contentItem.child, 'name');
                        contentItem.child = sortKey(contentItem.child, 'startTime').reverse();
                        contentItem.child = sortKey(contentItem.child, 'i_subSeminarOrder');
                        contentItem.child = sortKey(contentItem.child, 'liveOrder');

                        if(contentItem.m_vhallLiveId){
                            let isMatch = false;
                            that.vhallStatus.map(vhallItem=>{
                                if(vhallItem.liveId == contentItem.m_vhallLiveId){
                                    contentItem.vhallStatus = vhallItem.status;
                                    // if(vhallItem.status != 0){
                                    //     contentItem.vhallStatus = vhallItem.status;
                                    // }else{
                                    //     if(currentTime > contentItem.startTime * 1){
                                    //         contentItem.vhallStatus = 1;
                                    //     }else{
                                    //         contentItem.vhallStatus = 0;
                                    //     }
                                    // }
                                    isMatch = true;

                                }
                            });

                            // 未匹配到接口返回状态 是否刷新
                            // if(!isMatch){
                            //     if(currentTime > contentItem.startTime * 1){
                            //         contentItem.vhallStatus = 1;
                            //     }else{
                            //         contentItem.vhallStatus = 0;
                            //     }
                            // }
                        }
                    });
                });
                that.liveLists = res;
                // that.vhallStatusTimeGuardId = setTimeout(function(){
                //     that.vhallStatusTimeGuard();
                // }, 2000);
            },
            clickLive(item){
                if(item.m_vhallLiveId){

                    // 埋码
                    this.$maima.live_homepage_attend_btn_click(item.name, item.m_product_tag, item.m_industry_tag);

                    if(item.isMain){
                        goVhall(item.m_vhallLiveId, true);
                    }else{
                        goVhall(item.m_vhallLiveId);
                    }
                }
            },
            getMainLiveData(){
                if(this.$store.state.cache.firstMainLiveAgenda){
                    this.mainLiveTitle = this.$store.state.cache.firstMainLiveAgenda.name;
                }else{
                    this.mainLiveTitle = '华为中国生态大会2021';
                }

                let currentTime = getTime();
                if(currentTime <= 1621267200 && this.$store.state.cache.firstMainLiveAgenda){
                    this.mainLiveIframeUrl = this.$store.state.cache.firstMainLiveAgenda.i_liveurl;
                }else if(currentTime > 1621267200 && this.$store.state.cache.secondMainLiveAgenda){
                    this.mainLiveIframeUrl = this.$store.state.cache.secondMainLiveAgenda.i_liveurl;
                }

                // let that = this;
                // api.getMainLive()
                // .then(res=>{
                //     console.log('getMainLiveData res', res);
                //     if(res.result == 0){
                //         that.mainLiveIframeUrl = res.content.summary.split('^')[0];
                //         that.mainLiveUrl = res.content.summary.split('^')[1];
                //         that.mainLiveTitle = res.content.title;
                //     }
                // })
                // .catch(err=>{
                //     console.log('getMainLiveData err', err);
                // });
            },
            clickMainLive(){
                let currentTime = getTime(), vhallId = 0, agenda;
                if(currentTime <= 1621267200 && this.$store.state.cache.firstMainLiveAgenda && this.$store.state.cache.firstMainLiveAgenda.m_vhallLiveId){
                    vhallId = this.$store.state.cache.firstMainLiveAgenda.m_vhallLiveId;
                    agenda = this.$store.state.cache.firstMainLiveAgenda;
                }else if(currentTime > 1621267200 && currentTime < 1621353600 && this.$store.state.cache.secondMainLiveAgenda && this.$store.state.cache.secondMainLiveAgenda.m_vhallLiveId){
                    vhallId = this.$store.state.cache.secondMainLiveAgenda.m_vhallLiveId;
                    agenda = this.$store.state.cache.secondMainLiveAgenda;
                }else{
                    vhallId = this.$store.state.cache.firstMainLiveAgenda.m_vhallLiveId;
                    agenda = this.$store.state.cache.firstMainLiveAgenda;
                }

                if(vhallId && agenda){
                    // 埋码
                    this.$maima.live_homepage_attend_btn_click(agenda.name, agenda.m_product_tag, agenda.m_industry_tag);
                }

                if(vhallId){
                    goVhall(vhallId, true);
                    // goVhall(vhallId);
                }
                return;
            },
        },
    }
</script>
<style scoped lang="scss">
*{
    box-sizing: border-box;
    padding: 0;
    margin: 0;
}
.icon-weixin{
    top:-84px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    transition: all 0.3s;
    width: 70px !important;
    height: 70px !important;
    // margin-bottom: 110px;
    img{
        width: 70px !important;
        height: 70px !important;
    }
    .sanjiao{
        position: absolute;
        top: 63px;
        left: 32px;
        width: 0;
        height: 0;
        border-top: 10px solid white;
        border-right: 10px solid transparent;
        transform: rotate(225deg);
    }
}
.pc {
    a{
        cursor: pointer;
    }
    .margin-l-r-auto{
        margin-left: auto !important;
        margin-right: auto !important;
    }
    .icon-weixin{
        position: absolute;
        top:-84px;
        left: 50%;
        transform: translateX(-50%);
        transition: all 0.3s;
        width: 70px !important;
        height: 70px !important;
        // margin-bottom: 110px;
        img{
            width: 70px !important;
            height: 70px !important;
        }
        .sanjiao{
            position: absolute;
            top: 63px;
            left: 32px;
            width: 0;
            height: 0;
            border-top: 10px solid white;
            border-right: 10px solid transparent;
            transform: rotate(225deg);
        }
    }
    .nav-list {
        z-index: 99;
        position: fixed;
        top: 50%;
        left: pxToVw(95);
        transform: translateY(-50%);
        .left-button{
            position: absolute;
            top: pxToVw(11);
            left: pxToVw(105);
            width: pxToVw(73);
            display: flex;
            align-items: center;
            justify-content: center;
            height: pxToVw(24);
            background: #C50819;
            border-radius: 0px pxToVw(12) pxToVw(12) pxToVw(12);
            img{
                width: pxToVw(6);
                height: pxToVw(8);
                vertical-align: top;
            }
            p{
                margin-left: pxToVw(4);
                font-size: pxToVw(14);
                color: #FFFFFF;
                padding-top: pxToVw(1);
                line-height: pxToVw(17);
            }
        }
        .nav-line {
            .nav-line-item {
                margin: 0;
                list-style: none;
                cursor: pointer;
                .nav-line-item-one{
                    position: relative;
                    width: pxToVw(105);
                    height: auto;
                    &:hover{
                        p{
                            font-size: pxToVw(24);
                            color: #C50819;
                            line-height: pxToVw(46);
                        }
                        .line{
                            display: block;
                        }
                    }
                    p{
                        font-size: pxToVw(19);
                        color: #666666;
                        line-height: pxToVw(46);
                    }
                    .line{
                        display: none;
                        position: absolute;
                        top: 50%;
                        left: pxToVw(-53);
                        width: pxToVw(41);
                        height: 1px;
                        background: #C50819;
                    }
                }
                .nav-line-item-one-active{
                    p{
                        font-size: pxToVw(24);
                        color: #C50819;
                        line-height: pxToVw(46);
                    }
                    .line{
                        display: block;
                    }
                }
                &:hover {
                    .nav-line-item-img {
                        background: #c30716;
                        border: none;
                    }
                }
            }
        }
    }
    .swiper-page {
        width: 100%;
        height: 100vh;
        margin: 0 auto;
        .swiper-wrapper {
            .swiper-slide {
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
                .con-page1,.con-page2,.con-page3,.con-page4,
                .con-page5,.con-page6,.con-page7,.con-page8,.con-page12{
                    width: 100%;
                    height: 100%;
                }
                .con-1200{
                    // width: pxToVw(1520);
                    width: pxToVw(1370);
                    margin: 8.0vh pxToVw(240) 0 pxToVw(310);
                    // margin: pxToVw(97) pxToVw(240) 0 pxToVw(310);
                    .con-title{
                        width: 100%;
                        height: pxToVw(116);
                        text-align: left;
                        p{  
                            width: pxToVw(358);
                            height: pxToVw(116);
                            // width: 30.5vh;
                            // height: 10vh;
                            padding: pxToVw(45) 0 0 pxToVw(94);
                            font-size: pxToVw(36);
                            font-family: "FZLT-blackBold";
                            color: #FFF;
                            line-height: pxToVw(43);
                            background: url("../assets/newImages/home/title-bg.png")no-repeat center center/cover;
                        }
                    }
                    .hot-top-button{
                        margin-bottom: pxToVw(22);
                        display: flex;
                        justify-content: flex-end;
                        .hot-left,.hot-right{
                            width: pxToVw(35);
                            height: pxToVw(35);
                            background: #C5C5C5;
                            cursor: pointer;
                            margin-left: pxToVw(17);
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            img{
                                width: pxToVw(17);
                                height: pxToVw(13);
                            }
                        }
                        .hot-left-active,.hot-right-active{
                            background: #C50819;
                        }
                    }
                }
                .more{
                    width: auto;
                    cursor: pointer;
                    // margin: pxToVw(37) auto 0;
                    margin: 2.9vh auto 0;
                    height: auto;
                    display: flex;
                    height: pxToVw(22);
                    justify-content: center;
                    align-items: center;
                    &:hover{
                        p{
                            color: #c30716;
                        }
                    }
                    p{
                        font-size: pxToVw(19);
                        color: #333333;
                        line-height: pxToVw(22);
                        margin-right: pxToVw(8);
                    }
                    .img{
                        width: pxToVw(20);
                        height: pxToVw(14);
                        img{
                            vertical-align: top;
                            width: pxToVw(20);
                            height: pxToVw(14);
                        }
                    }
                }
                .tishi{
                    font-size: pxToVw(14);
                    width: 100%;
                    text-align: right;
                    color: #666666;
                    line-height: pxToVw(18);
                }
            }
        }
    }
    .con-page1{
        position: relative;
        background: url("../assets/newImages/home/page1.jpg")no-repeat center center/cover;;
        .text{
            width: 100%;
            text-align: center;
            font-size: pxToVw(21);
            color: #666666;
            line-height: pxToVw(24);
            margin: 65vh auto pxToVw(33);
        }
        .button{
            height: pxToVw(56);
            width: pxToVw(440);
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            .button1{
                width: pxToVw(200);
                height: pxToVw(56);
                background: #C50819;
                border-radius: 1px;
                font-size: pxToVw(19);
                color: #FFF;
                cursor: pointer;
                line-height: pxToVw(56);
                border: none;
            }
            .button2{
                width: pxToVw(200);
                height: pxToVw(56);
                background: #FFF;
                border: 2px solid #C50819;
                border-radius: 1px;
                font-size: pxToVw(19);
                color: #C50819;
                cursor: pointer;
                line-height: pxToVw(52);
            }
            .button3{
                width: pxToVw(200);
                height: pxToVw(56);
                background: #2F5597;
                border: none;
                border-radius: 1px;
                font-size: pxToVw(19);
                color: #FFF;
                cursor: pointer;
                line-height: pxToVw(56);
            }
        }
        .button-div{
            justify-content: center;
        }
        .page1-bottom{
            position: absolute;
            bottom: pxToVw(71);
            left: pxToVw(950.5);
            display: flex;
            justify-content: center;
            width: pxToVw(19);
            height: pxToVw(40);
            // padding-top: pxToVw(20);
            border-radius: pxToVw(10);
            border: pxToVw(2) solid #333333;
            img{
                position: absolute;
                top:0;left: pxToVw(-1);
                width: pxToVw(19);
                height: pxToVw(40);
            }
            // span{
            //     position: absolute;
            //     left: 50%;
            //     bottom: pxToVw(30);
            //     transform: translateX(-50%);
            //     width: pxToVw(2);
            //     height: pxToVw(11);
            //     border-radius: pxToVw(2);
            //     &:before {
            //         content: "";
            //         position: absolute;
            //         top: pxToVw(2);
            //         left: 0;
            //         width: pxToVw(2);
            //         height: pxToVw(11);
            //         background: #333333;
            //         animation: mymove 1s infinite;
            //         animation-direction: alternate;
            //     }
            //     @keyframes mymove {
            //         from {
            //             top: 2px;
            //         }
            //         to {
            //             top: pxToVw(24);
            //         }
            //     }
            // }
        }
    }
    .con-page2{
        position: relative;
        overflow: hidden;
        box-shadow: 0px -8px 16px 0px rgba(232,232,232,0.5);
        background: url("../assets/newImages/home/page3.png")no-repeat center center/cover,#FFF;
        .bg-img{
            position: absolute;
            top: pxToVw(-262);
            right: 0;
            width: pxToVw(304);
            img{
                width: 100%;
            }
        }
        .con-1200{
            .image{
                // margin: pxToVw(73) 0 0 pxToVw(242);
                margin: 5vh 0 0 pxToVw(242);
                width: pxToVw(831);
                height: pxToVw(310);
                img{
                    width: pxToVw(831);
                    height: pxToVw(310);
                }
            }
            .rich-text{
                width: pxToVw(903);
                height: pxToVw(190);
                margin: pxToVw(30) 0 0 pxToVw(242);
                padding-right: pxToVw(72);
                // overflow-y: scroll;
                color: #333333;
                font-size: pxToVw(19);
                line-height: 3.6vh;
                text-align: justify;
                scrollbar-width: none;
                -ms-overflow-style: none;
                &::-webkit-scrollbar{
                    width: 1px;
                    height: pxToVw(201);
                    background: #bbb;
                }
                &::-webkit-scrollbar-track{
                    background: #bbb;
                }
                &::-webkit-scrollbar-thumb{
                    background: #c5081c;
                }
            }
        }
    }
    .con-page3{
        position: relative;
        box-shadow: 0px -8px 16px 0px rgba(232,232,232,0.5);
        background: url("../assets/newImages/home/page3.png") no-repeat center center/cover,#FFF;
        .bg-img{
            position: absolute;
            bottom: pxToVw(-76);
            right: 0;
            width: pxToVw(309);
            img{
                width: 100%;
            }
        }
        .agenda-content{
            // margin: pxToVw(37) 0 0 pxToVw(81);
            margin: 3.2vh 0 0 pxToVw(81);
            width: pxToVw(1284);
            height: auto;
            position: relative;
            z-index: 2;
            .agenda-year{
                position: absolute;
                z-index: 3;
                bottom: 0;
                left: 0;
                width: pxToVw(84);
                height: pxToVw(527);
                background: #FFF;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                overflow: hidden;
                border-radius: 0 pxToVw(30) 0 pxToVw(30);
                .agenda-year-list{
                    padding-top: pxToVw(14);
                    .day-text{
                        width: pxToVw(60);
                        height: pxToVw(120);
                        margin: auto;
                        cursor: pointer;
                        flex-direction: column;
                        border-bottom: pxToVw(2) solid #c9c9c9;
                        &:hover{
                            p{
                                color: #C50819;
                            }
                        }
                        p{
                            font-size: pxToVw(20);
                            font-family: "ABlack";
                            color: #333;
                            line-height: pxToVw(28);
                            font-weight: bold;
                            &:nth-child(2){
                                font-size: pxToVw(18);
                                line-height: pxToVw(28);
                            }
                        }
                    }
                    .day-text-active{
                        p{
                            color: #C50819;
                        }
                    }
                }
                .year-text{
                    width: 100%;
                    height: pxToVw(130);
                    padding: pxToVw(36) 0 0;
                    color: #FFF;
                    background: #c40719;
                    p{
                        font-family: "ABlack";
                        font-size: pxToVw(20);
                        line-height: pxToVw(30);
                        &:nth-child(2){
                            font-size: pxToVw(12);
                            line-height: pxToVw(28);
                        }
                    }
                }
            }
            .agenda-list{
                width: pxToVw(1240);
                height: pxToVw(563);
                margin: 0 0 0 pxToVw(44);
                padding: pxToVw(39) 0 0 pxToVw(82);
                box-shadow: 0px 0px pxToVw(25) 0px rgba(231,231,231,0.5);
                border-radius: pxToVw(3);
                background: rgba(255,255,255,0.7);
                .agenda-nav{
                    width: pxToVw(1071);
                    margin: 0 0 pxToVw(35) pxToVw(10);
                    height: pxToVw(44);
                    display: flex;
                    border-bottom: pxToVw(3) solid #D8D8D8;
                    .agenda-nav-one{
                        width: pxToVw(155);
                        height: pxToVw(44);
                        font-size: pxToVw(22);
                        line-height: pxToVw(25);
                        color: #333;
                        margin-right: pxToVw(115);
                        cursor: pointer;
                        &:hover{
                            color: #C50819;
                            font-family: "FZLT-blackBold";
                            border-bottom: pxToVw(4) solid #C50819;
                        }
                    }
                    .agenda-nav-one-active{
                        color: #C50819;
                        font-family: "FZLT-blackBold";
                        border-bottom: pxToVw(4) solid #C50819;
                    }
                }
                .agenda-wait{
                    width: pxToVw(1071);
                    margin: pxToVw(190) 0 0 pxToVw(10);
                    height: 100%;
                    font-size: pxToVw(22);
                    line-height: pxToVw(25);
                    color: #333;
                    text-align: center;
                }
                .agenda-child-wait{
                    margin: 0 0 0 pxToVw(50);
                    width: pxToVw(800);
                    height: pxToVw(400);
                    font-size: pxToVw(22);
                    line-height: pxToVw(25);
                    color: #333;
                    text-align: center;
                }
                .agenda-main1{
                    width: 100%;
                    height: pxToVw(400);
                    display: flex;
                    text-align: left;
                    .agenda-image{
                        width: pxToVw(234);
                        height: pxToVw(390);
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        padding: pxToVw(36) pxToVw(30) pxToVw(44) pxToVw(30);
                        background: url(../assets/newImages/home/agenda-main1-image.png) no-repeat center center/cover;
                        box-shadow: 0 pxToVw(5) pxToVw(8) rgba(0,0,0,0.1);
                        .text-title{
                            width: 100%;
                            height: pxToVw(25);
                            font-size: pxToVw(22);
                            font-family: "FZLT-blackLittle";
                            font-weight: normal;
                            color: #FFFFFF;
                            line-height: pxToVw(25);
                            margin-bottom: pxToVw(6);
                            display: flex;
                            align-items: center;
                            span{
                                display: inline-block;
                                margin-right: pxToVw(10);
                                width: 0;
                                height: 0;
                                border-width: 0 pxToVw(6) pxToVw(6);
                                border-style: solid;
                                border-color: transparent transparent white;
                                transform: rotate(90deg);
                            }
                        }
                        .text-am{
                            display: flex;
                            align-items: flex-end;
                            height: pxToVw(66);
                            .p{
                                display: flex;
                                width: pxToVw(120);
                                height: pxToVw(66);
                                padding-right: pxToVw(3);
                                justify-content: space-between;
                                p{
                                    width: pxToVw(27);
                                    text-align: center;
                                    font-size: pxToVw(53);
                                    font-family: "ABlack";
                                    font-weight: 900;
                                    color: #FFFFFF;
                                    letter-spacing: 1px;
                                    line-height: pxToVw(66);
                                    &:nth-child(3){
                                        width: pxToVw(12);
                                    }
                                }
                            }
                            span{
                                font-size: pxToVw(14);
                                font-weight: normal;
                                color: #FFFFFF;
                                line-height: pxToVw(45);
                            }
                        }
                        .text-p{
                            font-size: pxToVw(19);
                            color: #FFFFFF;
                            line-height: pxToVw(29);
                        }
                        .text-address{
                            margin-top: pxToVw(16);
                            display: flex;
                            align-items: center;
                            span{
                                width: pxToVw(153);
                                // font-size: pxToVw(12);
                                font-size: 12px;
                                line-height: 14px;
                                color: #FFFFFF;
                                // line-height: pxToVw(14);
                            }
                            img{
                                vertical-align: top;
                                width: pxToVw(12);
                                height: pxToVw(17);
                                margin: pxToVw(-1) pxToVw(8) 0 0;
                            }
                            
                        }
                    }
                    .agenda-image2{
                        width: pxToVw(234);
                        height: pxToVw(390);
                        display: flex;
                        flex-direction: column;
                        background: url(../assets/newImages/home/agenda-main1-image.png) no-repeat center center/cover;
                        box-shadow: 0 pxToVw(5) pxToVw(8) rgba(0,0,0,0.1);
                        .agenda-image-one{
                            position: relative;
                            width: 100%;
                            height: 100%;
                            cursor: pointer;
                            background: rgba($color: #FFF, $alpha: 0.3);
                            box-shadow: 0 pxToVw(1) pxToVw(0) rgba(255,255,255,0.5);
                            // border-bottom: pxToVw(1) solid rgba(255,255,255,0.5);
                            &:last-child{
                                border-bottom: none;
                            }
                            .triangle{
                                display: none;
                                position: absolute;
                                top: 50%;right: pxToVw(0);
                                width: 0;
                                height: 0;
                                z-index: -1;
                                border-top: pxToVw(20) solid #fff;
                                border-left: pxToVw(20) solid transparent;
                                transform: rotate(45deg) translateY(-50%);
                            }
                            .agenda-image-one-main{
                                display: flex;
                                flex-direction: column;
                                .text-p{
                                    width: pxToVw(202);
                                    height: pxToVw(58);
                                    font-size: pxToVw(19);
                                    font-family: "FZLT-blackLittle";
                                    color: #FFFFFF;
                                    line-height: pxToVw(29);
                                    margin-bottom: pxToVw(1);
                                }
                                .time-address{
                                    display: flex;
                                    align-items: flex-start;
                                    .time{
                                        width: pxToVw(107);
                                        font-size: pxToVw(19);
                                        font-family: "ABlack";
                                        font-weight: 900;
                                        color: #FFFFFF;
                                        line-height: pxToVw(24);
                                    }
                                    .text-address{
                                        margin-top: pxToVw(5);
                                        width: pxToVw(95);
                                        display: flex;
                                        align-items: flex-start;
                                        img{
                                            width: pxToVw(12);
                                            height: pxToVw(14);
                                            margin-right: pxToVw(7);
                                        }
                                        span{
                                            width: pxToVw(76);
                                            font-size: pxToVw(12);
                                            color: #FFFFFF;
                                            line-height: pxToVw(14);
                                            // overflow: hidden;
                                            // text-overflow :ellipsis; 
                                            // white-space: nowrap; 
                                        }
                                    }
                                }
                            }
                        }
                        .agenda-image-one-active{
                            background: none;
                            .triangle{
                                display: block;
                            }
                        }
                    }
                    .agenda-lists-main{
                        margin: 0 0 0 pxToVw(50);
                        width: auto;
                        height: pxToVw(400);
                        overflow-y: scroll;
                        padding-right: pxToVw(30);
                        scrollbar-width: none;
                        -ms-overflow-style: none;
                        &::-webkit-scrollbar{
                            width: pxToVw(5);
                            height: pxToVw(432);
                            background: none;
                        }
                        &::-webkit-scrollbar-track{
                            background: none;
                        }
                        &::-webkit-scrollbar-thumb{
                            background: #DDDDDD;
                            border: pxToVw(5) solid rgba(221, 221, 221, 0.6);
                        }
                        .agendaList-one{
                            display: flex;
                            width: 100%;
                            height: auto;
                            align-items: flex-start;
                            cursor: pointer;
                            text-align: left;
                            margin-bottom: pxToVw(24);
                            &:hover{
                                .title{
                                    color: #C50819;
                                }
                            }
                            .time{
                                width: pxToVw(100);
                                font-size: pxToVw(19);
                                font-family: "ABlack";
                                color: #333;
                                line-height: pxToVw(24);
                                font-weight: 900;
                            }
                            .line{
                                vertical-align: top;
                                display: inline-block;
                                margin: pxToVw(5) pxToVw(36) 0 pxToVw(24);
                                width: pxToVw(11);
                                height: pxToVw(9);
                            }
                            .title{
                                width: pxToVw(320);
                                font-size: pxToVw(17);
                                color: #333;
                                line-height: pxToVw(26);
                            }
                            .guest{
                                margin-left: pxToVw(22);
                                display: flex;
                                font-size: pxToVw(14);
                                line-height: pxToVw(20);
                                color: #999;
                                margin-bottom: pxToVw(10);
                                &:last-child{
                                    margin-bottom: 0;
                                }
                                p{  
                                    width: pxToVw(50);
                                    margin: 0 0 0 0;
                                    text-align: justify;
                                    text-align-last: justify;
                                    word-break: break-all;
                                    text-justify: distribute;
                                    &:nth-child(2){
                                        // margin: 0 0 0 0;
                                        width: pxToVw(10);
                                        text-align: center;
                                        text-align-last: center;
                                    }
                                    &:nth-child(3){
                                        // margin: 0 0 0 0;
                                        width: pxToVw(230);
                                        text-align: left;
                                        text-align-last: left;
                                    }
                                }
                            }
                        }
                    }
                    .main-one-image{
                        margin: pxToVw(0) pxToVw(2) 0 0;
                        width: pxToVw(193);
                        height: pxToVw(390);//390
                        background: url(../assets/newImages/agenda/agenda-img.png) no-repeat center center/cover;
                        display: flex;
                        justify-content: space-between;
                        flex-direction: column;
                        padding: pxToVw(50) pxToVw(17);
                        .main-one-image-top{
                            .title{
                                font-size: pxToVw(19);
                                color: #FFFFFF;
                                font-family: "FZLT-blackLittle";
                                line-height: pxToVw(27);
                                height: pxToVw(50);
                                overflow: hidden;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                                text-overflow :ellipsis; 
                            }
                            .time{
                                margin: pxToVw(15) 0 pxToVw(5);
                                font-size: pxToVw(21);
                                font-weight: 900;
                                font-family: "ABlack";
                                color: #FFFFFF;
                                line-height: pxToVw(25); 
                            }
                            .address{
                                margin-top: pxToVw(7);
                                display: flex;
                                align-items: center;
                                img{
                                    width: pxToVw(13);
                                    height: pxToVw(16);
                                    margin-right: pxToVw(8);
                                }
                                span{
                                    width: pxToVw(135);
                                    font-size: pxToVw(13);
                                    color: #FFFFFF;
                                    line-height: pxToVw(16);
                                }
                            }
                        }
                        .main-one-image-bottom{
                            display: flex;
                            align-items: center;
                            margin-top: pxToVw(25);
                            .bottom-icon{
                                width: pxToVw(25);
                                height: pxToVw(24);
                                cursor: pointer;
                                margin-right: pxToVw(24);
                                &:first-child{
                                    img{
                                        opacity: 0.6;
                                        margin-top: pxToVw(-1);
                                        &:nth-child(2){
                                            opacity: 1;
                                        }
                                    }
                                }
                                img{
                                    width: 100%;
                                    vertical-align: top;
                                    &:nth-child(2){
                                        display: none;
                                    }
                                }
                            }
                            .bottom-icon-active{
                                img{
                                    display: none;
                                    &:nth-child(2){
                                        display: block;
                                    }
                                }
                            }
                        }
                    }
                    .main-one-image2{
                        margin: pxToVw(0) pxToVw(2) 0 0;
                        width: pxToVw(193);
                        height: pxToVw(390);
                        .main-one-image-one{
                            position: relative;
                            width: pxToVw(193);
                            height: pxToVw(195);
                            cursor: pointer;
                            padding: pxToVw(20) pxToVw(17);
                            // border-bottom: 2px solid rgba(255, 255, 255, 0.5);
                            &:last-child{
                                // border: none;
                                .image-bg1{
                                    top: pxToVw(1);
                                    &:nth-child(2){
                                        top: pxToVw(2);
                                    }
                                }
                            }
                            z-index: 2;
                            .image-bg1{
                                position: absolute;
                                z-index: -1;
                                top: 0;
                                left: 0;
                                width: 100%;
                                height: pxToVw(194);
                                &:nth-child(2){
                                    display: none;
                                    height: pxToVw(193);
                                }
                                img{
                                    height: 100%;
                                    vertical-align: top;
                                }
                            }
                            .main-one-image-top{
                                .title{
                                    font-size: pxToVw(18);
                                    color: #FFFFFF;
                                    font-family: "FZLT-blackLittle";
                                    line-height: pxToVw(24);
                                    height: pxToVw(68);
                                    overflow: hidden;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 3;
                                    -webkit-box-orient: vertical;
                                    text-overflow :ellipsis; 
                                }
                                .time{
                                    margin-top: pxToVw(7);
                                    font-size: pxToVw(21);
                                    font-weight: 900;
                                    font-family: "ABlack";
                                    color: #FFFFFF;
                                    line-height: pxToVw(25); 
                                }
                                .address{
                                    display: none;
                                    align-items: center;
                                    margin-top: pxToVw(7);
                                    img{
                                        width: pxToVw(13);
                                        height: pxToVw(16);
                                        margin-right: pxToVw(8);
                                    }
                                    span{
                                        width: pxToVw(135);
                                        font-size: pxToVw(13);
                                        color: #FFFFFF;
                                        line-height: pxToVw(16);
                                    }
                                }
                            }
                            .main-one-image-bottom{
                                display: none;
                                align-items: center;
                                margin-top: pxToVw(15);
                                .bottom-icon{
                                    width: pxToVw(25);
                                    height: pxToVw(24);
                                    margin-right: pxToVw(24);
                                    img{
                                        width: 100%;
                                        vertical-align: top;
                                        &:nth-child(2){
                                            display: none;
                                        }
                                    }
                                    &:first-child{
                                        img{
                                            opacity: 0.6;
                                            margin-top: pxToVw(-1);
                                            &:nth-child(2){
                                                opacity: 1;
                                            }
                                        }
                                    }
                                }
                                .bottom-icon-active{
                                    img{
                                        display: none;
                                        &:nth-child(2){
                                            display: block;
                                        }
                                    }
                                }
                            }
                        }
                        .main-one-image-active{
                            &:last-child{
                                // border: none;
                                // border-top: 2px solid rgba(255, 255, 255, 0.5);
                                .image-bg1{
                                    top: 1px;
                                    &:nth-child(2){
                                        top: 2px !important;
                                    }
                                }
                            }
                            .image-bg1{
                                display: none;
                                &:nth-child(2){
                                    display: block;
                                }
                            }
                            .main-one-image-top{
                                .address{
                                    display: flex;
                                }
                            }
                            .main-one-image-bottom{
                                display: flex;
                            }
                        }
                    }
                }
                .agenda-main2{
                    .agenda-image{
                        background: url(../assets/newImages/home/agenda-main2-image.png) no-repeat center center/cover;
                        .text-p{
                            font-size: pxToVw(17);
                            color: #FFFFFF;
                            line-height: pxToVw(29);
                        }
                    }
                    .agenda-lists-main{
                        margin: pxToVw(-20) 0 0 pxToVw(34);
                        width: pxToVw(853);
                        padding-right: pxToVw(40);
                        height: pxToVw(432);
                        .agendaList-one{
                            display: flex;
                            width: 100%;
                            // height: pxToVw(71);
                            padding: pxToVw(25) 0;
                            text-align: left;
                            cursor: pointer;
                            margin: 0;
                            border-bottom: 1px solid #EEEEEE;
                            &:last-child{
                                border-bottom:none;
                            }
                            &:hover{
                                .title{
                                    color: #C50819;
                                }
                            }
                            .line{
                                vertical-align: top;
                                display: inline-block;
                                margin: pxToVw(5) pxToVw(28) 0 pxToVw(5);
                                width: pxToVw(11);
                                height: pxToVw(9);
                            }
                            .title{
                                width: pxToVw(400);
                                font-size: pxToVw(17);
                                color: #333;
                                line-height: pxToVw(20);
                            }
                            .time-div{
                                width: pxToVw(150);
                                margin: 0 pxToVw(20) 0 pxToVw(50);
                                font-size: pxToVw(14);
                                line-height: pxToVw(16);
                                color: #999999;
                                display: flex;
                                align-items: center;
                                img{
                                    width: pxToVw(13);
                                    height: pxToVw(13);
                                    vertical-align: top;
                                    margin: pxToVw(2) pxToVw(7) 0 0;
                                }
                            }
                            .address-div{
                                margin: 0;
                                img{
                                    vertical-align: top;
                                    width: pxToVw(12);
                                    height: pxToVw(16);
                                }
                                p{
                                    width: pxToVw(125);
                                }
                            }
                        }
                    }
                }
                .agenda-main3{
                    .agenda-image{
                        background: url(../assets/newImages/home/agenda-main3-image.png) no-repeat center center/cover;
                    }
                    .agenda-lists-main{
                        width: pxToVw(864);
                        padding-right: pxToVw(51);
                        height: pxToVw(432);
                        overflow-y: scroll;
                        .agendaList-one{
                            display: flex;
                            width: 100%;
                            padding: pxToVw(25) 0;
                            text-align: left;
                            margin: 0;
                            border-bottom: 1px solid #EEEEEE;
                            &:last-child{
                                border-bottom:none;
                            }
                            &:hover{
                                .title{
                                    color: #C50819;
                                }
                            }
                            .num{
                                width: pxToVw(109);
                                height: pxToVw(26);
                                margin-right: pxToVw(20);
                                img{
                                    width: 100%;
                                }
                            }
                            .title{
                                width: pxToVw(325);
                                font-size: pxToVw(17);
                                color: #333;
                                line-height: pxToVw(20);
                            }
                            .time-div{
                                width: pxToVw(150);
                                margin: 0 pxToVw(20) 0 pxToVw(30);
                                img{
                                    margin-top: pxToVw(3);
                                }
                            }
                            .address-div{
                                margin: 0;
                                img{
                                    margin-top: pxToVw(1);
                                }
                            }
                        }
                    }
                }
            }
            .tishi{
                position: absolute;
                right: 0;
                bottom: pxToVw(-33);
            }
        }
    }
    .con-page4{
        position: relative;
        box-shadow: 0px -8px 16px 0px rgba(232,232,232,0.5);
        background: url("../assets/newImages/home/page4.png")no-repeat center center/cover,#FFF;
        .bg-img{
            position: absolute;
            top: pxToVw(-256);
            right: 0;
            width: pxToVw(309);
            img{
                width: 100%;
            }
        }
        .bg-img2{
            position: absolute;
            bottom: pxToVw(-56);
            left: 0;
            width: pxToVw(441);
            img{
                width: 100%;
            }
        }
        .data-content{
            width: pxToVw(1288);
            // margin: pxToVw(118) 0 0 pxToVw(72);
            margin: 5.7vh 0 0 pxToVw(72);
            height: auto;
            position: relative;
            z-index: 2;
            display: flex;
            justify-content: space-between;
            height: pxToVw(538);
            .data-content-bg{
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translate(-50%,0);
                z-index: -1;
                width: pxToVw(1112);
                height: pxToVw(326);
                background: #EAD9DA;
                border-radius: 2px;
            }
            .data-content-one{
                margin-top: pxToVw(53);
                width: pxToVw(306);
                height: pxToVw(378);
                background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0.5) 100%);
                box-shadow: 0px 0px pxToVw(10) 0px rgba(211,211,211,0.5);
                border-radius: 3px;
                display: flex;
                position: relative;
                align-items: center;
                flex-direction: column;
                cursor: pointer;
                padding: pxToVw(65) pxToVw(50) 0;
                &:hover{
                    margin-top: pxToVw(0);
                    padding: pxToVw(77) 0 0;
                    width: pxToVw(305);
                    height: pxToVw(400);
                    background: url("../assets/newImages/home/page4-hover-bg.png") no-repeat center center/cover;
                    .num{
                        font-size: pxToVw(67);
                        line-height: pxToVw(83);
                        color: #FFFFFF;
                        span{
                            font-size: pxToVw(38);
                            color: #FFFFFF;
                        }
                    }
                    .title{
                        font-size: pxToVw(24);
                        line-height: pxToVw(28);
                        color: #FFF;
                        margin: pxToVw(17) 0 pxToVw(56);
                    }
                    .info{
                        font-size: pxToVw(17);
                        line-height: pxToVw(24);
                        color: #FFF;
                    }
                    .bottom{
                        display: block;
                    }
                }
                .num{
                    font-size: pxToVw(53);
                    line-height: pxToVw(66);
                    font-family: "ABlack";
                    font-weight: 900;
                    color: #C50819;
                    span{
                        font-size: pxToVw(41);
                    }
                }
                .title{
                    font-size: pxToVw(24);
                    line-height: pxToVw(28);
                    color: #333330;
                    margin: pxToVw(31) 0 pxToVw(29);
                }
                .info{
                    width: pxToVw(205);
                    margin: 0 auto;
                    font-size: pxToVw(17);
                    line-height: pxToVw(24);
                    color: #666;
                }
                .bottom{
                    position: absolute;
                    top: 100%;
                    left: 0;
                    width: 100%;
                    height: pxToVw(31);
                    display: none;
                }
            }
        }
    }
    .con-page5{
        position: relative;
        z-index: 2;
        box-shadow: 0px -8px 16px 0px rgba(232,232,232,0.5);
        background: url("../assets/newImages/home/page5.png")no-repeat center center/cover,#FFF;
        .bg-img{
            position: absolute;
            top: pxToVw(-199);
            left: 0;
            width: pxToVw(441);
            img{
                width: 100%;
            }
        }
        .bg-img2{
            position: absolute;
            bottom: pxToVw(-313);
            right: 0;
            width: pxToVw(336);
            img{
                width: 100%;
            }
        }
        .bg-img3{
            position: absolute;
            top: pxToVw(-351);
            right: 0;
            width: pxToVw(336);
            height: pxToVw(671);
            z-index: -1;
            img{
                width: 100%;
            }
        }
        .hot-main{
            margin: pxToVw(4) 0 pxToVw(-20) pxToVw(75);
            .hot-news-list{
                height: pxToVw(499);
                width: pxToVw(1284);
                position: relative;
                overflow: hidden;
            }
            .hot-news{
                position: absolute;
                top: 0;
                left: 0;
                height: pxToVw(499);
                width: pxToVw(1284);
                display: flex;
                opacity: 0;
                transform: translateX(100%);
                transition: all ease-in-out 0.3s;
                .hot-left{
                    cursor: pointer;
                    width: pxToVw(637);
                    height: pxToVw(499);
                    .hot-image{
                        width: pxToVw(637);
                        height: pxToVw(359);
                        overflow: hidden;
                        img{
                            width: pxToVw(637);
                            // height: pxToVw(359);
                        }
                    }
                    .hot-text{
                        width: pxToVw(637);
                        height: pxToVw(140);
                        background: #666666;
                        text-align: left;
                        border-radius: 2px;
                        padding: pxToVw(30) pxToVw(38) 0;
                        p{
                            font-size: pxToVw(17);
                            color: #FFFFFF;
                            line-height: pxToVw(29);
                            height: pxToVw(58);
                            overflow: hidden;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            text-overflow :ellipsis; 
                            -webkit-box-orient: vertical;
                        }
                        .img{
                            float: right;
                            width: pxToVw(29);
                            height: pxToVw(24);
                            img{
                                width: pxToVw(29);
                                height: pxToVw(24);
                            }
                        }
                    }
                }
                .hot-right{
                    width: pxToVw(647);
                    height: pxToVw(499);
                    background: rgba(255, 255, 255, 0.7);
                    border-radius: 2px;
                    padding: pxToVw(40) 0 0 pxToVw(45);
                    // opacity: 0.7;
                    .hot-right-one{
                        width: 100%;
                        cursor: pointer;
                        display: flex;
                        .days{
                            width: pxToVw(50);
                            p{
                                padding: pxToVw(6) 0;
                                font-size: pxToVw(29);
                                font-family: "ABlack";
                                font-weight: 900;
                                color: #333333;
                                line-height: pxToVw(35);
                                border-bottom: 1px solid #AAAAAA;
                            }
                            span{
                                margin-top: pxToVw(5);
                                font-size: pxToVw(23);
                                font-family: "ABlack";
                                font-weight: 900;
                                color: #333333;
                                line-height: pxToVw(28);
                            }
                        }
                        .hot-main-title{
                            margin: 0 0 pxToVw(31) pxToVw(33);
                            padding-left: pxToVw(25);
                            text-align: left;
                            width: pxToVw(470);
                            border-left: 1px solid #CCCCCC;
                            .title{
                                font-size: pxToVw(17);
                                color: #333333;
                                line-height: pxToVw(29);
                                overflow: hidden;
                                // padding-right: pxToVw(28);
                                text-overflow :ellipsis; 
                                white-space: nowrap; 
                            }
                            .text{
                                height: pxToVw(40);
                                font-size: pxToVw(14);
                                color: #999999;
                                line-height: pxToVw(22);
                                // padding-right: pxToVw(28);
                                margin: pxToVw(5) 0 pxToVw(30);
                                overflow: hidden;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                text-overflow :ellipsis; 
                                -webkit-box-orient: vertical;
                            }
                            .img{
                                width: pxToVw(22);
                                height: pxToVw(18);
                                img{
                                    width: pxToVw(22);
                                    height: pxToVw(18);
                                }
                            }
                        }
                    }
                }
            }
            .hot-news-active{
                opacity: 1;
                transform: translateX(0);
                transition: all ease-in-out 0.3s;
            }
            .hot-news-oldActive{
                transform: translateX(-100%);
                transition: all ease-in-out 0.3s;
            }
        }
        .more{
            margin: 5.4vh auto 0 !important;
        }
    }
    .con-page6{
        position: relative;
        box-shadow: 0px -8px 16px 0px rgba(232,232,232,0.5);
        background: url("../assets/newImages/home/page5.png")no-repeat center center/cover,#FFF;
        // .bg-img{
        //     position: absolute;
        //     top: pxToVw(-351);
        //     right: 0;
        //     width: pxToVw(336);
        //     height: pxToVw(671);
        //     img{
        //         width: 100%;
        //     }
        // }
        .bg-img3{
            position: absolute;
            bottom: pxToVw(-25);
            left: 0;
            width: pxToVw(163);
            img{
                width: 100%;
            }
        }
        .con-1200{
            margin-top: 4vh !important;
        }
        .com-main{
            // margin: pxToVw(41) pxToVw(55) 0 pxToVw(73);
            margin: 0.8vh pxToVw(55) 0 pxToVw(73);
            .com-main-top{
                width: pxToVw(1289);
                height: pxToVw(148);
                background: url("../assets/newImages/home/page6-main-top-bg.png")no-repeat center center/cover;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                // margin-bottom: pxToVw(16);
                margin-bottom: 1.3vh;
                cursor: pointer;
                p{
                    font-size: pxToVw(24);
                    // color: #333333;
                    font-family: "FZLT-blackLittle";
                    line-height: pxToVw(29);
                    color: #C50819;
                }
                img{
                    width: pxToVw(136);
                    height: pxToVw(68);
                    margin-top: pxToVw(8);
                }
            }
            .com-main-bottom{
                width: pxToVw(1289);
                height: pxToVw(468);
                .sponsor-main{
                    width: pxToVw(1289);
                    display: flex;
                    align-items: center;
                    .sponsor-one{
                        width: pxToVw(72);
                        position: relative;
                        margin-right: pxToVw(3);
                        &:last-child{
                            margin-right: 0;
                        }
                        .sponsor-one-img{
                            position: relative;
                            z-index: 2;
                            width: pxToVw(72);
                            cursor: pointer;
                            height: pxToVw(468);
                            padding: pxToVw(62) pxToVw(20) 0;
                            img{
                                position: absolute;
                                left: 0;
                                top: 0;
                                z-index: -1;
                                width: pxToVw(72);
                                height: pxToVw(468);
                            }
                            p{  
                                position: relative;
                                z-index: 3;
                                font-size: pxToVw(22);
                                color: #333333;
                                line-height: pxToVw(30);
                            }
                            .sponsor-one-img-bg{
                                position: absolute;
                                left: 0;
                                top: 0;
                                width: pxToVw(72);
                                height: pxToVw(468);
                                border-radius: 0 pxToVw(30) 0 pxToVw(30); 
                                // background: rgba(255, 255, 255, 0.3);
                                background: linear-gradient(rgba(255,255,255,1),rgba(255,255,255,0));
                            }
                        }
                        .sponsor-logo-list{
                            position: absolute;
                            left: pxToVw(25);
                            top:0;
                            display: none;
                            width: pxToVw(964);
                            padding: pxToVw(41) pxToVw(19) 0 pxToVw(73);
                            height: pxToVw(468);
                            background: rgba(255, 255, 255, 0.7);
                            border-radius: pxToVw(3);
                            .sponsor-logo-main{
                                width: pxToVw(872);
                                height: pxToVw(320);
                                margin-top: pxToVw(33);
                                overflow: hidden;
                                position: relative;
                                .sponsor-logoOne{
                                    display: flex;
                                    flex-wrap: wrap;
                                    align-items: flex-start;
                                    width: pxToVw(872);
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    opacity: 0;
                                    transform: translateX(100%);
                                    transition: all ease-in-out 0.3s;
                                    .sponsorLogo{
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        width: pxToVw(144);
                                        cursor: pointer;
                                        height: pxToVw(72);
                                        background: #FFFFFF;
                                        border-radius: 1px;
                                        margin: 0 pxToVw(38) pxToVw(17) 0;
                                        &:nth-child(5n){
                                            margin-right: 0;
                                        }
                                        img{
                                            width: 100%;
                                            height: 100%;
                                        }
                                    }
                                    // .partner-logo{
                                    //     object-fit: fill;
                                    // }
                                }
                                .sponsor-logoOne-active{
                                    opacity: 1;
                                    transform: translateX(0);
                                    transition: all ease-in-out 0.3s;
                                }
                                .sponsor-logoOne-oldActive{
                                    transform: translateX(-100%);
                                    transition: all ease-in-out 0.3s;
                                }
                            }
                        }
                    }
                    .sponsor-active{
                        width: pxToVw(990);
                        .sponsor-one-img{
                            p{
                                font-family: "FZLT-blackBold";
                                color: #C50819;
                            }
                            .sponsor-one-img-bg{
                                // display: none;
                            }
                        }
                        .sponsor-logo-list{
                            display: block;
                        }
                    }
                }
            }
        }
        .tishi{
            margin: pxToVw(10) 0 0;
            padding-right: pxToVw(10);
        }
        .more{
            margin-top: 0 !important;
        }
    }
    .con-page12{
        position: relative;
        box-shadow: 0px -8px 16px 0px rgba(232,232,232,0.5);
        background: url("../assets/newImages/home/page5.png")no-repeat center center/cover,#FFF;
        .bg-img{
            position: absolute;
            bottom: pxToVw(-32);
            left: 0;
            width: pxToVw(204);
            // height: 176;
            img{
                width: 100%;
            }
        }
        .bg-img2{
            position: absolute;
            top: pxToVw(-183);
            right: 0;
            width: pxToVw(199);
            img{
                width: 100%;
            }
        }
        .twins-content{
            margin: pxToVw(69) 0 0 pxToVw(99);
            width: pxToVw(1382);
            height: pxToVw(467);
            padding-top: pxToVw(47);
            .swiper-slide{
                position: relative;
                width: pxToVw(741);
                height: pxToVw(420);
                margin-right: pxToVw(24);
                display: block;
                padding: pxToVw(93) 0 0 0;
                background: url(../assets/newImages/home/guest/twins-bg.png) center center/cover no-repeat;
                &:last-child{
                    margin-right: 0;
                }
                .bg-img{
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    z-index: 2;
                    width: pxToVw(264);
                    height: pxToVw(108);
                    img{
                        width: 100%;
                        height: 100%;
                        vertical-align: top;
                    }
                }
                .people-img{
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    // z-index: 2;
                    width: pxToVw(265);
                    height: pxToVw(350);
                    img{
                        width: 100%;
                        height: 100%;
                        vertical-align: top;
                    }
                }
                .text{
                    padding-left: pxToVw(283);
                    width: pxToVw(693);
                    height: auto;
                    text-align: left;
                    .name{
                        font-size: pxToVw(22);
                        font-family: "FZLT-blackBold";
                        color: #111111;
                        line-height: pxToVw(25);
                    }
                    .post{
                        height: pxToVw(36);
                        font-size: pxToVw(14);
                        color: #999999;
                        line-height: pxToVw(19);
                        margin: pxToVw(5) 0 pxToVw(14);
                        overflow: hidden;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        text-overflow :ellipsis;
                    }
                    .detail-div{
                        display: flex;
                        align-items: center;
                        height: pxToVw(240);
                        justify-content: center;
                        margin-top: -2vw;
                        .text-show{
                            position: relative;
                            width: pxToVw(402);
                            margin: 0 auto;
                            .show-img{
                                position: absolute;
                                width: pxToVw(19);
                                height: pxToVw(20);
                                top: pxToVw(-8);
                                left: 0;
                                img{width: 100%;height: 100%;vertical-align: top;}
                            }
                            .detail{
                                font-size: pxToVw(14);
                                color: #666666;
                                max-height: pxToVw(240);
                                line-height: pxToVw(22);
                                text-indent: pxToVw(25);
                                overflow: hidden;
                                display: -webkit-box;
                                -webkit-line-clamp: 11;
                                -webkit-box-orient: vertical;
                                text-overflow :ellipsis;
                                text-align: justify;
                            }
                        }
                    }
                }
            }
            .swiper-button-next,.swiper-button-prev{
                top: 0;
                left: pxToVw(1224);
                width: pxToVw(35);
                height: pxToVw(35);
                background: #C50819;
                &::after{
                    content:''
                }
                img{
                    width: pxToVw(17);
                    height: pxToVw(13);
                }
            }
            .swiper-button-prev{
                left: pxToVw(1173);
            }
            .swiper-button-disabled{
                opacity: 1;
                background: #C5C5C5;
            }
            .twins-bg{
                position: absolute;
                right: 0;
                top: pxToVw(45);
                width: pxToVw(161);
                height: pxToVw(425);
                background: linear-gradient(270deg, #E3EFFA 0%, rgba(255, 255, 255, 0) 100%);
                border-radius: 1px;
                z-index: 2;
            }
        }
    }
    .con-page7{
        position: relative;
        box-shadow: 0px -8px 16px 0px rgba(232,232,232,0.5);
        background: url("../assets/newImages/home/page3.png")no-repeat center center/cover,#FFF;
        .bg-img{
            position: absolute;
            top: pxToVw(-157);
            left: 0;
            width: pxToVw(204);
            // height: 176;
            img{
                width: 100%;
            }
        }
        .bg-img2{
            position: absolute;
            bottom: pxToVw(-217);
            right: 0;
            width: pxToVw(252);
            // height: 176;
            img{
                width: 100%;
            }
        }
        .con-main{
            margin: pxToVw(55) 0 pxToVw(66) pxToVw(72);
            .video-main{
                width: pxToVw(1284);
                height: pxToVw(361);
                overflow: hidden;
                position: relative;
                .video-one{
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: pxToVw(1284);
                    height: pxToVw(361);
                    display: flex;
                    opacity: 0;
                    transform: translateX(100%);
                    transition: transform ease-in-out 0.3s;
                    align-items: center;
                    .video-one-three{
                        width: pxToVw(392);
                        height: pxToVw(361);
                        margin-right: pxToVw(54);
                        background: #fff;
                        cursor: pointer;
                        &:nth-child(3n){
                            margin-right: 0;
                        }
                        &:hover{
                            .video-show-one{
                                display: none;
                            }
                            .video-show-two{
                                display: block;
                            }
                        }
                        .video-show-one{
                            width: pxToVw(392);
                            height: pxToVw(361);
                            flex-direction: column;
                            .img-bg{
                                width: pxToVw(392);
                                height: pxToVw(102);
                                // background: linear-gradient(180deg, rgba(118, 53, 53, 0) 0%, #000000 100%);
                                top: pxToVw(118);
                                position: absolute;
                            }
                            img{
                                vertical-align: top;
                                width: pxToVw(392);
                                height: pxToVw(220);
                            }
                            .p{
                                width: pxToVw(392);
                                height: pxToVw(91);
                                background: #FFFFFF;
                                font-size: pxToVw(17);
                                font-weight: normal;
                                color: #666666;
                                line-height: pxToVw(26);
                                padding: pxToVw(19) pxToVw(18) pxToVw(17);
                                text-align: left;
                            }
                            .button{
                                width: pxToVw(392);
                                height: pxToVw(50);
                                background: #C50819;
                                border-radius: 0px 0px 3px 3px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                p{
                                    font-size: pxToVw(14);
                                    color: #FFFFFF;
                                    line-height: pxToVw(14);
                                }
                                img{
                                    vertical-align: top;
                                    width: pxToVw(12);
                                    height: pxToVw(14); 
                                    margin: pxToVw(0) 0 0 pxToVw(7);
                                }
                            }
                            
                        }
                        .video-show-two{
                            display: none;
                            width: pxToVw(392);
                            height: pxToVw(361);
                            overflow: hidden;
                            position: relative;
                            img{
                                // width: pxToVw(392);
                                margin: auto;
                                margin-left: -32%;
                                height: pxToVw(361);
                            }
                            .bg{
                                left: 0;
                                width: pxToVw(392);
                                height: pxToVw(102);
                                background: linear-gradient(180deg, rgba(118, 53, 53, 0) 0%, #000000 100%);
                                position: absolute;
                                z-index: 1;
                                margin-top: pxToVw(-102);
                                padding: pxToVw(26) pxToVw(17) pxToVw(23);
                                margin-left: 0;
                                p{
                                    font-size: pxToVw(17);
                                    font-weight: normal;
                                    color: #FFFFFF;
                                    line-height: pxToVw(26);
                                    text-align: left;
                                }
                                .video-start{
                                    width: pxToVw(45);
                                    height: pxToVw(53); 
                                    position: absolute;
                                    // top: pxToVw(0);
                                    left: 50%;
                                    transform: translateX(-50%);
                                    margin-top: -40%;
                                    img{
                                        width: 100%;
                                        height: 100%;
                                        vertical-align: top;
                                    }
                                }
                                
                            }
                        }
                    }
                }
                .video-one-active{
                    opacity: 1;
                    transform: translateX(0);
                    transition: all ease-in-out 0.3s;
                }
                .video-one-oldActive{
                    transform: translateX(-100%);
                    transition: all ease-in-out 0.3s;
                }
            }
        }
    }
    .con-page8{
        position: relative;
        box-shadow: 0px -8px 16px 0px rgba(232,232,232,0.5);
        background: url("../assets/newImages/home/page3.png")no-repeat center center/cover,#FFF;
        .bg-img{
            position: absolute;
            bottom: pxToVw(61);
            right: 0;
            width: pxToVw(285);
            // height: pxToVw(309);
            img{
                width: 100%;
                height: 100%;
            }
        }
        .bg-img2{
            position: absolute;
            bottom: 0;
            left: 0;
            width: pxToVw(188);
            img{
                width: 100%;
            }
        }
        .con-1200{
            margin-top: 4vh !important;
            .con-main{
                // margin: pxToVw(48) 0 0 pxToVw(71);
                margin: pxToVw(8) 0 0 pxToVw(102);
                width: pxToVw(1194);
                .image{
                    position: relative;
                    // width: pxToVw(1232);
                    // height: pxToVw(512);
                    margin: 0 auto;
                    width: pxToVw(1109);
                    height: pxToVw(461);
                    background: url("../assets/newImages/home/page8-map11.jpg")no-repeat center center/cover;
                    cursor: pointer;
                }
                .more{
                    width: pxToVw(1194) !important;//1600宽度
                    margin: 3vh auto !important;
                }
                .applet{
                    // width: pxToVw(1286);
                    // height: pxToVw(116);
                    width: pxToVw(1157);//1550宽度
                    height: pxToVw(130);
                    margin: pxToVw(10) auto 0;
                    img{
                        vertical-align: top;
                        width: 100%;
                    }
                }
            }
            
        }
        .more{
            margin-top: 0.5vh !important;
        }
        // 底部
        .footer{
            position: absolute;
            z-index: 99;
            bottom: 0;
            width: 100%;
            height: pxToVw(120);
            background: #F4F4F4;
            border-radius: 1px;
            padding: 0 pxToVw(200);
            display: flex;
            justify-content: space-between;
            .left{
                text-align: left;
                padding-top: pxToVw(22);
                p{
                    font-size: pxToVw(14);
                    font-weight: normal;
                    color: #666666;
                    line-height: pxToVw(24);
                    &:nth-child(1){
                        font-size: pxToVw(17);
                        font-weight: 600;
                        color: #333333;
                        line-height: pxToVw(20);
                        margin-bottom: pxToVw(8);
                    }
                }
            }
            .right{
                padding-top: pxToVw(22);
                .title-img{
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    p{
                        font-size: pxToVw(17);
                        font-weight: normal;
                        color: #666666;
                        line-height: pxToVw(20);
                    }
                    .logos{
                        display: flex;
                        margin-left: pxToVw(2);
                        .img{
                            position: relative;
                            width: pxToVw(30);
                            height: pxToVw(30);
                            border-radius: 5px;
                            border: 1px solid #AAAAAA;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin-left: pxToVw(10);
                            cursor: pointer;
                            &:nth-child(2){
                                img{
                                    width: pxToVw(17);
                                }
                            }
                            &:nth-child(3){
                                img{
                                    width: pxToVw(19);
                                }
                            }
                            img{
                                vertical-align: top;
                                width: pxToVw(20);
                            }
                        }
                    }
                }
                p{
                    font-size: pxToVw(14);
                    font-weight: normal;
                    line-height: pxToVw(24);
                    text-align: right;
                    &:nth-child(2){
                        color: #666666;
                        margin-top: pxToVw(2);
                    }
                    &:nth-child(3){
                        color: #999;
                    }           
                }
            }
        }
    }
    .cover-page1{
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0,0,0,0.5);
        border-radius: 4px;
        .cover-main{
            width: pxToVw(549);
            height: pxToVw(344);
            background: #FFFFFF;
            border-radius: pxToVw(9);
            .cover-close{
                float: right;
                width: pxToVw(62);
                cursor: pointer;
                height: pxToVw(62);
                padding: pxToVw(24) pxToVw(24) pxToVw(19) pxToVw(19);
                img{
                    width: pxToVw(19);
                    height: pxToVw(19);
                }
            }
            .cover-content{
                width: 100%;
                height: auto;
                display: flex;
                justify-content: space-between;
                padding: 0 pxToVw(86) pxToVw(44);
                border-bottom: 1px solid #EEEEEE;
                .cover-one{
                    width: pxToVw(180);
                    height: pxToVw(160);
                    background: #FFFFFF;
                    padding: pxToVw(35) 0 pxToVw(29);
                    display: flex;
                    flex-direction: column;
                    cursor: pointer;
                    align-items: center;
                    justify-content: space-between;
                    box-shadow: 0px 0px pxToVw(12) 0px rgba(211,211,211,0.5);
                    border-radius: pxToVw(5);
                    img{    
                        width: pxToVw(44);
                        height: pxToVw(45);
                    }
                    p{
                        font-size: pxToVw(19);
                        color: #333333;
                        line-height: pxToVw(24);
                    }
                }
            }
            .text{
                margin-top: pxToVw(27);
                font-size: pxToVw(19);
                font-family: "FZLT-blackBold";
                color: #C50819;
                text-align: center;
                line-height: pxToVw(24);
            }
        }
    }
    .cover-page1{cursor: pointer;}
    .cover-page-video{
        position: fixed;
        z-index: 1001;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: pxToVw(1280);
        height: pxToVw(720);
        video{
            width: pxToVw(1280);
            height: pxToVw(720);
            border: none;
        }
        .close{
            position: absolute;
            top: pxToVw(-70);
            right: 0;
            width: pxToVw(50);
            height: pxToVw(50);
            font-size: pxToVw(60);
            line-height: pxToVw(50);
            color: #FFF;
            cursor: pointer;
        }
    }
    .con-page9{
        position: relative;
        width: 100%;height: 100%;
        box-shadow: 0px -8px 16px 0px rgba(232,232,232,0.5);
        background: url("../assets/newImages/home/page4.png")no-repeat center center/cover,#FFF;
        .bg-img{
            position: absolute;
            top: pxToVw(-256);
            right: 0;
            width: pxToVw(309);
            img{
                width: 100%;
            }
        }
        .bg-img2{
            position: absolute;
            bottom: pxToVw(-62);
            left: 0;
            width: pxToVw(436);
            img{
                width: 100%;
            }
        }
        .guest-content{
            margin: pxToVw(-27) 0 0 pxToVw(71);
            width: pxToVw(1288);
            height: auto;
            .guest-list{
                margin-top: pxToVw(-12);
                width: pxToVw(1288);
                height: pxToVw(531);
                overflow: hidden;
                position: relative;
                .guest-one{
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: pxToVw(1288);
                    height: pxToVw(531);
                    display: flex;
                    opacity: 0;
                    transform: translateX(100%);
                    transition: transform ease-in-out 0.3s;
                    align-items: flex-end;
                    // justify-content: space-between;
                    .guest1{
                        margin-right: pxToVw(18);
                        cursor: pointer;
                        &:last-child{
                            margin-right: 0;
                        }
                        &:hover{
                            .guest1-one{display: none;}
                            .guest1-two{display: block;}
                        }
                        .guest1-one{
                            position: relative;
                            width: pxToVw(218);
                            z-index: 2;
                            height: pxToVw(471);
                            background: rgba(255, 255, 255, 0.7);
                            border-radius: 2px;
                            padding: pxToVw(39) 0 0 pxToVw(23);
                            .bg-img{
                                position: absolute;
                                top:pxToVw(105);right: 0;
                                width: pxToVw(203);
                                height: pxToVw(213);
                                z-index: -1;
                                img{
                                    width: 100%;
                                    vertical-align: top;
                                }
                            }
                            .name{
                                width: pxToVw(85);
                                text-align: left;
                                font-size: pxToVw(26);
                                font-family: "FZLT-blackLittle";
                                color: #333333;
                                line-height: pxToVw(31);
                                margin-bottom: pxToVw(17);
                                text-align: justify;
                                text-align-last: justify;
                                word-break: break-all;
                                text-justify: distribute;
                            }
                            .text{
                                width: pxToVw(154);
                                text-align: left;
                                font-size: pxToVw(17);
                                color: #666;
                                line-height: pxToVw(24);
                            }
                            .people-img{
                                position: absolute;
                                bottom: 0;
                                right: 0;
                                width: pxToVw(206);
                                // height: pxToVw(298);
                                height: pxToVw(280);
                                overflow: hidden;
                                display: flex;
                                justify-content: center;
                                align-items: flex-start;
                                img{
                                    vertical-align: top;
                                    height: 100%;
                                }
                            }
                        }
                        .guest1-two{
                            display: none;
                            position: relative;
                            width: pxToVw(344);
                            z-index: 2;
                            height: pxToVw(531);
                            background: #FFFFFF;
                            border-radius: 2px;
                            padding: pxToVw(51) 0 0 pxToVw(48);
                            .bg-img{
                                position: absolute;
                                top:pxToVw(92);right: 0;
                                width: pxToVw(288);
                                height: pxToVw(439);
                                z-index: -1;
                                img{
                                    width: 100%;
                                    vertical-align: top;
                                }
                            }
                            .name{
                                width: pxToVw(85);
                                text-align: left;
                                font-size: pxToVw(26);
                                font-family: "FZLT-blackLittle";
                                color: #333333;
                                line-height: pxToVw(31);
                                margin-bottom: pxToVw(17);
                                text-align: justify;
                                text-align-last: justify;
                                word-break: break-all;
                                text-justify: distribute;
                            }
                            .text{
                                width: pxToVw(246);
                                text-align: left;
                                font-size: pxToVw(17);
                                color: #666;
                                line-height: pxToVw(24);
                            }
                            .people-img{
                                position: absolute;
                                bottom: 0;
                                right: pxToVw(16);
                                width: pxToVw(312);
                                height: pxToVw(334);
                                overflow: hidden;
                                display: flex;
                                justify-content: center;
                                align-items: flex-start;
                                img{
                                    vertical-align: top;
                                    // width: 100%;
                                    height: 100%;
                                }
                            }
                        }
                    }
                    .guest1-active{
                        .guest1-one{display: none;}
                        .guest1-two{display: block;}
                    }
                }
                .guest-one-active{
                    opacity: 1;
                    transform: translateX(0);
                    transition: all ease-in-out 0.3s;
                }
                .guest-one-oldActive{
                    transform: translateX(-100%);
                    transition: all ease-in-out 0.3s;
                }
            }
        }
    }
    .con-page10{
        position: relative;
        width: 100%;height: 100%;
        overflow: hidden;
        box-shadow: 0px -8px 16px 0px rgba(232,232,232,0.5);
        background: url("../assets/newImages/home/page4.png")no-repeat center center/cover,#FFF;
        .bg-img{
            position: absolute;
            top: pxToVw(-200);
            left: -3px;
            width: pxToVw(441);
            img{
                width: 100%;
            }
        }
        .bg-img2{
            position: absolute;
            bottom: pxToVw(-313);
            right: 0;
            width: pxToVw(336);
            img{
                width: 100%;
            }
        }
        .exhibition-content{
            margin: pxToVw(19) 0 0 pxToVw(72);
            .exhibition-top{
                position: relative;
                z-index: 2;
                width: pxToVw(1275);
                height: pxToVw(421);
                margin-bottom: pxToVw(20);
                .top-left{
                    position: relative;
                    width: 100%;
                    height: pxToVw(421);
                    padding: pxToVw(238) pxToVw(29) 0 pxToVw(29);
                    font-size: pxToVw(17);
                    color: #333333;
                    text-align: left;
                    line-height: pxToVw(36);
                    background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0.9) 100%);
                    border: 1px solid transparent;
                    background-clip: padding-box;
                    border-radius: 0px pxToVw(36) 0px pxToVw(36);
                    &:after{
                        content: "";
                        display: block;
                        position: absolute;
                        top: -1px;
                        right: -1px;
                        bottom: -1px;
                        left: -1px;
                        border-radius: 0px pxToVw(36) 0px pxToVw(36);
                        background: linear-gradient(#FFDDCB, #FAEEE8);
                        z-index: -1;
                    }
                }
                .top-middle{
                    position: absolute;
                    z-index: 2;
                    width: pxToVw(1220);
                    height: pxToVw(47);
                    top: pxToVw(182);
                    left: pxToVw(29);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    p{
                        width: 33.33%;
                        height: pxToVw(47);
                        text-align: center;
                        font-size: pxToVw(17);
                        line-height: pxToVw(47);
                        color: #666;
                        font-family: "FZLT-blackLittle";
                    }
                }
                .bg-img{
                    position: absolute;
                    top: pxToVw(29);
                    left: pxToVw(29);
                    z-index: 1;
                    width: pxToVw(1220);
                    height: pxToVw(148);
                    overflow: hidden;
                    img{
                        vertical-align: top;
                        width: pxToVw(411);
                        height: pxToVw(148);
                        &:nth-child(2){
                            width: pxToVw(422);
                            height: pxToVw(148);
                            margin: 0 pxToVw(-12);
                        }
                    }
                }
            }
            .exhibition-three{
                width: 100%;
                height: pxToVw(96);
                display: flex;
                .exhibition-one{
                    position: relative;
                    width: pxToVw(347);
                    height: pxToVw(96);
                    background: #FFFFFF;
                    border-radius: 1px;
                    z-index: 2;
                    display: flex;
                    margin-right: pxToVw(116);
                    padding: pxToVw(14) 0 0 pxToVw(24);
                    box-shadow: 0 0 pxToVw(7) 0 rgba(229, 229, 229, 0.5);
                    cursor: pointer;
                    &:last-child{
                        margin-right: 0;
                    }
                    .bg-img{
                        position: absolute;
                        top: 0;left: pxToVw(107);
                        z-index: -1;
                        width: pxToVw(240);
                        height: pxToVw(96);
                        img{
                            vertical-align: top;
                            height: 100%;
                        }
                    }
                    .img{
                        width: pxToVw(71);
                        height: pxToVw(67);
                        margin-right: pxToVw(85);
                        img{width: 100%;
                            vertical-align: top;
                        }
                    }
                    .text-right{
                        padding-top: pxToVw(14);
                        .title{
                            display: flex;
                            align-items: center;
                            span{
                                font-size: pxToVw(19);
                                font-family: "FZLT-blackLittle";
                                color: #333333;
                                line-height: pxToVw(23);
                            }
                            img{
                                width: pxToVw(14);
                                height: pxToVw(12);
                                margin-left: pxToVw(20);
                            }
                        }
                        p{
                            margin-top: pxToVw(10);
                            font-size: pxToVw(12);
                            text-align: left;
                            // font-family: "FZLT-blackLittle";
                            color: #CCCCCC;
                            line-height: pxToVw(17);
                        }
                    }
                }
            }
        }   
    }
    .con-page11{
        position: relative;
        width: 100%;height: 100%;
        overflow: hidden;
        box-shadow: 0px -8px 16px 0px rgba(232,232,232,0.5);
        background: url("../assets/newImages/home/page4.png")no-repeat center center/cover,#FFF;
        .bg-img{
            position: absolute;
            top: pxToVw(-324);
            left: -3px;
            width: pxToVw(181);
            img{
                width: 100%;
            }
        }
        .com-main{
            width: pxToVw(1285);
            margin: pxToVw(-5) 0 0 pxToVw(73);
            .atlas-list{
                margin-top: pxToVw(-10);
                width: pxToVw(1285);
                height: pxToVw(524);
                overflow-x: scroll;
                scrollbar-width: none;
                -ms-overflow-style: none;
                // cursor: pointer;
                &::-webkit-scrollbar{
                    height: 0;
                }
                .page11-content{
                    width: auto;
                    height: 100%;
                    display: flex;
                    .left{
                        height: 100%;
                        margin-right: pxToVw(24);
                        img{
                            vertical-align: top;
                            height: 100%;
                        }
                    }
                    .right{
                        .right-top{
                            display: flex;
                            height: pxToVw(237);
                            margin-bottom: pxToVw(24);
                            &:nth-child(2){
                                margin-bottom: 0;
                                height: pxToVw(263);
                            }
                            img{
                                vertical-align: top;
                                height: 100%;
                                margin-right: pxToVw(23);
                            }
                        }
                    }
                }
            }
        }
    }
    .con-page13{
        position: relative;
        width: 100%;height: 100%;
        overflow: hidden;
        box-shadow: 0px -8px 16px 0px rgba(232,232,232,0.5);
        background: url("../assets/newImages/home/page4.png")no-repeat center center/cover,#FFF;
        .bg-img{
            position: absolute;
            top: pxToVw(-323);
            left: 0;
            width: pxToVw(181);
            img{
                width: 100%;
            }
        }
        .bg-img2{
            position: absolute;
            top: pxToVw(-109);
            right: 0;
            width: pxToVw(252);
            // height: 176;
            img{
                width: 100%;
            }
        }
        .files-content{
            // margin: pxToVw(39) 0 0 pxToVw(69);
            margin: 3.2vh 0 0 pxToVw(69);
            width: pxToVw(1286);
            height: auto;
            position: relative;
            z-index: 2;
            padding-top: pxToVw(50);
            .files-three{
                position: absolute;
                top:0;
                left: 0;
                width: pxToVw(598);
                height: pxToVw(72);
                display: flex;
                background: #FFFFFF;
                box-shadow: 0 pxToVw(2) pxToVw(5) 0 rgba(234,234,234,0.5);
                border-radius: 2px pxToVw(40) 2px pxToVw(40);
                .files-three-one{
                    width: pxToVw(199);
                    position: relative;
                    height: 100%;
                    cursor: pointer;
                    &:last-child{
                        .right-line{display: none;}
                    }
                    &:hover{
                        p{color: #C50819;}
                        .line{display: block;}
                    }
                    .right-line{
                        position: absolute;
                        top:50%;
                        right: 0;
                        transform: translateY(-50%);
                        width: 1px;
                        height: pxToVw(36);
                        background: #949494;
                        opacity: 0.3;
                    }
                    .line{
                        display: none;
                        position: absolute;
                        bottom: 0;
                        left: 50%;
                        transform: translateX(-50%);
                        width: pxToVw(36);
                        height: pxToVw(4);
                        background: #C50819;
                    }
                    p{
                        font-size: pxToVw(24);
                        color: #333333;
                        font-family: "FZLT-blackLittle";
                        line-height: pxToVw(34);
                        text-shadow: 0 pxToVw(2) pxToVw(5) rgba(234, 234, 234, 0.5);
                    }
                }
                .files-one-active{
                    p{color: #C50819;}
                    .line{display: block;}
                }
            }
            .files-list{
                width: pxToVw(1286);
                height: pxToVw(525);
                padding: pxToVw(40) pxToVw(24) 0;
                box-shadow: 0px 0px pxToVw(24) 0px rgba(231,231,231,0.5);
                border-radius: pxToVw(3);
                background: rgba(255,255,255,0.7);
                .files-nav{
                    width: pxToVw(1239);
                    margin: 0 0 pxToVw(20) 0;
                    height: pxToVw(46);
                    display: flex;
                    border-bottom: pxToVw(2) solid #D8D8D8;
                    .files-nav-one{
                        width: pxToVw(155);
                        height: pxToVw(46);
                        font-size: pxToVw(22);
                        line-height: pxToVw(25);
                        color: #333;
                        margin-right: pxToVw(45);
                        cursor: pointer;
                        &:hover{
                            color: #C50819;
                            font-family: "FZLT-blackBold";
                            border-bottom: pxToVw(4) solid #C50819;
                        }
                    }
                    .files-nav-one-active{
                        color: #C50819;
                        font-family: "FZLT-blackBold";
                        border-bottom: pxToVw(4) solid #C50819;
                    }
                }
                .files-main1{
                    width: 100%;
                    height: pxToVw(416);
                    padding: 0 pxToVw(21);
                    display: flex;
                    text-align: left;
                    .files-main1-content{
                        width: 100%;
                        height: pxToVw(400);
                        overflow-y: scroll;
                        scrollbar-width: none;
                        -ms-overflow-style: none;
                        &::-webkit-scrollbar{
                            width: pxToVw(0);
                        }
                        .filesTwo-one{
                            width: 100%;
                            padding-top: pxToVw(12);
                            height: auto;
                            margin-bottom: pxToVw(25);
                            .title{
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                cursor: pointer;
                                padding-bottom: pxToVw(35);
                                border-bottom: 1px solid rgba(204, 204, 204, 0.5);
                                .title-left{
                                    display: flex;
                                    align-items: center;
                                    .line{
                                        width: pxToVw(4);
                                        height: pxToVw(19);
                                        background: #C50819;
                                        border-radius: pxToVw(2);
                                        margin: pxToVw(-1) pxToVw(10) 0 0;
                                    }
                                    p{
                                        width: pxToVw(1000);
                                        font-size: pxToVw(19);
                                        color: #333333;
                                        font-family: "FZLT-blackLittle";
                                        text-overflow :ellipsis; 
                                        white-space: nowrap; 
                                        overflow: hidden;
                                        line-height: pxToVw(23);
                                    }
                                }
                                .right-icon{
                                    width: pxToVw(20);
                                    height: pxToVw(10);
                                    transform: rotate(180deg);
                                    img{
                                        vertical-align: top;
                                        width: 100%;
                                    }
                                }
                                .right-icon-bottom{
                                    transform: rotate(0deg);
                                }
                            }
                            .title-active{
                                padding-bottom: 0;
                                border-bottom:none;
                            }
                            .filesTwo-one-main{
                                display: none;
                                width: 100%;
                                height: auto;
                                .filesTwo-oneItem{
                                    width: 100%;
                                    height: pxToVw(84);
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                    border-bottom: 1px solid rgba(204, 204, 204, 0.5);
                                    .left-one{
                                        display: flex;
                                        align-items: center;
                                        .left-img{
                                            width: pxToVw(26);
                                            height: pxToVw(28);
                                            margin-right: pxToVw(30);
                                            img{
                                                width: 100%;
                                                vertical-align: top;
                                            }
                                        }
                                        p{
                                            width: pxToVw(800);
                                            font-size: pxToVw(17);
                                            color: #333333;
                                            line-height: pxToVw(20);
                                            text-overflow :ellipsis; 
                                            overflow: hidden;
                                            white-space: nowrap; 
                                        }
                                    }
                                    .right-one{
                                        display: flex;
                                        align-items: center;
                                        .loading-div{
                                            width: pxToVw(110);
                                            margin-right: pxToVw(18);
                                            display: flex;
                                            align-items: center;
                                            cursor: pointer;
                                            .img{
                                                width: pxToVw(23);
                                                height: pxToVw(20);
                                                margin-right: pxToVw(10);
                                                &:nth-child(2){display: none;}
                                                img{
                                                    vertical-align: top;
                                                    width: 100%;
                                                }
                                            }
                                            p{
                                                font-size: pxToVw(14);
                                                color: #666666;
                                                line-height: pxToVw(17);
                                            }
                                        }
                                        .loading-div2{
                                            .img{
                                                width: pxToVw(25);
                                                height: pxToVw(20);
                                            }
                                        }
                                        .loading-div-active{
                                            .img{
                                                display: none;
                                                &:nth-child(2){display: block;}
                                            }
                                        }
                                    }
                                }
                            }
                            .filesTwo-one-main-active{
                                display: block;
                            }
                        }
                    }
                }
                .files-main2{
                    height: pxToVw(460);
                    .files-main1-content{
                        height: 100%;
                        .filesTwo-one{
                            .title{
                                cursor: default;
                            }
                        }
                        .left-img{
                            width: pxToVw(31) !important;
                            height: pxToVw(25) !important;
                            margin-right: pxToVw(30);
                            img{
                                width: 100%;
                                vertical-align: top;
                            }
                        }
                    }
                }
                .files-main3{
                    height: pxToVw(460);
                    .files-main1-content{
                        height: 100%;
                        .left-img{
                            width: pxToVw(31) !important;
                            height: pxToVw(25) !important;
                            margin-right: pxToVw(30);
                            img{
                                width: 100%;
                                vertical-align: top;
                            }
                        }
                    }
                }
            }
        }
    }
    .con-page1-live{
        position: relative;
        width: 100%;height: 100%;
        overflow: hidden;
        background: url("../assets/newImages/home/live/page-bg.jpg")no-repeat center center/cover;;
        .bg-img1{
            position: absolute;
            bottom: 0;
            right: 0;
            width: pxToVw(384);
            height: pxToVw(264);
            img{width: 100%;vertical-align: top;}
        }
        .bg-img2{
            position: absolute;
            bottom: 0;
            left: 0;
            width: pxToVw(291);
            height: pxToVw(381);
            img{width: 100%;vertical-align: top;}
        }
        .bg-img3{
            position: absolute;
            top: 0;
            left: pxToVw(1036);
            width: pxToVw(181);
            height: pxToVw(167);
            img{width: 100%;vertical-align: top;}
        }
        .con-1200{
            position: relative;
            z-index: 2;
            display: flex;
            height: pxToVw(622);
            justify-content: space-between;
            margin-top: pxToVw(182) !important;
            .live-left{
                width: pxToVw(1012);
                height: pxToVw(622);
                .left-title{
                    width: pxToVw(1012);
                    height: pxToVw(55);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0 pxToVw(25);
                    background: linear-gradient(258deg, #FDFDFD 0%, #FFFFFF 100%, #EBECEE 100%);
                    border-radius: pxToVw(36) 1px 1px;
                    .one-left{
                        display: flex;
                        width: pxToVw(730);
                        height: pxToVw(20);
                        align-items: center;
                        img{
                            width: pxToVw(18);
                            height: pxToVw(18);
                            margin-right: pxToVw(17);
                        }
                        p{
                            width: pxToVw(695);
                            font-size: pxToVw(17);
                            color: #C50819;
                            font-family: "FZLT-blackLittle";
                            line-height: pxToVw(20);
                            text-align: left;
                            text-overflow :ellipsis; 
                            overflow: hidden;
                            white-space: nowrap; 
                        }
                    }
                    .one-right{
                        width: pxToVw(200);
                        height: pxToVw(33);
                        font-size: pxToVw(14);
                        color: #FFFFFF;
                        line-height: pxToVw(33);
                        background: #C50819;
                        border-radius: 1px;
                        cursor: pointer;
                    }
                }
                .left-video{
                    width: pxToVw(1012);
                    height: pxToVw(567);
                    background: url("../assets/newImages/home/live/like-bg.jpg") no-repeat center center/cover,#FFF;
                    border-radius: 1px;
                    border:none;
                    video{
                        width: 100%;
                        vertical-align: top;
                    }
                }
            }
            .live-right{
                position: relative;
                width: pxToVw(347);
                height: pxToVw(622);
                padding-top: pxToVw(26);
                background: rgba($color: #FFF, $alpha: 0.79);
                border-radius: 1px pxToVw(31) 1px 1px;
                .live-right-top{
                    position: absolute;
                    z-index: 2;
                    top:0;
                    left: 0;
                    width: pxToVw(347);
                    height: pxToVw(85);
                    padding-top: pxToVw(39);
                    background: #FFFFFF;
                    box-shadow: 0px 1px 4px 0px rgba(234,234,234,0.5);
                    border-radius: 2px pxToVw(45) 2px pxToVw(45);
                    .img{
                        position: absolute;
                        left: pxToVw(40);
                        top:pxToVw(-48);
                        width: pxToVw(267);
                        height: pxToVw(81);
                        img{
                            width: 100%;
                            vertical-align: top;
                        }
                    }
                    .text-div{
                        padding: 0 pxToVw(75);
                        height: pxToVw(46);
                        display: flex;
                        justify-content: space-between;
                        .text-date{
                            position: relative;
                            width: pxToVw(75);
                            height: pxToVw(46);
                            cursor: pointer;
                            p{
                                font-size: pxToVw(23);
                                font-family: "ABlack";
                                font-weight: 900;
                                color: #333333;
                                line-height: pxToVw(24);
                                text-shadow: 0px 1px pxToVw(4) rgba(234, 234, 234, 0.5);
                            }
                            span{
                                display: none;
                                position: absolute;
                                bottom: 0;
                                left: 50%;
                                transform: translateX(-50%);
                                width: pxToVw(33);
                                height: pxToVw(4);
                                background: #C50819;
                                box-shadow: 0px 1px pxToVw(4) 0px rgba(234,234,234,0.5);
                            }
                        }
                        .text-active{
                            p{
                                color: #C50819;
                            }
                            span{
                                display: block;
                            }
                        }
                    }
                }
                .live-right-lists{
                    width: pxToVw(347);
                    height: pxToVw(597);
                    padding: pxToVw(69) pxToVw(35) 0 pxToVw(20);
                    .live-right-lists-one{
                        width: pxToVw(292);
                        height: auto;
                        .right-title{
                            width: 100%;
                            height: pxToVw(50);
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            justify-content: space-between;
                            border-bottom: 1px solid #CCCCCC;
                            .title-left{
                                padding-left: pxToVw(13);
                                position: relative;
                                height: pxToVw(50);
                                display: flex;
                                align-items: center;
                                p{
                                    width: pxToVw(200);
                                    text-align: left;
                                    font-size: pxToVw(17);
                                    font-family: "FZLT-blackLittle";
                                    color: #333333;
                                    line-height: pxToVw(50);
                                    text-overflow :ellipsis; 
                                    overflow: hidden;
                                    white-space: nowrap; 
                                }
                                .img{
                                    max-width: pxToVw(200);
                                    margin: auto 0;
                                    height: pxToVw(17);
                                    display: flex;
                                    align-items: center;
                                    img{
                                        height: pxToVw(17);
                                        vertical-align: top;
                                        margin-top: pxToVw(1);
                                    }
                                }
                                .left-right{
                                    position: absolute;
                                    left: 0;
                                    top: pxToVw(17);
                                    width: pxToVw(4);
                                    height: pxToVw(17);
                                    background: #C50819;
                                }
                                .list-img{
                                    width: pxToVw(62);
                                    height: pxToVw(20);
                                    .img1{
                                        width: pxToVw(62);
                                        height: pxToVw(20);
                                        img{
                                            width: pxToVw(62);
                                            height: pxToVw(20);
                                            vertical-align: top;
                                        }
                                    }
                                }
                            }
                            .title-img{
                                width: pxToVw(20);
                                height: pxToVw(11);
                                transform: rotate(180deg);
                                img{
                                    width: 100%;
                                    vertical-align: top;
                                }
                            }
                        }
                        .right-list{
                            display: none;
                            height: pxToVw(265);
                            width: pxToVw(315);
                            padding: pxToVw(10) 0;
                            .right-list-scroll{
                                height: pxToVw(245);
                                width: pxToVw(315);
                                overflow-y: scroll;
                                padding-right: pxToVw(22);
                                padding-top: pxToVw(9);
                                scrollbar-width: none;
                                -ms-overflow-style: none;
                                &::-webkit-scrollbar{
                                    width: pxToVw(1);
                                    height: pxToVw(242);
                                    background: linear-gradient(to bottom ,rgba(69, 69, 69, 0.49),rgba(33, 33, 33, 1),rgba(63, 63, 63, 0.5));
                                }
                                &::-webkit-scrollbar-track{
                                    background: none;
                                }
                                &::-webkit-scrollbar-thumb{
                                    background: #C50819;
                                    border: pxToVw(1) solid #C50819;
                                }
                                .right-list-one{
                                    width: pxToVw(292);
                                    height: auto;
                                    text-align: left;
                                    cursor: pointer;
                                    margin: 0 0 pxToVw(18);
                                    padding: 0 pxToVw(13);
                                    &:hover{
                                        .list-one-top{
                                            .time{color: #C50819;}
                                        }
                                        .list-one-title{color: #C50819;}
                                    }
                                    .list-one-top{
                                        display: flex;
                                        .time{
                                            width: pxToVw(80);
                                            height: pxToVw(18);
                                            font-size: pxToVw(14);
                                            font-family: "ABlack";
                                            font-weight: 900;
                                            color: #666666;
                                            line-height: pxToVw(18);
                                        }
                                        .list-img{
                                            width: pxToVw(62);
                                            height: pxToVw(20);
                                            .img1{
                                                width: pxToVw(62);
                                                height: pxToVw(20);
                                                img{
                                                    width: pxToVw(62);
                                                    height: pxToVw(20);
                                                    vertical-align: top;
                                                }
                                            }
                                        }
                                    }
                                    .list-one-title{
                                        width: 100%;
                                        margin-top: pxToVw(2);
                                        font-size: pxToVw(14);
                                        color: #333333;
                                        line-height: pxToVw(22);
                                    }
                                }
                                .right-list-one-no-active{
                                    cursor: default;
                                }
                                .right-list-one-active{
                                    .list-one-top{
                                        .time{color: #C50819;}
                                    }
                                    .list-one-title{color: #C50819;}
                                }
                            }
                        }

                    }
                    .live-right-lists-active{
                        border-bottom: 1px solid #CCCCCC;
                        .right-title{
                            .title-left{
                                padding-left: pxToVw(13);
                                position: relative;
                                height: pxToVw(50);
                                p{
                                    color: #C50819;
                                }
                            }
                            .title-img{
                                transform: rotate(0deg);
                            }
                        }
                        .right-list{
                            display: block;
                        }
                    }
                }
            }
        }
    }
}
.ie-pc{
    .con-1200{
        margin: 7.0vh pxToVw(240) 0 pxToVw(310) !important;
    }
    .margin-l-r-auto{
        margin-left: auto !important;
        margin-right: auto !important;
    }
    .more{
        margin: 2.4vh auto 0 !important;
    }
    // .button2{font-family: none;}
    .agenda-content{
        margin: 2.5vh 0 0 pxToVw(81) !important;
        .text-am{
            p{width: pxToVw(130) !important;}
        }
    }
    .con-page6{
        .com-main{
            margin: 2vh pxToVw(55) 0 pxToVw(73) !important;
            .com-main-top{
                margin-bottom: 0.8vh !important;
            }
        }
        .more{
            margin: 0.8vh auto 0 !important;
        }
    }
}
.mobile{
    display: none;
}
@media screen and (max-width:767px) {
    .pc{
        display: none;
    }
    .mobile{
        display: block;
        width: 100vw;
        height: 100vh;
        padding: 0;
        .cover-page1{
            position: fixed;
            z-index: 1000;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background: rgba(0,0,0,0.5);
            border-radius: 4px;
            .cover-main{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 82.4vw;
                height: 54.9vw;
                background: #FFFFFF;
                border-radius: 1.3vw;
                // padding: 3vw 3.6vw 0 7.5vw;
                .cover-close{
                    float: right;
                    // width: 2.8vw;
                    // height: 2.9vw;
                    padding: 3vw 3.6vw 0 0;
                    img{
                        width: 2.8vw;
                        height: 2.9vw;
                    }
                }
                .cover-content{
                    width: 82.4vw;
                    height: 35.3vw;
                    display: flex;
                    justify-content: space-between;
                    border-bottom: 2px solid #EEEEEE;
                    padding:3.5vw 7.5vw 0;
                    .cover-one{
                        width: 32vw;
                        height: 25.5vw;
                        background: #FFFFFF;
                        box-shadow: 0px 0px 19px 0px rgba(211,211,211,0.5);
                        border-radius: 0.8vw;
                        padding-top: 5.5vw;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        img{    
                            width: 6.5vw;
                            height: 7.2vw;
                        &:nth-child(2){
                            width: 6.5vw;
                            height: 5.9vw;
                        }
                        }
                        
                        p{
                            font-size: 3.2vw;
                            font-weight: normal;
                            color: #333333;
                            line-height: 10vw;
                        }
                    }
                }
                .text{
                    margin-top: 4.5vw;
                    font-size: 3.2vw;
                    font-weight: normal;
                    color: #C50819;
                    line-height: 3.7vw;
                    font-family: "FZLT-blackBold";
                    text-align: center;
                }
            }
        }
        .cover-page-video{
            position: fixed;
            z-index: 1001;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            width: 82.4vw;
            height: 46.35vw;
            video{
                width: 82.4vw;
                height: 46.35vw;
                border: none;
            }
            .close{
                position: absolute;
                top: -6vw;
                right: 0;
                width: 5vw;
                height: 5vw;
                font-size: 6vw;
                text-align: center;
                line-height: 5vw;
                color: #FFF;
            }
        }
        .more{
            width: 100%;
            display: flex;
            height: 3.6vw;
            align-items: center;
            justify-content: center;
            p{
                text-align: center;
                // font-size: 3.2vw;
                font-weight: normal;
                color: #333333;
                // line-height: 3.6vw;
                font: 3.2vw/3.6vw "FZLT-black";
            }
            .img{
                margin-top: -0.6vw;
                width: 3.4vw;
                height: 2.4vw;
                margin-left: 2.7vw;
                img{
                    width: 3.4vw;
                    height: 2.4vw;
                    vertical-align: top;
                }
            }
        }
        .page-title{
            width: 100%;
            height: 10.53vw;
            margin-left: -4.67vw;
            p{
                width: 32.67vw;
                height: 10.53vw;
                padding: 3.73vw 0 0 8.67vw;
                background: url('../assets/newImages/wap/home/title-bg.png') no-repeat center center/cover;
                font-size: 4vw;
                font-weight: normal;
                font-family: "FZLT-blackBold";
                color: #FFFFFF;
                line-height: 4.8vw;
            }
        }
        .page1{
            position: relative;
            z-index: 2;
            width: 100%;
            height: 100vh;
            .page-img1{
                z-index: -1;
                position: absolute;
                top: 0;left: 0;
                width: 100%;
                height: 100%;
                img{
                    width: 100%;
                    height: 100vh;
                }
            }
            .page-img2{
                position: absolute;
                top: 42.5vh;left: 0;
                width: 16vw;
                height: 19.2vw;
                img{
                    width: 16vw;
                    height: 19.2vw;
                }
            }
            .page-img3{
                position: absolute;
                top: 8vh;right: 0;
                width: 12.3vw;
                height: 16.1vw;
                img{
                    width: 12.3vw;
                    height: 16.1vw;
                }
            }
            .page-img4{
                position: absolute;
                right: 0;bottom: 0;
                width: 17.6vw;
                height: 32.3vw;
                img{
                    width: 17.6vw;
                    height: 32.3vw;
                }
            }
            .page-img5{
                position: absolute;
                top:7.6vh;right: 7.3vw;
                width: 26.3vw;
                height: 3.6vw;
                img{
                    width: 26.3vw;
                    height: 3.6vw;
                }
            }
            .page-img6{
                position: absolute;
                top:17.5vh;left: 0;
                width: 98vw;
                height: 55.6vw;
                img{
                    width: 98vw;
                    height: 55.6vw;
                }
            }
            .page-img7{
                position: absolute;
                top:52.2vh;left: 13vw;
                width: 73.7vw;
                height: 22.5vw;
                img{
                    width: 73.7vw;
                    height: 22.5vw;
                }
            }
            p{
                position: absolute;
                top: 68.6vh;
                font-size: 3.2vw;
                color: #666666;
                line-height: 3.6vw;
                text-align: center;
                width: 100%;
            }
            .home-buttons{
                position: absolute;
                top: 78.34vh;
                left: 28.1vw;
                button{
                    &:nth-child(2){
                        margin-top: 4vw;
                    }
                }
                .button1{
                    width: 43.7vw;
                    height: 9.3vw;
                    background: #FFF;
                    border-radius: 1px;
                    // font-size: 3.5vw;
                    font-weight: normal;
                    color: #C50819;
                    // line-height: 8.1vw;
                    border: 0.6vw solid #C50819;
                    font: 3.5vw/8.1vw "FZLT-black";
                    resize: none;
                }
                .button2{
                    width: 43.7vw;
                    height: 9.3vw;
                    background: #C50819;
                    border-radius: 1px;
                    // font-size: 3.5vw;
                    font-weight: normal;
                    color: #FFFFFF;
                    // line-height: 9.6vw;
                    font: 3.5vw/9.3vw "FZLT-black";
                    border: none;
                    resize: none;
                }
                .button3{
                    width: 43.7vw;
                    height: 9.3vw;
                    background: #2F5597;
                    border-radius: 1px;
                    font-size: 3.5vw;
                    font-weight: normal;
                    color: #FFFFFF;
                    line-height: 9.3vw;
                    border: none;
                    resize: none;
                }
            }
            .home-buttons2{
                padding-top: 6.6vw;
            }
        }
        .box-bg{
            // background: url('../assets/newImages/common/navWap/page-bg.png')no-repeat center center/cover,#FBF6F4;
            background: #E9EFF7;
            .page2{
                width: 100%;
                height: auto;
                padding: 5.3vw 4.7vw 5.2vw;
                .page2-content{
                    width: 90.7vw;
                    height: auto;
                    flex-direction: column;
                    padding-top: 2.67vw ;
                    .con-img{
                        width: 90.7vw;
                        height: 36.8vw;
                        img{
                            vertical-align: top;
                            width: 100%;
                        }
                    }
                    .rich-text{
                        width: 85vw;
                        margin: 0 auto;
                        font-family: "FZLT-black";
                        margin-top: 3.5vw;
                        font-size: 3.2vw;
                        color: #666;
                        text-align: justify;
                        line-height: 5.3vw;
                    }
                }
            }
            .page3{
                width: 100%;
                height: auto;
                padding: 0 4.7vw 0;
                position: relative;
                .page3-content{
                    margin: 2.93vw auto 4.3vw;
                    .icon{
                        position: absolute;
                        right: 0;
                        bottom: 0vw;
                        width: 12vw;
                        height: 26.3vw;
                        img{
                        width: 12vw;
                            height: 26.3vw; 
                        }
                    }
                    .con-title{
                        z-index: 2;
                        position: relative;
                        width: 80vw;
                        height: 11.5vw;
                        background: #FFFFFF;
                        border-radius: 2px 6vw 2px 6vw;
                        display: flex;
                        align-items: center;
                        .day-text{
                            width: 37.73vw;
                            cursor: pointer;
                            border-right: 1px solid #949494;
                            display: flex;
                            padding: 0 0 0 10vw;
                            text-align: center;
                            &:last-child{
                                border-right: none;
                            }
                            &:hover{
                                p{
                                    color: #C50819;
                                }
                            }
                            p{
                                font-family: "ABlack";
                                font-size: 4.67vw;
                                font-weight: 900;
                                color: #333333;
                                line-height: 4.67vw;
                                letter-spacing: 1px;
                                &:nth-child(2){
                                    font-size: 3.87vw;
                                    margin-left: 1.33vw;
                                }
                            }
                        }
                        .day-text-active{
                            p{
                                color: #C50819;
                            }
                        }
                    }
                    .con-list{
                        position: relative;
                        z-index: 1;
                        height: auto;
                        margin-top: -2.93vw;
                        box-shadow: 0px 0px 2vw 0px rgba(231,231,231,0.5);
                        border-radius: 2px;
                        background: rgba(250,250,250,0.7);
                        .list-nav{
                            height: 15.07vw;
                            display: flex;
                            justify-content: space-around;
                            border-bottom: 2px solid #D8D8D8;
                            .list-nav-one{
                                font-size: 3.73vw;
                                height: 15.07vw;
                                line-height: 20.07vw;
                                color: #333;
                                cursor: pointer;
                                &:hover{
                                    line-height: 20.07vw;
                                    color: #C50819;
                                    font-family: "FZLT-blackBold";
                                    border-bottom: 0.53vw solid #C50819;
                                }
                            }
                            .list-nav-one-active{
                                color: #C50819;
                                font-family: "FZLT-blackBold";
                                border-bottom: 0.53vw solid #C50819;
                            }
                        }
                        .agenda-wait{
                            width: 100%;
                            padding: 10vw 0;
                            font-size: 3.73vw;
                            line-height: 5vw;
                            color: #333;
                            text-align: center;
                        }
                        .agenda-main1{
                            // width: 100%;
                            height: auto;
                            padding-bottom: 4.5vw;
                            .agenda-image{
                                width: 81.3vw;
                                height: 13.9vw;
                                margin: 5vw auto;
                                display: flex;
                                z-index: 2;
                                justify-content: center;
                                position: relative;
                                padding: 4.5vw 4vw;
                                align-items:center;
                                .one-bg{
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 81.3vw;
                                    height: 13.9vw;
                                    z-index: -1;
                                    overflow: hidden;
                                    img{
                                        vertical-align: top;
                                        height: 100%;
                                    }
                                }
                                p{
                                    width: 100%;
                                    font-size: 3.2vw;
                                    font-family: "FZLT-blackLittle";
                                    color: #FFFFFF;
                                    line-height: 3.7vw;
                                    text-align: center;
                                }
                            }
                            .agenda-image2{
                                margin: 5vw 0;
                                display: flex;
                                justify-content: space-between;
                                padding: 0 4.5vw;
                                .agenda-image2-one{
                                    position: relative;
                                    width: 40vw;
                                    height: 13.9vw;
                                    z-index: 2;
                                    display: flex;
                                    // padding: 4.5vw 4vw;
                                    align-items: center;
                                    .one-bg{
                                        position: absolute;
                                        top: 0;
                                        left: 0;
                                        width: 40vw;
                                        height: 12.6vw;
                                        z-index: -1;
                                        overflow: hidden;
                                        &:nth-child(2){
                                            display: none;
                                            width: 40vw;
                                            height: 13.9vw;
                                        }
                                        img{
                                            vertical-align: top;
                                            width: 100%;
                                        }
                                    }
                                    p{
                                        width: 100%;
                                        font-size: 3.2vw;
                                        font-family: "FZLT-blackLittle";
                                        color: #FFFFFF;
                                        line-height: 3.7vw;
                                        text-align: center;
                                    }
                                }
                                .agenda-image2-active{
                                    height: 13.9vw;
                                    align-items: center;
                                    .one-bg{
                                        display: none;
                                        &:nth-child(2){
                                            display: block;
                                        }
                                    }

                                }
                            }
                            .agenda-child-wait{
                                width: 100%;
                                height: 20vw;
                                font-size: 4.2vw;
                                line-height: 5vw;
                                color: #333;
                            }
                            .agenda-image2-icons{
                                padding: 0 4vw;
                                margin-bottom: 4vw;
                                display: flex;
                                justify-content: flex-end;
                                .icon-div{
                                    display: flex;
                                    align-items: center;
                                    margin-left: 4.3vw;
                                    height: 3.6vw;
                                    &:nth-child(2){
                                        img{
                                            width: 3.6vw;
                                            height: 3.3vw;
                                        }
                                    }
                                    img{
                                        vertical-align: top;
                                        margin: -0.6vw 1vw 0 0;
                                        width: 3.7vw;
                                        height: 3.6vw;
                                        &:nth-child(2){
                                            display: none;
                                        }
                                    }
                                    p{
                                        // font-size: 3.2vw;
                                        color: #666666;
                                        // line-height: 3.6vw;
                                        font: 3.2vw/3.6vw "FZLT-black";
                                    }
                                }
                                .icon-div-active{
                                    img{
                                        display: none;
                                        &:nth-child(2){
                                            display: block;
                                        }
                                    }
                                }
                            }
                            .agenda-lists-main{
                                margin: 0 0 0 4.13vw;
                                width: auto;
                                height: auto;
                                // overflow-y: scroll;
                                padding-right: pxToVw(30);
                                // &::-webkit-scrollbar{
                                //     width: pxToVw(5);
                                //     height: pxToVw(432);
                                //     background: none;
                                // }
                                // &::-webkit-scrollbar-track{
                                //     background: none;
                                // }
                                // &::-webkit-scrollbar-thumb{
                                //     background: #DDDDDD;
                                //     border: pxToVw(5) solid rgba(221, 221, 221, 0.6);
                                // }
                                .agendaList-one{
                                    display: flex;
                                    width: 100%;
                                    height: auto;
                                    align-items: flex-start;
                                    flex-direction: column;
                                    cursor: pointer;
                                    text-align: left;
                                    margin-bottom: 5.33vw;
                                    // &:hover{
                                    //     .title{
                                    //         color: #C50819;
                                    //     }
                                    // }
                                    .line-time{
                                        display: flex;
                                        align-items: center;
                                        .time{
                                            font-size: 3.73vw;
                                            font-family: "ABlack";
                                            color: #333;
                                            line-height: 4.67vw;
                                            font-weight: 900;
                                        }
                                        .line{
                                            vertical-align: top;
                                            display: inline-block;
                                            margin: 0vw 3.25vw 0 0;
                                            width: 1.73vw;
                                            height: 1.73vw;
                                        }
                                    }
                                    .title{
                                        width: 77vw;
                                        font-size: 3.47vw;
                                        color: #333;
                                        line-height: 4vw;
                                        margin: 0.4vw 0 0 4.93vw;
                                    }
                                    .guest{
                                        margin: 2vw 0 1.3vw 4.93vw;
                                        display: flex;
                                        font-size: 3.2vw;
                                        line-height: 4vw;
                                        color: #999;
                                        &:last-child{
                                            margin-bottom: 0;
                                        }
                                        p{
                                            width: 10.5vw;
                                            margin: 0 1.33vw 0 0;
                                            text-align: justify;
                                            height: 4vw;
                                            text-align-last: justify;
                                            word-break: break-all;
                                            text-justify: distribute;
                                            &:first-child::after{
                                                display: inline-block;
                                                content: '';
                                                width: 100%;
                                                height: 0;
                                            }
                                            &:nth-child(2){
                                                width: 1.66vw;
                                                height: auto;
                                                // margin: 0 0 0 1.33vw;
                                                text-align: center;
                                                text-align-last: center;
                                            }
                                            &:nth-child(3){
                                                width: 65.5vw;
                                                height: auto;
                                                // margin: 0 0 0 1.33vw;
                                                text-align: left;
                                                text-align-last: left;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        .agenda-main2{
                            .agenda-lists-main{
                                padding: 9.2vw 4.4vw 5.23vw;
                                height: auto;
                                .agendaList-one{
                                    flex-direction: column;
                                    width: 100%;
                                    height: auto;
                                    cursor: pointer;
                                    align-items: center;
                                    margin-bottom: 6.67vw;
                                    // &:hover{
                                    //     .title{
                                    //         color: #C50819;
                                    //     }
                                    // }
                                    .line-title{
                                        display: flex;
                                        align-items: center;
                                        .title{
                                            font-size: 3.47vw;
                                            font-weight: normal;
                                            color: #333;
                                            line-height: 4.5vw;
                                            font-weight: 900;
                                        }
                                        .line{
                                            vertical-align: top;
                                            display: inline-block;
                                            margin: 0vw 3.25vw 0 0;
                                            width: 1.73vw;
                                            height: 1.73vw;
                                        }
                                    }
                                    .time-address{
                                        display: flex;
                                        // align-items: center;
                                        margin-top: 1.6vw;
                                        .time-div{
                                            width: 30vw;
                                            margin: 0 3vw 0 3.8vw;
                                            font-size: 12px;
                                            font-family: none;
                                            color: #999999;
                                            line-height: 14px;
                                            display: flex;
                                            // align-items: center;
                                            img{
                                                width: 12px;
                                                height: 12px;
                                                vertical-align: middle;
                                                margin: 0.4vw 5px 0 0;
                                            }
                                        }
                                        .address-div{
                                            margin: 0;
                                            width: 47vw;
                                            img{
                                                vertical-align: top;
                                                width: 11px;
                                                height: 15px;
                                                margin: 0.3vw 1vw 0 0;
                                            }
                                            p{
                                                width: 43vw;
                                            }
                                        }
                                    }
                                    
                                }
                            }
                        }
                        .agenda-main3{
                            .agenda-lists-main{
                                padding: 10.8vw 4.4vw 0.4vw;
                                // overflow-y: scroll;
                                .agendaList-one{
                                    display: flex;
                                    flex-direction: column;
                                    width: 100%;
                                    margin-bottom: 7.2vw;
                                    // &:hover{
                                    //     .title{
                                    //         color: #C50819;
                                    //     }
                                    // }
                                    .num-title{
                                        display: flex;
                                        // height: 5.2vw;
                                        // align-items: center;
                                        .num{
                                            width: 21.7vw;
                                            height: 5.2vw;
                                            margin-right: 2.3vw;
                                            img{
                                                vertical-align: top;
                                                width: 100%;
                                                margin-top: -0.2vw;
                                            }
                                        }
                                        .title{
                                            width: 58vw;
                                            font-size: 3.5vw;
                                            color: #333;
                                            line-height: 5.2vw;
                                            // overflow: hidden;
                                            // text-overflow :ellipsis; 
                                            // white-space: nowrap; 
                                        }
                                    }
                                    .time-address{
                                        display: flex;
                                        margin-top: 1.6vw;
                                        .time-div{
                                            width: 30vw;
                                            margin: 0 3vw 0 0vw;
                                            font-size: 12px;
                                            font-family: none;
                                            color: #999999;
                                            line-height: 14px;
                                            display: flex;
                                            img{
                                                width: 12px;
                                                height: 12px;
                                                vertical-align: middle;
                                                margin: 1px 5px 0 0;
                                            }
                                        }
                                        .address-div{
                                            margin: 0;
                                            width: 47vw;
                                            img{
                                                vertical-align: top;
                                                width: 11px;
                                                height: 15px;
                                                margin: 0.3vw 1vw 0 0;
                                            }
                                            p{
                                                width: 43vw;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .tishi{
                        font-size: 3.2vw;
                        width: 100%;
                        text-align: right;
                        color: #666666;
                        margin-top: 2vw;
                        line-height: 4.8vw;
                    }
                }
            }
            .page4{
                padding: 7.1vw 4.7vw 4vw;
                position: relative;
                .page4-content{
                    height: auto;
                    display: flex;
                    flex-direction: column;
                    margin: 6.4vw auto;
                    .data-content{
                        width: 90.7vw;
                        // height: 24vw;
                        position: relative;
                        // align-items: center;
                        margin-bottom: 3.2vw;
                            .breviery-out{
                                width: 90.7vw;
                                height: auto;
                                background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0.9) 100%);
                                border-radius: 3.9vw 3.9vw 0px 0px;
                                border: 0.2vw solid #FAEEE8;
                                border-image: linear-gradient(#FFDDCB, #FAEEE8,) 0.2vw 0.2vw;
                                padding: 5.3vw 3.5vw 2.7vw;
                                .breviery{
                                    width: 83.8vw;
                                    height: 60.4vw;
                                    .swiper-breviery{
                                        width: 100%;
                                        height: 35.5vw;
                                        .swiper-wrapper{
                                            height: 35.5vw;
                                            .swiper-slide{
                                                width: 83.6vw;
                                                height: 35.5vw;
                                                margin: 0 auto;
                                                img{width: 100%;height: 100%;vertical-align: top;}
                                            }
                                        }   
                                    }
                                    .swiper-bottom{
                                        display: flex;
                                        width: 100%;
                                        margin-top: 3.3vw;
                                        height: 21.6vw;
                                        .swiper-one{
                                            width: 27.5vw;
                                            height: 21.6vw;
                                            margin-right: 0.3vw;
                                            &:last-child{
                                                margin-right: 0;
                                            }
                                            &:nth-child(2){
                                                width: 28.3vw;
                                            }
                                            img{
                                                vertical-align: top;
                                                width: 100%;
                                                height: 11.7vw;
                                            }
                                            p{
                                                margin-top: 2.1vw;
                                                font-size: 3.2vw;
                                                color: #666666;
                                                text-align: center;
                                                font-family: "FZLT-blackLittle";
                                                line-height: 3.7vw;
                                            }
                                        }
                                        .swiper-one-active{
                                            p{
                                                color: #C50819;
                                            }
                                        }
                                    }
                                }
                                .p{
                                    height: auto;
                                    width: 82.7vw;
                                    margin: 0 auto;
                                    p{
                                        font-size: 3.2vw;
                                        color: #666666;
                                        line-height: 5.4vw;
                                        margin-bottom: 2.7vw;
                                    }
                                }
                            }
                    }
                    .exhibition-three{
                        width: 100%;
                        .exhibition-one{
                            position: relative;
                            width: 90.7vw;
                            height: 16vw;
                            background: #FFFFFF;
                            border-radius: 2px;
                            z-index: 2;
                            display: flex;
                            margin-bottom: 2.7vw;
                            padding-left: 6.9vw;
                            box-shadow: 0 0 1.2vw 0 rgba(229, 229, 229, 0.5);
                            &:last-child{
                                margin-bottom: 0;
                            }
                            .bg-img{
                                position: absolute;
                                top: 0;right: 0;
                                z-index: -1;
                                width: 68.5vw;
                                height: 16vw;
                                img{
                                    vertical-align: top;
                                    width: 100% ;
                                    height: 100%;
                                }
                            }
                            .img{
                                width: 11.9vw;
                                height: 11.2vw;
                                margin:auto 0;
                                img{
                                    width: 100%;
                                    vertical-align: top;
                                }
                            }
                            .text-right{
                                margin:6vw 0 0 16.9vw;
                                display: flex;
                                span{
                                    font-size: 3.7vw;
                                    padding-top: 0.3vw;
                                    line-height: 4.4vw;
                                    font-weight: normal;
                                    font-family: "FZLT-blackLittle";
                                    color: #333333;
                                }
                                p{
                                    margin:1.2vw 0 0 2.1vw;
                                    font-size: 2.4vw;
                                    font-weight: normal;
                                    color: #CCCCCC;
                                    line-height: 3.4vw;
                                    width: 28vw;
                                }
                                .title{
                                    margin:2.3vw 0 0 2.6vw;
                                    width: 2.9vw;
                                    height: 2.4vw;
                                    img{
                                        width: 100%;
                                        vertical-align: top;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .page5{
                position: relative;
                padding:1.3vw 4.7vw 0;
                z-index: 2;
                .page5-icon{
                    position: absolute;
                    left: 0;
                    top: 6.9vw;
                    width: 8.5vw;
                    height: 11.2vw;
                    z-index: -1;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .page5-content{
                    height: auto;
                    margin: 2.8vw auto 2vw;
                    .hot-news{
                        flex-direction: column;
                        .hot-left{
                            position: relative;
                            height: 51.1vw;
                            width: 90.7vw;
                            .hot-image{
                                height: 51.1vw;
                                width: 90.7vw;
                                overflow: hidden;
                                img{
                                    height: 51.1vw;
                                    width: 90.7vw;
                                }
                            }
                            .hot-text{
                                position: absolute;
                                bottom: 0;
                                width: 100%;
                                height: 15vw;
                                text-align: left;
                                background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.01) 0%, #000000 100%);
                                border-radius: 3px;
                                padding: 4.5vw 3.5vw 0 4.9vw;
                                p{
                                    width: 70.5vw;
                                    font-size: 3.5vw;
                                    color: #FFFFFF;
                                    line-height: 5.3vw;
                                    overflow: hidden;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 1;
                                    -webkit-box-orient: vertical;
                                }
                                .img{
                                    float: right;
                                    margin-top: -0.9vw;
                                    width: 4.1vw;
                                    height: 3.5vw;
                                    img{
                                        width: 4.1vw;
                                        height: 3.5vw;
                                    }
                                }
                            }
                        }
                        .hot-right{
                            width: 90.7vw;
                            height: auto;
                            padding-top: 4.7vw;
                            .hot-right-one{
                                width: 100%;
                                display: flex;
                                margin-bottom: 3.6vw;

                                .days{
                                    width: 9.3vw;
                                    text-align: center;
                                    padding-top: 0.4vw;
                                    p{
                                        font-size: 3.8vw;
                                        font-family: "ABlack";
                                        font-weight: 900;
                                        color: #333333;
                                        line-height: 5.6vw;
                                        border-bottom: 1px solid #AAAAAA;
                                    }
                                    span{
                                        margin-top: 0.7vw;
                                        font-size: 3vw;
                                        font-family: "ABlack";
                                        font-weight: 900;
                                        color: #333333;
                                        line-height: 3.7vw;
                                    }
                                }
                                .hot-main{
                                    margin-left: 4.4vw;
                                    text-align: left;
                                    border-left: 1px solid #CCCCCC;
                                    .title{
                                        width: 72.8vw;
                                        font-size: 3.5vw;
                                        color: #333333;
                                        line-height: 5.3vw;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        display: -webkit-box;
                                        -webkit-line-clamp: 2;
                                        -webkit-box-orient: vertical; 
                                        margin-left: 4vw;

                                    }
                                    .img{
                                        width: 2.4vw;
                                        height: 2vw;
                                        margin:1.7vw 0 0 4vw;
                                        img{
                                            width: 100%;
                                            vertical-align: top;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .page6{
                padding: 0 4.7vw;
                margin-top: 6.5vw;
                position: relative;
                z-index: 1;
                .page6-icon{
                    position: absolute;
                    z-index: -1;
                    right: 0;
                    top: -1vw;
                    width: 17.3vw;
                    height: 33.5vw;
                    img{
                        width: 17.3vw;
                        height: 33.5vw;
                    }
                }
                .page6-content{
                    margin: 2.8vw 0 3.6vw;
                    .com-main-top{
                        width: 90.7vw;
                        height: 14.7vw;
                        background: url("../assets/newImages/wap/home/page6-bg.png")no-repeat center center/cover;
                        display: flex;
                        align-items: center;
                        // justify-content: center;
                        margin-bottom: 1.9vw;
                        padding-left: 20.7vw;
                        p{
                            width: auto;
                            font-size: 3.5vw;
                            // color: #333333;
                            line-height: 5.2vw;
                            font-family: "FZLT-blackBold";
                            text-align: center;
                            color: #C50819;
                        }
                        img{
                            width: 26.7vw;
                            height: 13.35vw;
                            margin: 0 0 0 4.5vw;
                        }
                    }
                    .com-main-bottom{
                        width: 90.5vw;
                        height: auto;
                        .sponsor-main{
                            width: 90.5vw;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            .sponsor-one{
                                width: 100%;
                                height: 8.5vw;
                                position: relative;
                                margin-bottom: 0.8vw;
                                .sponsor-one-img{
                                    position: relative;
                                    z-index: 3;
                                    width: 100%;
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                    height: 8.5vw;
                                    padding: 0 3vw 0 5.3vw;
                                    .bg-img{
                                        position: absolute;
                                        left: 0;
                                        top: 0;
                                        z-index: -2;
                                        width: 100%;
                                        height: 8.5vw;
                                    }
                                    p{  
                                        position: relative;
                                        z-index: 3;
                                        font-size: 3.5vw;
                                        color: #333333;
                                        line-height: 8.5vw;
                                    }
                                    .right-icon{
                                        width: 4.3vw;
                                        height: 2.5vw;
                                        transform: rotate(0);
                                    }
                                    .sponsor-one-img-bg{
                                        position: absolute;
                                        right: 0;
                                        top: 0;
                                        z-index: -1;
                                        width: 24.5vw;
                                        height: 8.5vw;
                                        border-radius: 0 4vw 0 4vw; 
                                        background: linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
                                    }
                                }
                                .sponsor-logo-list{
                                    display: none;
                                    width: 90.7vw;
                                    padding: 2.2vw 3.3vw;
                                    height: auto;
                                    background: rgba(255, 255, 255, 0.6);
                                    border-radius: 3px;
                                    .hot-top-button{
                                        margin-top: 2.4vw;
                                        display: flex;
                                        justify-content: flex-end;
                                        .hot-left,.hot-right{
                                            width: 3.7vw;
                                            height: 3.9vw;
                                            background: #C5C5C5;
                                            margin-left: 1.7vw;
                                            display: flex;
                                            align-items: center;
                                            justify-content: center;
                                            img{
                                                width: 1.9vw;
                                                height: 1.5vw;
                                            }
                                        }
                                        .hot-left-active,.hot-right-active{
                                            background: #C50819;
                                        }
                                    }
                                    .sponsor-logo-main{
                                        height: auto;
                                        display: flex;
                                        flex-wrap: wrap;
                                        align-items: flex-start;
                                        .sponsor-logoOne{
                                            display: flex;
                                            flex-wrap: wrap;
                                            align-items: flex-start;
                                            width: 26.7vw;
                                            height: 13.3vw;
                                            margin: 1.9vw 1.9vw 0 0;
                                            &:nth-child(3n){
                                                margin-right: 0;
                                            }
                                            .sponsorLogo{
                                                display: flex;
                                                align-items: center;
                                                justify-content: center;
                                                width: 26.7vw;
                                                height: 13.3vw;
                                                background: #FFFFFF;
                                                border-radius: 1px;
                                                img{
                                                    width: 100%;
                                                    height: 100%;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            .sponsor-active{
                                height: auto;
                                .sponsor-one-img{
                                    p{
                                        font-family: "FZLT-blackBold";
                                        color: #C50819;
                                    }
                                    .right-icon{
                                        transform: rotate(180deg);
                                    }
                                    .sponsor-one-img-bg{
                                    }
                                }
                                .sponsor-logo-list{
                                    display: block;
                                }
                            }
                        }
                    }
                    .tishi{
                        font-size: 3.2vw;
                        width: 100%;
                        text-align: right;
                        color: #666666;
                        margin-top: 2vw;
                        line-height: 4.8vw;
                    }
                }
            }
            .page7{
                position: relative;
                padding: 0 4.7vw;
                margin-top: 5.2vw;
                z-index: 2;
                .page7-icon{
                    position: absolute;
                    left: 0;
                    bottom: -14.7vw;
                    z-index: -1;
                    width: 17.1vw;
                    height: 30.8vw;
                    img{
                        vertical-align: top;
                        width: 100%;
                    }
                }
                .page7-content{
                    margin: 2.7vw auto 5.2vw;
                    .slider-right{
                        position: absolute;
                        right: 0;
                        z-index: 9;
                        width: 19.6vw;
                        height: 46.5vw;
                        background: linear-gradient(270deg, #F7F8F9 0%, rgba(242, 244, 247, 0) 100%);
                        border-radius: 1px;
                    }
                    .slider-page{
                        width: 100%;
                        height: auto;
                        overflow-x: scroll;
                        display: flex;
                        &::-webkit-scrollbar{
                            width: 0;
                            height: 0;
                            background: #bbb;
                        }
                        &::-webkit-scrollbar-track{
                            width: 0;
                        }
                        &::-webkit-scrollbar-thumb{
                            width: 0;
                        }
                        .swiper-slide{
                            width: 48.3vw;
                            height: 46.3vw;
                            margin-right: 2.4vw;
                            .slide-img{
                                position: relative;
                                width: 48.3vw;
                                height: 46.3vw;
                                background: #fff;
                                margin:0 2.4vw 0 0;
                                img{
                                    width: 100%;
                                    height: 27.1vw;
                                }
                            }
                            .bg{
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: 48.3vw;
                                height: 27.1vw;
                                // background:rgba(0, 0, 0, .2);
                                img{
                                    margin: 11.7vw 0 0 22.5vw;
                                    width: 3.2vw;
                                    height: 3.7vw;
                                }
                            }
                            p{
                                padding: 2.8vw 4.1vw 0;
                                border-radius: 1px; 
                                font-size: 3.5vw;
                                font-weight: normal;
                                color: #333333;
                                line-height: 5.3vw;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 2;
                                overflow: hidden;
                            }
                        }
                    }
                }
            }
            .page8{
                padding: 0 4.7vw 13.5vw;
                margin-top: 6vw;
                position: relative;
                z-index: 2;
                .page8-icon{
                    position: absolute;
                    right: 0;
                    bottom: 12vw;
                    z-index: -1;
                    width: 13.6vw;
                    height: 22vw;
                    img{
                        width: 13.6vw;
                        height: 22vw; 
                    }
                }
                .page8-content{
                    width: 90.7vw;
                    position: relative;
                    background: RGBA(246, 239, 237, 1);
                    margin: 3.5vw auto 3.6vw;
                    .con-map{
                        width: 83.5vw;
                        height: 51.3vw;
                        margin: 0 auto;
                        // padding: 1.1vw;
                        // background: rgba(255, 255, 255, 0.7);
                        // border-radius: 3px;
                        img{
                            vertical-align: top;
                            width: 83.5vw;
                            height: 51.3vw;
                        }
                    }
                    .con-msg{
                        width: 91.2vw;
                        height: 61.7vw;
                        background: #FFFFFF;
                        padding: 3.5vw 3.2vw 0;
                        .msg-img{
                            width: 84.8vw;
                            height: 40.3vw;
                            img{
                                width: 100%;
                                height: 100%;
                            }
                        }
                        .title{
                            font-size: 3.5vw;
                            font-weight: normal;
                            color: #333333;
                            line-height: 4.1vw;
                            margin: 3.2vw 0 0 0.5vw;
                            font-family: "FZLT-blackBold";
                        }
                        .address{
                            font-size: 3.2vw;
                            font-weight: normal;
                            color: #666666;
                            line-height: 3.6vw;
                            margin-top: 1.2vw;
                        }
                    }
                    
                }
                .applet{
                    margin-top: 5.7vw;
                    width: 90.7vw;
                    height: 44.3vw;
                    img{
                        width: 100%;
                    }
                }
            }
            .page9{
                margin-top: 5.2vw;
                padding: 0 4.5vw;
                .swiper-container{
                    margin-top: -0.5vw;
                    // height: 66.1vw;
                    height: 92.2vw;
                    padding-top: 5.6vw;
                    .swiper-wrapper{
                        display: flex;
                        height: 100%;
                        align-items: flex-end;
                        .swiper-slide{
                            position: relative;
                            width: 56.6vw !important;
                            // height: 43.7vw !important;
                            .guest1-one{
                                position: absolute;
                                // left: 0;
                                left: 50%;
                                transform: translateX(-50%);
                                bottom: 0;
                                width: 56.6vw;
                                z-index: 2;
                                height: 80vw;
                                background: rgba(255, 255, 255, 0.7);
                                border-radius: 0.3vw;
                                padding: 5.3vw 0 0 2.7vw;
                                .bg-img{
                                    position: absolute;
                                    top:2.9vw;right: 0;
                                    width: 22.7vw;
                                    height: 23.7vw;
                                    z-index: -1;
                                    img{
                                        width: 100%;
                                        vertical-align: top;
                                    }
                                }
                                .name{
                                    width: 13.2vw;
                                    text-align: left;
                                    font-size: 4vw;
                                    font-family: "FZLT-blackLittle";
                                    color: #333333;
                                    line-height: 4.4vw;
                                    margin-bottom: 0.5vw;
                                    text-align: justify;
                                    text-align-last: justify;
                                    word-break: break-all;
                                    text-justify: distribute;
                                }
                                .text{
                                    width: 50vw;
                                    text-align: left;
                                    font-size: 3.4vw;
                                    color: #666;
                                    line-height: 4.6vw;
                                    margin-top: 1.5vw;
                                    overflow: hidden;
                                    text-overflow :ellipsis; 
                                    // white-space: nowrap;
                                }
                                .people-img{
                                    position: absolute;
                                    bottom: 0;
                                    right: .1vw;
                                    width: 56.6vw;
                                    // height: 26vw;
                                    height: 61.16vw;
                                    overflow: hidden;
                                    display: flex;
                                    justify-content: center;
                                    align-items: flex-start;
                                    img{
                                        vertical-align: top;
                                        // width: 100%;
                                        height: 100%;
                                    }
                                }
                            }
                            .guest1-two{
                                display: none;
                                position: absolute;
                                bottom: 0;
                                left: 50%;
                                transform: translateX(-50%);
                                width: 38.4vw;
                                z-index: 2;
                                height: 60.5vw;
                                background: #FFFFFF;
                                border-radius: 0.3vw;
                                padding: 5.1vw 0 0 5.3vw;
                                .bg-img{
                                    position: absolute;
                                    top:11.6vw;right: 0;
                                    width: 32.1vw;
                                    height: 48.9vw;
                                    z-index: -1;
                                    img{
                                        width: 100%;
                                        vertical-align: top;
                                    }
                                }
                                .name{
                                    width: 11.5vw;
                                    text-align: left;
                                    font-size: 3.7vw;
                                    font-family: "FZLT-blackLittle";
                                    color: #333333;
                                    line-height: 4.4vw;
                                    margin-bottom: 1.9vw;
                                    text-align: justify;
                                    text-align-last: justify;
                                    word-break: break-all;
                                    text-justify: distribute;
                                }
                                .text{
                                    width: 27.5vw;
                                    text-align: left;
                                    font-size: 3.2vw;
                                    color: #666;
                                    line-height: 3.7vw;
                                    overflow: hidden;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 3;
                                    -webkit-box-orient: vertical;
                                    text-overflow :ellipsis; 
                                }
                                .people-img{
                                    position: absolute;
                                    bottom: 0;
                                    right: 1.5vw;
                                    width: 34.8vw;
                                    height: 37.2vw;
                                    overflow: hidden;
                                    display: flex;
                                    justify-content: center;
                                    align-items: flex-start;
                                    img{
                                        vertical-align: top;
                                        // width: 100%;
                                        height: 100%;
                                    }
                                }
                            }
                        }
                        .swiper-slide-active{
                            // width: 38.4vw !important;
                            // height: 60.5vw !important;
                            // .guest1-one{display: none;}
                            // .guest1-two{display: block;}
                        }
                        .swiper-slide-next{
                            // .guest1-one{
                            //     left: auto;
                            //     right: 0;
                            // }
                        }
                    }
                    .swiper-button-next,.swiper-button-prev{
                        top: 0;
                        left: 87.2vw;
                        width: 3.7vw;
                        height: 3.9vw;
                        background: #C50819;
                        &::after{
                            content:''
                        }
                        img{
                            width: 1.9vw;
                            height: 1.5vw;
                        }
                    }
                    .swiper-button-prev{
                        left: 81.8vw;
                    }
                    .swiper-button-disabled{
                        opacity: 1;
                        background: #C5C5C5;
                    }
                }
                .more{
                    margin-top: 5.1vw;
                }
            }
            .page11{
                margin-top: 7.3vw;
                padding: 0 4.7vw;
                .hot-top-button{
                    margin: -3.2vw 0 2vw;
                    display: flex;
                    justify-content: flex-end;
                    .hot-left,.hot-right{
                        width: 3.7vw;
                        height: 3.9vw;
                        background: #C5C5C5;
                        margin-left: 1.7vw;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        img{
                            width: 1.9vw;
                            height: 1.5vw;
                        }
                    }
                    .hot-left-active,.hot-right-active{
                        background: #C50819;
                    }
                }
                .page11-main{
                    height: 60vw;
                    width: 95.3vw;
                    overflow-x: scroll;
                    &::-webkit-scrollbar{
                        height: 0;
                    }
                    .page11-content{
                        width: auto;
                        height: 100%;
                        display: flex;
                        // margin-left: -10vw;
                        .left{
                            height: 100%;
                            margin-right: 2.7vw;
                            img{
                                vertical-align: top;
                                height: 100%;
                            }
                        }
                        .right{
                            .right-top{
                                display: flex;
                                height: 27.1vw;
                                margin-bottom: 2.9vw;
                                &:nth-child(2){
                                    margin-bottom: 0;
                                    height: 30vw;
                                }
                                img{
                                    vertical-align: top;
                                    height: 100%;
                                    margin-right: 2.7vw;
                                }
                            }
                        }
                    }
                }
            }
            .page12{
                margin-top: 5.7vw;
                padding: 0 4.7vw;
                position: relative;
                z-index: 2;
                .page12-icon{
                    position: absolute;
                    top:-2.9vw;right: 0;
                    width: 20.5vw;
                    height: 34.8vw;
                    z-index: -1;
                    img{
                        vertical-align: top;
                        width: 100%;
                    }
                }
                .swiper-container{
                    margin-top: -4.6vw;
                    height: 77.5vw;
                    padding-top: 7.2vw;
                    .swiper-wrapper{
                        display: flex;
                        height: 100%;
                        align-items: flex-end;
                        .swiper-slide{
                            width: 90.7vw;
                            height: 70.3vw;
                            position: relative;
                            z-index: 3;
                            background: url(../assets/newImages/home/guest/twins-wap-bg.png) center center/cover no-repeat;
                            display: flex;
                            align-items: center;
                            .people-div{
                                position: relative;
                                width: 33.6vw;
                                height: 35.9vw;
                                .img{
                                    position: absolute;
                                    left: 0;
                                    bottom: 0;
                                    width: 29.5vw;
                                    height: 12.1vw;
                                    img{
                                        width: 100%;
                                        height: 100%;
                                        vertical-align: top;
                                    }
                                }
                                .people-img{
                                    width: 33.6vw;
                                    height: 35.9vw;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    img{
                                        height: 100%;
                                        vertical-align: top;
                                    }
                                }
                            }
                            .name-div{
                                margin-left: 0.8vw;
                                width: 50.9vw;
                                padding-top: 6vw;
                                .name{
                                    font-family: "FZLT-blackBold";
                                    font-size: 3.7vw;
                                    color: #111111;
                                    line-height: 4.4vw;
                                }
                                .post{
                                    width: 51vw;
                                    margin: 1.1vw 0 2vw;
                                    font-size: 2.4vw;
                                    color: #999999;
                                    line-height: 3.2vw;
                                    overflow: hidden;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 3;
                                    -webkit-box-orient: vertical;
                                    text-overflow :ellipsis;
                                }
                                .show{
                                    width: 100%;
                                    height: auto;
                                    position: relative;
                                    .show-img{
                                        position: absolute;
                                        top: 0;
                                        left: 0;
                                        width: 2.1vw;
                                        height: 2.3vw;
                                        img{
                                            width: 100%;
                                            height: 100%;
                                            vertical-align: top;
                                        }
                                    }
                                    .detail{
                                        font-size: 2.4vw;
                                        color: #666;
                                        line-height: 3.6vw;
                                        text-align: justify;
                                        text-indent: 3.5vw;
                                    }
                                }
                            }
                        }
                    }
                    .swiper-button-next,.swiper-button-prev{
                        top: 0;
                        left: 84.7vw;
                        width: 3.7vw;
                        height: 3.9vw;
                        background: #C50819;
                        &::after{
                            content:''
                        }
                        img{
                            width: 1.9vw;
                            height: 1.5vw;
                        }
                    }
                    .swiper-button-prev{
                        left: 79.3vw;
                    }
                    .swiper-button-disabled{
                        opacity: 1;
                        background: #C5C5C5;
                    }
                }
            }
            .page13{
                margin-top: 6vw;
                padding: 0 4.7vw;
                position: relative;
                z-index: 2;
                .page13-icon{
                    position: absolute;
                    right: 0;
                    bottom: 11.8vw;
                    width: 13.6vw;
                    height: 22vw;
                    z-index: -1;
                    img{
                        vertical-align: top;
                        width: 100%;
                    }
                }
                .files-content{
                    margin-top: 3.1vw;
                    width: 90.7vw;
                    height: auto;
                    position: relative;
                    z-index: 2;
                    padding-top: 8vw;
                    .files-three{
                        position: absolute;
                        top:0;
                        left: 0;
                        width: 100%;
                        height: 10.7vw;
                        display: flex;
                        background: #FFFFFF;
                        box-shadow: 0 0.3vw 0.7vw 0 rgba(234,234,234,0.5);
                        border-radius: 2px 5.5vw;
                        .files-three-one{
                            width: 30.2vw;
                            position: relative;
                            height: 100%;
                            cursor: pointer;
                            &:last-child{
                                .right-line{display: none;}
                            }
                            &:hover{
                                p{color: #C50819;}
                                .line{display: block;}
                            }
                            .right-line{
                                position: absolute;
                                top:50%;
                                right: 0;
                                transform: translateY(-50%);
                                width: 0.2vw;
                                height: 4.5vw;
                                background: #949494;
                            }
                            .line{
                                display: none;
                                position: absolute;
                                bottom: 0;
                                left: 50%;
                                transform: translateX(-50%);
                                width: 4.5vw;
                                height: 0.7vw;
                                background: #C50819;
                            }
                            p{
                                font-size: 4vw;
                                color: #333333;
                                font-family: "FZLT-blackLittle";
                                line-height: 4.6vw;
                                text-shadow: 0 0.3vw 0.7vw rgba(234, 234, 234, 0.5);
                            }
                        }
                        .files-one-active{
                            p{color: #C50819;}
                            .line{display: block;}
                        }
                    }
                    .files-list{
                        width: 100%;
                        height: auto;
                        padding: 6.7vw 0 5.1vw;
                        box-shadow: 0px 0px 2.7vw 0px rgba(231,231,231,0.5);
                        border-radius: 0.3vw;
                        background: rgba(255,255,255,0.9);
                        .files-nav{
                            width: 100%;
                            height: 7vw;
                            display: flex;
                            padding-left: 8vw;
                            border-bottom: 0.3vw solid #D8D8D8;
                            .files-nav-one{
                                width: 18vw;
                                height: 7vw;
                                font-size: 3.7vw;
                                line-height: 4.3vw;
                                text-align: center;
                                color: #333;
                                margin-right: 10.3vw;
                                cursor: pointer;
                                &:hover{
                                    color: #C50819;
                                    font-family: "FZLT-blackBold";
                                    border-bottom: 0.4vw solid #C50819;
                                }
                            }
                            .files-nav-one-active{
                                color: #C50819;
                                font-family: "FZLT-blackBold";
                                border-bottom: 0.4vw solid #C50819;
                            }
                        }
                        .files-main1{
                            width: 100%;
                            height: auto;
                            padding: 0 4vw 0 4vw;
                            display: flex;
                            text-align: left;
                            .files-main1-content{
                                width: 100%;
                                height: auto;
                                .filesTwo-one{
                                    width: 100%;
                                    padding-top: 6.1vw;
                                    height: auto;
                                    cursor: pointer;
                                    margin-bottom: 0.5vw;
                                    .title{
                                        display: flex;
                                        align-items: center;
                                        justify-content: space-between;
                                        cursor: pointer;
                                        padding: 0 0 3vw 2.1vw;
                                        .title-left{
                                            position: relative;
                                            .line{
                                                position: absolute;
                                                top:50%;
                                                left: -2.2vw;
                                                transform: translateY(-50%);
                                                width: 0.6vw;
                                                height: 3.2vw;
                                                background: #C50819;
                                                border-radius: 0.4vw;
                                            }
                                            p{
                                                width: 75vw;
                                                font-size: 3.2vw;
                                                color: #333333;
                                                font-family: "FZLT-blackLittle";
                                                text-overflow :ellipsis; 
                                                white-space: nowrap; 
                                                overflow: hidden;
                                                line-height: 3.7vw;
                                            }
                                        }
                                        .right-icon{
                                            width: 4.2vw;
                                            height: 2.1vw;
                                            transform: rotate(180deg);
                                            img{
                                                vertical-align: top;
                                                width: 100%;
                                            }
                                        }
                                        .right-icon-bottom{
                                            transform: rotate(0deg);
                                        }
                                    }
                                    .title-active{
                                        padding-bottom: 0;
                                        border-bottom:none;
                                    }
                                    .filesTwo-one-main{
                                        display: none;
                                        width: 100%;
                                        height: auto;
                                        .filesTwo-oneItem{
                                            width: 100%;
                                            height: auto;
                                            padding: 3.9vw 0 4.8vw;
                                            border-bottom: 0.1vw solid #EEEEE0;
                                            .left-one{
                                                display: flex;
                                                padding-left: 1.2vw;
                                                .left-img{
                                                    width: 4.4vw;
                                                    height: 4.7vw;
                                                    margin-right: 4.7vw;
                                                    // margin: 0.7vw 4.7vw 0 0;
                                                    img{
                                                        width: 100%;
                                                        vertical-align: top;
                                                    }
                                                }
                                                p{
                                                    width: 68.8vw;
                                                    font-size: 3.5vw;
                                                    color: #333333;
                                                    line-height: 4.8vw;
                                                }
                                            }
                                            .right-one{
                                                display: flex;
                                                align-items: center;
                                                margin-top: 3vw;
                                                padding-left: 10vw;
                                                .loading-div{
                                                    width: 20vw;
                                                    margin-right: 1.3vw;
                                                    display: flex;
                                                    align-items: center;
                                                    cursor: pointer;
                                                    .img{
                                                        width: 3.6vw;
                                                        height: 3.3vw;
                                                        margin:-0.3vw 1.5vw 0 0;
                                                        &:nth-child(2){
                                                            display: none;
                                                        }
                                                        img{
                                                            vertical-align: top;
                                                            width: 100%;
                                                            
                                                        }
                                                    }
                                                    p{
                                                        font-size: 3.2vw;
                                                        color: #666666;
                                                        line-height: 3.6vw;
                                                    }
                                                }
                                                .loading-div2{
                                                    .img{
                                                        width: 4.4vw;
                                                        height: 3.3vw;
                                                    }
                                                }
                                                .loading-div-active{
                                                    .img{
                                                        display: none;
                                                        &:nth-child(2){display: block;}
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    .filesTwo-one-main-active{
                                        display: block;
                                    }
                                }
                            }
                        }
                        .files-main2{
                            height: auto;
                            .files-main1-content{
                                height: auto;
                                .left-img{
                                    width: 5.2vw !important;
                                    height: 4.1vw !important;
                                    img{
                                        width: 100%;
                                        vertical-align: top;
                                    }
                                }
                            }
                        }
                        .files-main3{
                            height: auto;
                            .files-main1-content{
                                height: auto;
                                .left-img{
                                    width: 5.2vw !important;
                                    height: 4.1vw !important;
                                    margin-right: 4.7vw;
                                    img{
                                        width: 100%;
                                        vertical-align: top;
                                    }
                                }
                            }
                        }
                    }
                }
                .more{
                    margin-top: 3.7vw;
                }
            }
        }
        .footer{
            width: 100vw;
            height: 45.3vw;
            background: #F4F4F4;
            position: relative;
            z-index: 2;
            border-radius: 1px;
            padding: 0 4vw;
            // margin-top: 15vw;
            text-align: center;
            .ticket{
                border-bottom: 1px solid #DDDDDD;
                height: 20.5vw;
                padding-top: 5.6vw;
                p{
                    font-size: 2.4vw;
                    font-weight: normal;
                    color: #666666;
                    line-height: 4vw;
                    text-align: center;
                    &:nth-child(1){
                        font-size: 2.8vw;
                        font-weight: bold;
                        color: #333333;
                        line-height: 3.2vw;
                    }
                    &:nth-child(2){
                        margin-top: 1.6vw;
                    }
                }
            }
            .keep{
                padding-top: 3.2vw;
                p{
                    font-size: 2.8vw;
                    font-weight: normal;
                    color: #666666;
                    line-height: 3.2vw;
                    &:nth-child(2){
                        font-size: 2.4vw;
                        font-weight: normal;
                        color: #666666;
                        line-height: 4vw;
                        margin-top: 1.3vw;
                    }
                    &:nth-child(3){
                        font-size: 2.4vw;
                        font-weight: normal;
                        color: #999999;
                        line-height: 4vw;
                    }
                }
                .logos{
                    display: flex;
                    margin: 1.3vw auto;
                    padding-left: 35.1vw;
                    .img{
                        position: relative;
                        width: 6vw;
                        height: 6vw;
                        border-radius: 1vw;
                        border: 0.5vw solid #AAAAAA;
                        margin-right: 1.9vw;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        &:nth-child(2){
                            img{
                                width: 3.4vw;
                                height: 3.8vw;
                            }
                        }
                        &:nth-child(3){
                            margin-right: 0;
                            img{
                                width: 3.8vw;
                                height: 3.4vw;
                            }
                        }
                        img{
                            width: 4.1vw;
                            height: 3.1vw;
                            // &:nth-child(2){
                            //     width: 3.4vw;
                            //     height: 3.8vw;
                            // }
                            // &:nth-child(3){
                            //     width: 3.8vw;
                            //     height: 3.4vw;
                            // }
                        }
                    }
                }
            }
        }
        .page1-live{
            position: relative;
            z-index: 2;
            width: 100%;
            height: auto;
            padding: 9.7vw 0 4.3vw;
            background: #F4F7FB;
            .page-img1{
                z-index: -1;
                position: absolute;
                bottom: -2.4vw;right: 0;
                width: 44.8vw;
                height: 58.1vw;
                img{
                    width: 100%;
                    vertical-align: top;
                }
            }
            .page-img2{
                z-index: -1;
                position: absolute;
                top: 97.4vw;left: 0;
                width: 11.1vw;
                height: 13.3vw;
                img{
                    width: 100%;
                    vertical-align: top;
                }
            }
            .live-left{
                width: 100%;
                height: 68.7vw;
                .left-title{
                    width: 100%;
                    height: 12.4vw;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0 0 0 4.8vw;
                    background: #FFF;
                    border-radius: 0.3vw 0px 0.3vw 0px;
                    .one-left{
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        width: 72vw;
                        height: 12.4vw;
                        p{
                            width: 68vw;
                            font-size: 3.2vw;
                            height: 3.7vw;
                            color: #C50819;
                            font-family: "FZLT-blackLittle";
                            line-height: 3.7vw;
                            letter-spacing: 0.1vw;
                            text-align: left;
                            text-overflow :ellipsis; 
                            overflow: hidden;
                            white-space: nowrap;
                            margin-bottom: 1.1vw;
                            &:last-child{
                                margin-bottom: 0;
                            }
                            img{
                                width: 2.8vw;
                                height: 2.8vw;
                                vertical-align: top;
                                margin: 0.2vw 2.4vw 0 0;
                            } 
                            span{
                                font-size: 2.6vw;
                                line-height: 3.7vw;
                            }
                        }
                    }
                    .one-left2{
                        p{
                            span{
                                font-size: 3.2vw;
                                line-height: 3.7vw;
                            }
                        }
                    }
                    .one-right{
                        width: 23.2vw;
                        height: 12.4vw;
                        font-size: 2.7vw;
                        padding: 2.1vw 0;
                        color: #FFFFFF;
                        text-align: center;
                        line-height: 4vw;
                        background: #C50819;
                        border-radius: 0.2vw;
                    }
                }
                .left-video{
                    width: 100%;
                    height: 56.3vw;
                    background: url("../assets/newImages/home/live/like-bg.jpg") no-repeat center center/cover,#FFF;
                    video{
                        width: 100%;
                        vertical-align: top;
                    }
                }
            }
            .live-right{
                position: relative;
                width: 90.7vw;
                height: auto;
                margin: 0 auto;
                padding-top: 20.3vw;
                .live-right-top{
                    position: absolute;
                    z-index: 2;
                    top:0;
                    left: 0;
                    width: 90.7vw;
                    height: auto;
                    margin: 14.5vw auto 0;
                    background: #FFFFFF;
                    box-shadow:  0px 0.3vw 1.3vw 0px rgba(222,222,222,0.5);
                    border-radius: 0.3vw 5.5vw;
                    .img{
                        position: absolute;
                        left: 0;
                        top:-10.6vw;
                        width: 41.6vw;
                        height: 12.7vw;
                        img{
                            width: 100%;
                            vertical-align: top;
                        }
                    }
                    .text-div{
                        height: 11.5vw;
                        display: flex;
                        justify-content: space-between;
                        .text-date{
                            position: relative;
                            width: 45.4vw;
                            height: 11.5vw;
                            cursor: pointer;
                            &:nth-child(2){
                                .right-line{
                                    display: none;
                                }
                            }
                            p{
                                font-size: 4.6vw;
                                font-family: "ABlack";
                                font-weight: 900;
                                text-align: center;
                                color: #333333;
                                line-height: 11.5vw;
                            }
                            span{
                                display: none;
                                position: absolute;
                                bottom: 0;
                                left: 50%;
                                transform: translateX(-50%);
                                width: 4.3vw;
                                height: 0.4vw;
                                background: #C50819;
                            }
                            .right-line{
                                position: absolute;
                                top: 3.5vw;
                                right: 0;
                                width: 0.1vw;
                                height: 4.5vw;
                                background: #949494;
                                border-radius: 1px;
                            }
                        }
                        .text-active{
                            p{
                                color: #C50819;
                            }
                            span{
                                display: block;
                            }
                        }
                    }
                }
                .live-right-lists{
                    width: 100%;
                    height: auto;
                    padding: 7.5vw 3.5vw 5.3vw 3.5vw;
                    background: rgba($color: #FFF, $alpha: 0.7);
                    .live-right-lists-one{
                        width: 83.7vw;
                        height: auto;
                        .right-title{
                            width: 100%;
                            height: 12vw;
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            justify-content: space-between;
                            border-bottom: 0.1vw solid rgba($color: #ccc, $alpha: 0.5);
                            .title-left{
                                padding-left: 2vw;
                                position: relative;
                                height: 12vw;
                                display: flex;
                                align-items: center;
                                p{
                                    width: 75vw;
                                    text-align: left;
                                    font-size: 3.2vw;
                                    font-family: "FZLT-blackLittle";
                                    color: #333333;
                                    line-height: 12vw;
                                    text-overflow :ellipsis; 
                                    overflow: hidden;
                                    white-space: nowrap; 
                                }
                                .img{
                                    max-width: 75vw;
                                    margin: auto 0;
                                    height: 3.2vw;
                                    display: flex;
                                    align-items: center;
                                    img{
                                        height: 3.2vw;
                                        vertical-align: top;
                                        margin-top: 0.1vw;
                                    }
                                }
                                .left-right{
                                    position: absolute;
                                    left: 0;
                                    top: 4.4vw;
                                    width: 0.6vw;
                                    height: 3.2vw;
                                    background: #C50819;
                                }
                                .list-img{
                                    width: 13.5vw;
                                    height: 4.5vw;
                                    // margin-left: 2.5vw;
                                    .img1{
                                        width: 13.5vw;
                                        height: 4.5vw;
                                        img{
                                            width: 13.5vw;
                                            height: 4.5vw;
                                            vertical-align: top;
                                        }
                                    }
                                }
                            }
                            .title-img{
                                width: 4.2vw;
                                height: 2.1vw;
                                transform: rotate(180deg);
                                img{
                                    width: 100%;
                                    vertical-align: top;
                                }
                            }
                        }
                        .right-list{
                            display: none;
                            height: auto;
                            width: 100%;
                            padding: 4.3vw 0 0.9vw;
                            .right-list-one{
                                width: 100%;
                                height: auto;
                                text-align: left;
                                cursor: pointer;
                                padding: 0 3.1vw;
                                margin-bottom: 4.7vw;
                                .list-one-top{
                                    display: flex;
                                    .time{
                                        width: 20vw;
                                        height: 4.7vw;
                                        font-size: 3.7vw;
                                        font-family: "ABlack";
                                        font-weight: 900;
                                        color: #666666;
                                        line-height: 4.7vw;
                                    }
                                    .list-img{
                                        width: 13.5vw;
                                        height: 4.5vw;
                                        .img1{
                                            width: 13.5vw;
                                            height: 4.5vw;
                                            img{
                                                width: 13.5vw;
                                                height: 4.5vw;
                                                vertical-align: top;
                                            }
                                        }
                                    }
                                }
                                .list-one-title{
                                    width: 100%;
                                    margin-top: 1.2vw;
                                    font-size: 3.5vw;
                                    color: #333333;
                                    line-height: 4.6vw;
                                }
                            }
                            .right-list-one-active{
                                .list-one-top{
                                    .time{color: #C50819;}
                                }
                                .list-one-title{color: #C50819;}
                            }
                        }
                    }
                    .live-right-lists-active{
                        border-bottom: 1px solid rgba($color: #ccc, $alpha: 0.5);
                        .right-title{
                            .title-left{
                                p{
                                    color: #C50819;
                                }
                            }
                            .title-img{
                                transform: rotate(0deg);
                            }
                        }
                        .right-list{
                            display: block;
                        }
                    }
                }
            }
        }
    }
}
@media screen and (max-height:960px) {
.pc {
    .con-page8{
        .con-1200{
            margin-top: 4vh !important;
            .con-main{
                margin: pxToVw(8) 0 0 pxToVw(102);
                .image{
                    width: pxToVw(966);
                    height: pxToVw(401);
                    background: url("../assets/newImages/home/page8-map11.jpg")no-repeat center center/cover;
                }
                .more{
                    width: pxToVw(1194) !important;//1600宽度
                    margin: 3vh 0 !important;
                }
                .applet{
                    width: pxToVw(1008);//1350宽度
                    height: pxToVw(114);
                    margin: 0.5vh auto 0;
                }
            }
            
        }
        .more{
            margin-top: 0.5vh !important;
        }
    }
}
}
@media screen and (max-height:880px) {
.pc {
    .con-page8{
        .con-1200{
            margin-top: 4vh !important;
            .con-main{
                margin: pxToVw(8) 0 0 pxToVw(102);
                .image{
                    width: pxToVw(966);
                    height: pxToVw(401);
                    background: url("../assets/newImages/home/page8-map11.jpg")no-repeat center center/cover;
                }
                .more{
                    width: pxToVw(1194) !important;//1600宽度
                    margin: 2vh 0 !important;
                }
                .applet{
                    width: pxToVw(1008);//1350宽度
                    height: pxToVw(114);
                    margin: 0.5vh auto 0;
                }
            }
            
        }
        .more{
            margin-top: 0.5vh !important;
        }
    }
}
}
@media screen and (max-height:860px) {
.pc {
    .con-page8{
        .con-1200{
            margin-top: 4vh !important;
            .con-main{
                margin: pxToVw(8) 0 0 pxToVw(102);
                .image{
                    width: pxToVw(966);
                    height: pxToVw(401);
                    background: url("../assets/newImages/home/page8-map11.jpg")no-repeat center center/cover;
                }
                .more{
                    width: pxToVw(1194) !important;//1600宽度
                    margin: 1vh 0 !important;
                }
                .applet{
                    width: pxToVw(1008);//1350宽度
                    height: pxToVw(114);
                    margin: 0.5vh auto 0;
                }
            }
            
        }
        .more{
            margin-top: 0.2vh !important;
        }
    }
}
}
@media screen and (max-height:830px) {
.pc {
    .con-page8{
        .con-1200{
            margin-top: 4vh !important;
            .con-main{
                margin: pxToVw(8) 0 0 pxToVw(102);
                .image{
                    width: pxToVw(966);
                    height: pxToVw(401);
                    background: url("../assets/newImages/home/page8-map11.jpg")no-repeat center center/cover;
                }
                .more{
                    width: pxToVw(1194) !important;//1600宽度
                    margin: .4vh 0 !important;
                }
                .applet{
                    width: pxToVw(1008);//1350宽度
                    height: pxToVw(114);
                    margin: 0.2vh auto 0;
                }
            }
            
        }
        .more{
            margin-top: 0.2vh !important;
        }
    }
}
}
</style>